var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4648_14127)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.75,
    height: 34.6087,
    transform: "translate(0.625 0.905029)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4338 19.5504C27.1948 19.5504 26.9736 19.6081 26.7684 19.7233C26.5633 19.8386 26.4072 19.9917 26.3001 20.1828C26.1884 19.9801 26.0318 19.8239 25.8287 19.7142C25.6256 19.6045 25.3952 19.5499 25.1366 19.5499C24.9335 19.5499 24.7475 19.5899 24.5788 19.6692C24.4095 19.7491 24.2716 19.8583 24.164 19.9978V19.598H23.3289V22.9054H24.164V21.0786C24.164 20.8197 24.2307 20.6216 24.3641 20.4846C24.4974 20.3471 24.6793 20.2789 24.9102 20.2789C25.1411 20.2789 25.3159 20.3476 25.4473 20.4846C25.5786 20.6221 25.6443 20.8197 25.6443 21.0786V22.9054H26.4794V21.0786C26.4794 20.8197 26.5461 20.6216 26.6795 20.4846C26.8129 20.3471 26.9927 20.2789 27.2196 20.2789C27.4464 20.2789 27.6253 20.3476 27.7566 20.4846C27.888 20.6216 27.9537 20.8197 27.9537 21.0786V22.9054H28.7888V20.9653C28.7888 20.5195 28.6645 20.1722 28.416 19.9235C28.1674 19.6748 27.84 19.5504 27.4343 19.5504H27.4338Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3991 19.5505C35.1919 19.5505 35.0025 19.5915 34.8292 19.6729C34.6559 19.7543 34.5139 19.867 34.4028 20.01V19.5981H33.5676V22.9056H34.4028V21.0787C34.4028 20.8158 34.4695 20.6141 34.6028 20.4726C34.7362 20.3315 34.9181 20.2608 35.149 20.2608C35.3799 20.2608 35.5547 20.3315 35.686 20.4726C35.8174 20.6141 35.8831 20.8158 35.8831 21.0787V22.9056H36.7182V20.9654C36.7182 20.5196 36.597 20.1723 36.3544 19.9236C36.1119 19.6749 35.7936 19.5505 35.3996 19.5505H35.3991Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7795 21.9087L41.9262 19.5985H40.9895L42.3142 22.8221L41.5983 24.4695H42.4875L44.5337 19.5985H43.645L42.7795 21.9087Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0279 19.7567C31.7693 19.6157 31.4808 19.5449 31.163 19.5449C30.8452 19.5449 30.5562 19.6157 30.2975 19.7567C30.0389 19.8978 29.8353 20.0979 29.6862 20.3568C29.5372 20.6156 29.4624 20.9138 29.4624 21.252C29.4624 21.5902 29.5352 21.8889 29.6802 22.1472C29.8252 22.4061 30.0252 22.6057 30.2799 22.7473C30.5345 22.8888 30.8209 22.9591 31.1392 22.9591C31.4575 22.9591 31.7526 22.8883 32.0133 22.7473C32.274 22.6062 32.4806 22.4061 32.6337 22.1472C32.7868 21.8884 32.8636 21.5902 32.8636 21.252C32.8636 20.9138 32.7888 20.6151 32.6398 20.3568C32.4907 20.0979 32.2866 19.8983 32.0284 19.7567H32.0279ZM31.885 21.7894C31.8051 21.9365 31.699 22.0472 31.5657 22.1205C31.4323 22.1943 31.2903 22.2307 31.1392 22.2307C30.9008 22.2307 30.7027 22.1462 30.5456 21.9769C30.3885 21.8076 30.3097 21.5659 30.3097 21.2515C30.3097 20.9371 30.3905 20.6954 30.5512 20.5261C30.7123 20.3568 30.9124 20.2723 31.1509 20.2723C31.3893 20.2723 31.5914 20.3568 31.7566 20.5261C31.9218 20.6954 32.0042 20.9371 32.0042 21.2515C32.0042 21.4623 31.9643 21.6417 31.885 21.7888V21.7894Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8886 19.7476C39.64 19.6122 39.3586 19.5449 39.0444 19.5449C38.7301 19.5449 38.43 19.6147 38.1794 19.7537C37.9288 19.8932 37.7338 20.0919 37.5949 20.3507C37.4554 20.6095 37.3862 20.9098 37.3862 21.252C37.3862 21.5942 37.457 21.8889 37.5979 22.1472C37.7389 22.4061 37.9359 22.6057 38.1885 22.7473C38.4411 22.8888 38.7266 22.9591 39.0449 22.9591C39.4385 22.9591 39.7709 22.8565 40.0412 22.6517C40.3115 22.447 40.4949 22.1852 40.5899 21.8667H39.689C39.5577 22.1336 39.3369 22.2665 39.0267 22.2665C38.812 22.2665 38.6306 22.1988 38.4836 22.0638C38.3366 21.9284 38.2527 21.7413 38.233 21.5027H40.6495C40.6651 21.4072 40.6732 21.3 40.6732 21.1802C40.6732 20.8577 40.6045 20.5721 40.4676 20.3234C40.3302 20.0747 40.1372 19.8826 39.8891 19.7471L39.8886 19.7476ZM38.239 20.9416C38.2709 20.7187 38.3573 20.5448 38.4987 20.4194C38.6397 20.2941 38.814 20.2314 39.0206 20.2314C39.2394 20.2314 39.4243 20.2961 39.5754 20.4255C39.7264 20.5549 39.8042 20.7268 39.8083 20.9421H38.239V20.9416Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4338 25.7949C27.1948 25.7949 26.9736 25.8526 26.7684 25.9678C26.5633 26.0831 26.4072 26.2362 26.3001 26.4273C26.1884 26.2246 26.0318 26.0684 25.8287 25.9587C25.6256 25.849 25.3952 25.7944 25.1366 25.7944C24.9335 25.7944 24.7475 25.8344 24.5788 25.9137C24.4095 25.9936 24.2716 26.1028 24.164 26.2423V25.8425H23.3289V29.15H24.164V27.3231C24.164 27.0643 24.2307 26.8661 24.3641 26.7291C24.4974 26.5916 24.6793 26.5234 24.9102 26.5234C25.1411 26.5234 25.3159 26.5921 25.4473 26.7291C25.5786 26.8666 25.6443 27.0643 25.6443 27.3231V29.15H26.4794V27.3231C26.4794 27.0643 26.5461 26.8661 26.6795 26.7291C26.8129 26.5916 26.9927 26.5234 27.2196 26.5234C27.4464 26.5234 27.6253 26.5921 27.7566 26.7291C27.888 26.8666 27.9537 27.0643 27.9537 27.3231V29.15H28.7888V27.2098C28.7888 26.764 28.6645 26.4167 28.416 26.168C28.1674 25.9193 27.84 25.7949 27.4343 25.7949H27.4338Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.837 25.8429H35.7508L34.6413 27.2457V24.7323H33.8057V29.1499H34.6413V27.741L35.7629 29.1499H36.8486L35.381 27.5025L36.837 25.8429Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8036 24.4695C37.6566 24.4695 37.5338 24.5165 37.4368 24.6095C37.3393 24.703 37.2908 24.8193 37.2908 24.9588C37.2908 25.0983 37.3393 25.2146 37.4368 25.3081C37.5343 25.4016 37.6566 25.4486 37.8036 25.4486C37.9506 25.4486 38.0729 25.4016 38.1704 25.3081C38.2679 25.2146 38.3164 25.0983 38.3164 24.9588C38.3164 24.8193 38.2674 24.703 38.1704 24.6095C38.0729 24.516 37.9506 24.4695 37.8036 24.4695Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2148 25.8429H37.3796V29.1504H38.2148V25.8429Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9601 25.7949C40.7535 25.7949 40.5635 25.8359 40.3902 25.9173C40.2174 25.9986 40.0749 26.1114 39.9638 26.2544V25.8424H39.1287V29.1499H39.9638V27.3231C39.9638 27.0602 40.0305 26.8585 40.1639 26.717C40.2972 26.5759 40.4791 26.5052 40.71 26.5052C40.9409 26.5052 41.1157 26.5759 41.2471 26.717C41.3784 26.8585 41.4441 27.0602 41.4441 27.3231V29.1499H42.2792V27.2098C42.2792 26.764 42.158 26.4167 41.9155 26.168C41.673 25.9193 41.3547 25.7949 40.9606 25.7949H40.9601Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0577 26.3145C31.9461 26.1634 31.798 26.038 31.6131 25.9384C31.4282 25.8388 31.2125 25.7893 30.9659 25.7893C30.6835 25.7893 30.4279 25.8591 30.199 25.9981C29.9701 26.1376 29.7893 26.3363 29.6559 26.5951C29.5225 26.8539 29.4558 27.1501 29.4558 27.4848C29.4558 27.8194 29.5225 28.1227 29.6559 28.383C29.7893 28.6439 29.9701 28.8456 30.199 28.9891C30.4279 29.1327 30.6815 29.204 30.9599 29.204C31.2064 29.204 31.4242 29.1534 31.6131 29.0518C31.8021 28.9502 31.9501 28.8218 32.0577 28.6666V29.1504H32.8989V25.8429H32.0577V26.3145ZM31.9385 28.0186C31.8587 28.1637 31.7515 28.2754 31.6161 28.3527C31.4807 28.4306 31.3357 28.469 31.1806 28.469C31.0255 28.469 30.8871 28.4295 30.7542 28.3497C30.6209 28.2703 30.5137 28.1556 30.4319 28.0064C30.3501 27.8573 30.3096 27.6829 30.3096 27.4843C30.3096 27.2856 30.3506 27.1132 30.4319 26.9676C30.5132 26.8226 30.6198 26.7118 30.7512 26.636C30.8826 26.5602 31.0255 26.5223 31.1806 26.5223C31.3357 26.5223 31.4807 26.5612 31.6161 26.6386C31.7515 26.7159 31.8587 26.8276 31.9385 26.9727C32.0178 27.1183 32.0577 27.2922 32.0577 27.4949C32.0577 27.6976 32.0178 27.872 31.9385 28.0171V28.0186Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5482 26.3145C45.4406 26.1593 45.2936 26.033 45.1066 25.9354C44.9197 25.8378 44.703 25.7893 44.4564 25.7893C44.174 25.7893 43.9183 25.8591 43.6895 25.9981C43.4606 26.1376 43.2797 26.3363 43.1464 26.5951C43.013 26.8539 42.9463 27.1501 42.9463 27.4848C42.9463 27.8194 43.013 28.1227 43.1464 28.383C43.2797 28.6439 43.4616 28.8456 43.6925 28.9891C43.9229 29.1327 44.1775 29.204 44.4564 29.204C44.6989 29.204 44.9146 29.1524 45.1036 29.0488C45.2926 28.9452 45.4406 28.8157 45.5482 28.6606V29.1741C45.5482 29.4689 45.4724 29.6882 45.3214 29.8338C45.1703 29.9789 44.9733 30.0517 44.7307 30.0517C44.5236 30.0517 44.3478 30.0067 44.2028 29.9172C44.0573 29.8278 43.9633 29.7075 43.9194 29.5563H43.0903C43.1302 29.9344 43.2999 30.2327 43.6006 30.4516C43.9007 30.6704 44.2856 30.7801 44.755 30.7801C45.1051 30.7801 45.4032 30.7094 45.6497 30.5683C45.8963 30.4268 46.0812 30.2357 46.2045 29.9951C46.3278 29.7545 46.3894 29.4805 46.3894 29.1741V25.8429H45.5482V26.3145ZM45.429 28.0186C45.3491 28.1636 45.242 28.2754 45.1066 28.3527C44.9712 28.4306 44.8262 28.469 44.6711 28.469C44.516 28.469 44.3776 28.4295 44.2447 28.3497C44.1113 28.2703 44.0042 28.1556 43.9224 28.0064C43.8405 27.8573 43.8001 27.6829 43.8001 27.4843C43.8001 27.2856 43.841 27.1132 43.9224 26.9676C44.0037 26.8226 44.1103 26.7118 44.2417 26.636C44.373 26.5602 44.516 26.5223 44.6711 26.5223C44.8262 26.5223 44.9712 26.5612 45.1066 26.6386C45.242 26.7159 45.3491 26.8276 45.429 26.9727C45.5083 27.1183 45.5482 27.2922 45.5482 27.4949C45.5482 27.6976 45.5083 27.872 45.429 28.0171V28.0186Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4338 32.1051C27.1953 32.1051 26.9736 32.1627 26.7684 32.278C26.5633 32.3933 26.4077 32.5464 26.3001 32.7375C26.1884 32.5348 26.0313 32.3786 25.8287 32.2689C25.6256 32.1592 25.3952 32.1046 25.1366 32.1046C24.934 32.1046 24.7475 32.1445 24.5788 32.2239C24.4095 32.3038 24.2716 32.413 24.164 32.5525V32.1526H23.3289V35.4601H24.164V33.6333C24.164 33.3744 24.2307 33.1763 24.3641 33.0393C24.4974 32.9018 24.6793 32.8335 24.9102 32.8335C25.1411 32.8335 25.3159 32.9023 25.4473 33.0393C25.5786 33.1768 25.6443 33.3744 25.6443 33.6333V35.4601H26.4794V33.6333C26.4794 33.3744 26.5461 33.1763 26.6795 33.0393C26.8129 32.9018 26.9927 32.8335 27.2196 32.8335C27.4464 32.8335 27.6253 32.9023 27.7566 33.0393C27.888 33.1768 27.9537 33.3744 27.9537 33.6333V35.4601H28.7888V33.52C28.7888 33.0742 28.6645 32.7269 28.416 32.4782C28.1674 32.2295 27.84 32.1051 27.4343 32.1051H27.4338Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2199 32.8097C35.3872 32.8097 35.5271 32.8507 35.6408 32.9321C35.754 33.0135 35.8348 33.1262 35.8823 33.2692H36.7831C36.6916 32.8992 36.5118 32.6116 36.243 32.4063C35.9742 32.2016 35.6352 32.099 35.2255 32.099C34.9072 32.099 34.6248 32.1698 34.3782 32.3108C34.1317 32.4518 33.9387 32.651 33.7992 32.9078C33.6598 33.1646 33.5906 33.4639 33.5906 33.8061C33.5906 34.1483 33.6603 34.4481 33.7992 34.7044C33.9387 34.9611 34.1312 35.1603 34.3782 35.3014C34.6248 35.4429 34.9072 35.5132 35.2255 35.5132C35.6312 35.5132 35.9692 35.4075 36.24 35.1967C36.5103 34.9859 36.6911 34.7013 36.7831 34.3429H35.8823C35.7787 34.6452 35.5579 34.7964 35.2199 34.7964C34.9815 34.7964 34.7925 34.7099 34.6531 34.5365C34.5136 34.3631 34.4444 34.1195 34.4444 33.8051C34.4444 33.4906 34.5141 33.2409 34.6531 33.068C34.7925 32.8947 34.9815 32.8082 35.2199 32.8082V32.8097Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.017 32.2694C39.8219 32.1597 39.5991 32.1051 39.3486 32.1051C39.1298 32.1051 38.9307 32.146 38.7519 32.2274C38.573 32.3088 38.4296 32.4215 38.3224 32.5646V31.042H37.4873V35.4596H38.3224V33.6327C38.3224 33.3698 38.3891 33.1681 38.5225 33.0266C38.6559 32.8856 38.8378 32.8148 39.0687 32.8148C39.2995 32.8148 39.4744 32.8856 39.6057 33.0266C39.7371 33.1681 39.8028 33.3698 39.8028 33.6327V35.4596H40.6379V33.5195C40.6379 33.2207 40.5833 32.9654 40.4737 32.7521C40.3641 32.5393 40.212 32.378 40.017 32.2683V32.2694Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9444 30.7797C41.7974 30.7797 41.6747 30.8267 41.5777 30.9197C41.4801 31.0132 41.4316 31.1295 41.4316 31.269C41.4316 31.4085 41.4801 31.5248 41.5777 31.6183C41.6752 31.7118 41.7974 31.7588 41.9444 31.7588C42.0915 31.7588 42.2137 31.7118 42.3112 31.6183C42.4087 31.5248 42.4572 31.4085 42.4572 31.269C42.4572 31.1295 42.4082 31.0132 42.3112 30.9197C42.2137 30.8262 42.0915 30.7797 41.9444 30.7797Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3561 32.1526H41.5205V35.4601H42.3561V32.1526Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1005 32.1051C44.8939 32.1051 44.7039 32.146 44.5306 32.2274C44.3573 32.3088 44.2153 32.4215 44.1042 32.5646V32.1526H43.2686V35.4601H44.1042V33.6332C44.1042 33.3704 44.1709 33.1687 44.3043 33.0271C44.4376 32.8861 44.6195 32.8153 44.8504 32.8153C45.0813 32.8153 45.2561 32.8861 45.3875 33.0271C45.5188 33.1687 45.5845 33.3704 45.5845 33.6332V35.4601H46.4196V33.52C46.4196 33.0741 46.2984 32.7269 46.0559 32.4782C45.8134 32.2295 45.4951 32.1051 45.1015 32.1051H45.1005Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0577 32.6247C31.9461 32.4736 31.798 32.3482 31.6131 32.2486C31.4282 32.149 31.2125 32.0995 30.9659 32.0995C30.6835 32.0995 30.4279 32.1692 30.199 32.3083C29.9701 32.4478 29.7893 32.6464 29.6559 32.9053C29.5225 33.1641 29.4558 33.4603 29.4558 33.7949C29.4558 34.1296 29.5225 34.4329 29.6559 34.6932C29.7893 34.9541 29.9701 35.1558 30.199 35.2993C30.4279 35.4429 30.6815 35.5142 30.9599 35.5142C31.2064 35.5142 31.4242 35.4636 31.6131 35.362C31.8021 35.2604 31.9501 35.132 32.0577 34.9768V35.4606H32.8989V32.1531H32.0577V32.6247ZM31.9385 34.3288C31.8592 34.4738 31.7515 34.5855 31.6161 34.6629C31.4807 34.7407 31.3357 34.7792 31.1806 34.7792C31.0255 34.7792 30.8871 34.7397 30.7542 34.6599C30.6209 34.5805 30.5137 34.4657 30.4319 34.3166C30.3506 34.1675 30.3096 33.9931 30.3096 33.7944C30.3096 33.5958 30.3506 33.4234 30.4319 33.2778C30.5132 33.1327 30.6198 33.022 30.7512 32.9462C30.8826 32.8704 31.0255 32.8325 31.1806 32.8325C31.3357 32.8325 31.4807 32.8714 31.6161 32.9487C31.7515 33.0261 31.8587 33.1378 31.9385 33.2829C32.0183 33.4285 32.0577 33.6023 32.0577 33.8051C32.0577 34.0078 32.0178 34.1822 31.9385 34.3272V34.3288Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3752 33.7348C50.3752 33.4123 50.3065 33.1267 50.169 32.878C50.0316 32.6293 49.8386 32.4372 49.59 32.3017C49.3415 32.1662 49.0601 32.099 48.7458 32.099C48.4316 32.099 48.1315 32.1688 47.8809 32.3078C47.6303 32.4473 47.4353 32.646 47.2958 32.9048C47.1564 33.1636 47.0872 33.4639 47.0872 33.8061C47.0872 34.1483 47.1579 34.443 47.2988 34.7013C47.4398 34.9601 47.6368 35.1598 47.8895 35.3014C48.1421 35.4429 48.4275 35.5132 48.7458 35.5132C49.1394 35.5132 49.4718 35.4105 49.7421 35.2058C50.0124 35.0011 50.1958 34.7392 50.2913 34.4208H49.3905C49.2591 34.6877 49.0383 34.8206 48.7281 34.8206C48.5134 34.8206 48.332 34.7529 48.185 34.6179C48.0375 34.4824 47.9541 34.2954 47.9344 34.0568H50.3509C50.3666 33.9613 50.3747 33.8541 50.3747 33.7343L50.3752 33.7348ZM47.941 33.4962C47.9728 33.2733 48.0592 33.0994 48.2007 32.974C48.3416 32.8487 48.5159 32.786 48.7226 32.786C48.9413 32.786 49.1262 32.8507 49.2773 32.9801C49.4284 33.1095 49.5062 33.2814 49.5102 33.4967H47.941V33.4962Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4697 5.30945C22.4011 5.30945 21.5347 6.17638 21.5347 7.24552C21.5347 8.31466 22.4011 9.18159 23.4697 9.18159C24.5382 9.18159 25.4047 8.31466 25.4047 7.24552C25.4047 6.17638 24.5382 5.30945 23.4697 5.30945ZM23.4697 5.5991C23.691 5.5991 23.9016 5.64359 24.0936 5.72447L23.6359 6.5176C23.5823 6.50547 23.5268 6.49839 23.4697 6.49839C23.1307 6.49839 22.8447 6.72485 22.7538 7.03473H21.8666C21.9555 6.22744 22.6391 5.5991 23.4697 5.5991ZM23.839 7.24552C23.839 7.44974 23.6738 7.61504 23.4697 7.61504C23.2656 7.61504 23.1004 7.44974 23.1004 7.24552C23.1004 7.0413 23.2656 6.876 23.4697 6.876C23.6738 6.876 23.839 7.0413 23.839 7.24552ZM21.8747 7.45581H22.7538C22.8447 7.76568 23.1307 7.99215 23.4697 7.99215C23.5242 7.99215 23.5773 7.98608 23.6288 7.97496L24.0568 8.71653C23.8749 8.78781 23.6768 8.82724 23.4697 8.82724C22.6613 8.82724 21.9919 8.23226 21.8747 7.45581ZM24.4261 8.51332L23.9986 7.77276C24.133 7.63779 24.2164 7.45126 24.2164 7.24552C24.2164 7.03978 24.1351 6.85831 24.0037 6.72384L24.4574 5.93728C24.8378 6.2325 25.0829 6.69402 25.0829 7.21317C25.0829 7.73232 24.8242 8.21912 24.4256 8.51332H24.4261Z",
    fill: "url(#paint0_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8381 7.66303L26.532 7.60894C26.538 7.55485 26.5431 7.50076 26.5466 7.44566L26.8573 7.44667C26.9584 7.44667 27.0402 7.36529 27.0407 7.26419C27.0407 7.16309 26.9594 7.0812 26.8583 7.08069L26.5481 7.07968C26.5446 7.01295 26.538 6.94673 26.5304 6.88152L26.8356 6.82592C26.9351 6.80772 27.0008 6.71268 26.9826 6.6131C26.9644 6.51352 26.8694 6.4478 26.7699 6.466L26.4658 6.5216C26.4531 6.46954 26.4395 6.41798 26.4238 6.36692L26.7138 6.26077C26.8088 6.22589 26.8573 6.12074 26.8225 6.02621C26.7876 5.93168 26.6825 5.88265 26.588 5.91753L26.2985 6.02369C26.2743 5.96808 26.2485 5.91349 26.2212 5.8599L26.4875 5.70421C26.5749 5.65315 26.6042 5.54144 26.5532 5.45398C26.5021 5.36653 26.3905 5.33721 26.3031 5.38827L26.0368 5.54396C26.0005 5.48937 25.9626 5.4368 25.9232 5.38473L26.1566 5.18354C26.2329 5.11783 26.242 5.00207 26.1758 4.92573C26.1101 4.8494 25.9944 4.8403 25.9181 4.90653L25.6847 5.10772C25.6453 5.06677 25.6049 5.02734 25.5634 4.98842L25.7585 4.75033C25.8226 4.67197 25.811 4.55672 25.7327 4.49302C25.6544 4.42883 25.5392 4.44045 25.4755 4.51881L25.2805 4.7569C25.2355 4.72404 25.1896 4.6927 25.1426 4.66237L25.2936 4.39445C25.3432 4.30649 25.3123 4.19478 25.2244 4.14524C25.1365 4.0957 25.0249 4.12654 24.9754 4.21449L24.8248 4.4814C24.7652 4.45208 24.7046 4.42478 24.6429 4.39951L24.7424 4.10935C24.7753 4.01381 24.7243 3.90968 24.6288 3.87682C24.5333 3.84396 24.4292 3.89502 24.3964 3.99056L24.2968 4.28071C24.2387 4.26454 24.1801 4.24988 24.1205 4.23724L24.167 3.93444C24.1822 3.83486 24.114 3.74134 24.0144 3.72567C23.9149 3.71051 23.8214 3.77875 23.8058 3.87833L23.7593 4.18164C23.7244 4.1786 23.6891 4.17557 23.6537 4.17355V3.86671C23.6537 3.76561 23.5718 3.68372 23.4708 3.68372C23.3698 3.68372 23.2879 3.76561 23.2879 3.86671V4.17355C23.2298 4.17709 23.1717 4.18214 23.1141 4.18871L23.0606 3.88642C23.0429 3.78684 22.9479 3.72062 22.8489 3.73831C22.7493 3.756 22.6832 3.85104 22.7008 3.95012L22.7544 4.25241C22.6983 4.26555 22.6427 4.28071 22.5877 4.29689L22.4826 4.00875C22.4482 3.91372 22.3431 3.86519 22.2482 3.89957C22.1532 3.93394 22.1047 4.03908 22.139 4.13412L22.2441 4.42225C22.1911 4.445 22.1395 4.46977 22.088 4.49555L21.9344 4.22966C21.8839 4.14221 21.7722 4.11238 21.6848 4.16293C21.5974 4.21348 21.5676 4.3252 21.6181 4.41265L21.7717 4.67854C21.7237 4.71039 21.6762 4.74325 21.6303 4.77712L21.4327 4.54206C21.3681 4.46472 21.2524 4.45461 21.1751 4.51982C21.0978 4.58503 21.0877 4.70028 21.1528 4.77762L21.3509 5.01369C21.3089 5.05312 21.2685 5.09407 21.2291 5.13552L20.9927 4.93736C20.9154 4.87266 20.8002 4.88277 20.735 4.96011C20.6703 5.03745 20.6804 5.1527 20.7577 5.21791L20.9937 5.41607C20.9593 5.46207 20.927 5.50959 20.8952 5.55761L20.6279 5.40343C20.5405 5.35288 20.4288 5.38271 20.3783 5.47067C20.3278 5.55862 20.3576 5.66983 20.4455 5.72038L20.7128 5.87456C20.687 5.92562 20.6628 5.97768 20.64 6.03076L20.3505 5.92511C20.2555 5.89074 20.151 5.93977 20.1161 6.0343C20.0817 6.12934 20.1308 6.23397 20.2252 6.26885L20.5157 6.3745C20.4996 6.4291 20.4849 6.4847 20.4718 6.54081L20.1671 6.48723C20.0676 6.46954 19.9731 6.53626 19.9554 6.63534C19.9378 6.73493 20.0045 6.82946 20.1035 6.84715L20.4086 6.90124C20.4026 6.95533 20.3975 7.00941 20.3945 7.06451L20.0843 7.0635C19.9832 7.0635 19.9014 7.14489 19.9009 7.24599C19.9009 7.34709 19.9822 7.42898 20.0833 7.42949L20.394 7.4305C20.398 7.49722 20.4041 7.56294 20.4122 7.62865L20.106 7.68476C20.0065 7.70296 19.9408 7.798 19.959 7.89758C19.9772 7.99717 20.0722 8.06288 20.1717 8.04468L20.4773 7.98857C20.49 8.04064 20.5041 8.0922 20.5193 8.14275L20.2273 8.24992C20.1323 8.2848 20.0838 8.38994 20.1186 8.48447C20.1535 8.5795 20.2586 8.62803 20.3531 8.59315L20.6456 8.48599C20.6698 8.54109 20.6956 8.59568 20.7229 8.64926L20.4536 8.80698C20.3662 8.85804 20.3369 8.96975 20.3879 9.0572C20.4389 9.14466 20.5506 9.17397 20.638 9.12292L20.9073 8.9652C20.9437 9.01929 20.9816 9.07186 21.021 9.12342L20.784 9.32765C20.7077 9.39336 20.6986 9.50912 20.7648 9.58545C20.8305 9.66178 20.9462 9.67088 21.0225 9.60466L21.2599 9.39993C21.2993 9.44037 21.3393 9.4798 21.3807 9.51822L21.1821 9.76086C21.118 9.83922 21.1296 9.95447 21.2079 10.0182C21.2862 10.0824 21.4014 10.0707 21.4651 9.99238L21.6641 9.74974C21.7091 9.78209 21.7545 9.81344 21.801 9.84326L21.6469 10.1167C21.5974 10.2047 21.6282 10.3164 21.7162 10.3659C21.8041 10.4155 21.9157 10.3847 21.9652 10.2967L22.1193 10.0237C22.1784 10.0525 22.2391 10.0798 22.3002 10.1046L22.1986 10.4013C22.1658 10.4969 22.2168 10.601 22.3123 10.6339C22.4078 10.6667 22.5119 10.6157 22.5447 10.5201L22.6468 10.2229C22.7044 10.2391 22.763 10.2537 22.8221 10.2664L22.7741 10.5767C22.7589 10.6763 22.8271 10.7698 22.9267 10.7855C23.0262 10.8007 23.1197 10.7324 23.1353 10.6329L23.1833 10.322C23.2182 10.325 23.253 10.328 23.2879 10.3301V10.6445C23.2879 10.7456 23.3698 10.8275 23.4708 10.8275C23.5718 10.8275 23.6537 10.7456 23.6537 10.6445V10.3301C23.7118 10.3265 23.7689 10.3215 23.826 10.3149L23.8805 10.6248C23.8982 10.7243 23.9932 10.7906 24.0922 10.7729C24.1918 10.7552 24.2579 10.6602 24.2403 10.5611L24.1857 10.2517C24.2413 10.2386 24.2968 10.2239 24.3514 10.2077L24.459 10.5024C24.4934 10.5975 24.5985 10.646 24.6934 10.6116C24.7884 10.5772 24.8369 10.4721 24.8026 10.3771L24.6955 10.0824C24.748 10.0596 24.7995 10.0354 24.8506 10.0096L25.0077 10.281C25.0582 10.3685 25.1699 10.3983 25.2573 10.3478C25.3447 10.2972 25.3745 10.1855 25.324 10.098L25.1668 9.82658C25.2143 9.79524 25.2613 9.76238 25.3073 9.72851L25.5089 9.96862C25.5735 10.046 25.6892 10.0561 25.7665 9.99087C25.8438 9.92616 25.8539 9.8104 25.7888 9.73306L25.5872 9.49244C25.6286 9.45301 25.669 9.41257 25.7084 9.37112L25.9489 9.57282C26.0262 9.63752 26.1414 9.62741 26.2066 9.55007C26.2713 9.47273 26.2612 9.35747 26.1839 9.29226L25.9444 9.09158C25.9787 9.04558 26.0111 8.99857 26.0424 8.95105L26.3132 9.10725C26.4006 9.1578 26.5123 9.12797 26.5628 9.04002C26.6133 8.95206 26.5835 8.84085 26.4956 8.7903L26.2253 8.6341C26.2511 8.58304 26.2753 8.53148 26.298 8.47891L26.5906 8.58557C26.6855 8.61994 26.7901 8.57142 26.825 8.47638C26.8593 8.38135 26.8103 8.27671 26.7159 8.24183L26.4233 8.13517C26.4395 8.08057 26.4542 8.02497 26.4678 7.96936L26.7745 8.02345C26.874 8.04114 26.9685 7.97442 26.9862 7.87483C27.0038 7.77525 26.9371 7.68072 26.8381 7.66303ZM23.4713 9.89836C22.0102 9.89836 20.8259 8.71346 20.8259 7.25155C20.8259 5.78964 22.0102 4.60474 23.4713 4.60474C24.9324 4.60474 26.1167 5.78964 26.1167 7.25155C26.1167 8.71346 24.9324 9.89836 23.4713 9.89836Z",
    fill: "url(#paint1_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5441 7.62317H19.4425C19.4345 7.59284 19.4233 7.56453 19.4087 7.53774L19.4799 7.46697C19.5224 7.42451 19.5229 7.35576 19.4799 7.3133C19.4375 7.27083 19.3688 7.27033 19.3263 7.3133L19.2561 7.38356C19.2288 7.3684 19.2 7.35576 19.1697 7.34717V7.24809C19.1697 7.18793 19.1212 7.1394 19.0611 7.1394C19.001 7.1394 18.9525 7.18793 18.9525 7.24809V7.34717C18.9227 7.35576 18.8944 7.36739 18.8676 7.38255L18.7974 7.31229C18.7549 7.26982 18.6862 7.26932 18.6438 7.31229C18.6013 7.35475 18.6008 7.4235 18.6438 7.46596L18.7145 7.53723C18.6999 7.56403 18.6882 7.59233 18.6802 7.62216H18.5786C18.5185 7.62216 18.47 7.67018 18.4695 7.73034C18.4695 7.79049 18.518 7.83902 18.5781 7.83952H18.6812C18.6898 7.86884 18.7014 7.89665 18.716 7.92243L18.6428 7.99573C18.6003 8.03819 18.5998 8.10694 18.6428 8.1494C18.6852 8.19186 18.7539 8.19237 18.7964 8.1494L18.8706 8.07559C18.8964 8.08975 18.9242 8.10138 18.9535 8.10946V8.21461C18.9535 8.27476 19.002 8.32329 19.0621 8.32329C19.1222 8.32329 19.1707 8.27476 19.1707 8.21461V8.10946C19.199 8.10138 19.2263 8.09025 19.2516 8.07661L19.3253 8.15091C19.3678 8.19338 19.4365 8.19388 19.4789 8.15091C19.5214 8.10845 19.5219 8.0397 19.4789 7.99724L19.4057 7.92344C19.4203 7.89766 19.4324 7.86986 19.441 7.84104H19.5441C19.6042 7.84104 19.6527 7.79302 19.6532 7.73286C19.6532 7.67271 19.6047 7.62418 19.5446 7.62368L19.5441 7.62317ZM19.0611 7.95276C18.9368 7.95276 18.8363 7.85216 18.8363 7.7273C18.8363 7.60244 18.9368 7.50185 19.0611 7.50185C19.1854 7.50185 19.2864 7.60244 19.2864 7.7273C19.2864 7.85216 19.1859 7.95276 19.0611 7.95276Z",
    fill: "url(#paint2_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8131 9.64465H12.7116C12.7035 9.61432 12.6924 9.58602 12.6777 9.55922L12.749 9.48845C12.7914 9.44599 12.7919 9.37724 12.749 9.33478C12.7065 9.29232 12.6378 9.29181 12.5954 9.33478L12.5252 9.40505C12.4979 9.38988 12.4691 9.37724 12.4388 9.36865V9.26957C12.4388 9.20942 12.3903 9.16089 12.3301 9.16089C12.27 9.16089 12.2215 9.20942 12.2215 9.26957V9.36865C12.1917 9.37724 12.1634 9.38887 12.1366 9.40404L12.0664 9.33377C12.024 9.29131 11.9553 9.2908 11.9128 9.33377C11.8704 9.37623 11.8699 9.44498 11.9128 9.48744L11.9836 9.55872C11.9689 9.58551 11.9573 9.61382 11.9492 9.64364H11.8477C11.7875 9.64364 11.739 9.69167 11.7385 9.75182C11.7385 9.81198 11.787 9.8605 11.8471 9.86101H11.9502C11.9588 9.89033 11.9704 9.91813 11.9851 9.94391L11.9118 10.0172C11.8694 10.0597 11.8689 10.1284 11.9118 10.1709C11.9548 10.2133 12.023 10.2139 12.0654 10.1709L12.1397 10.0971C12.1654 10.1112 12.1932 10.1229 12.2225 10.1309V10.2361C12.2225 10.2962 12.271 10.3448 12.3312 10.3448C12.3913 10.3448 12.4398 10.2962 12.4398 10.2361V10.1309C12.4681 10.1229 12.4954 10.1117 12.5206 10.0981L12.5944 10.1724C12.6368 10.2149 12.7055 10.2154 12.748 10.1724C12.7904 10.1299 12.7909 10.0612 12.748 10.0187L12.6747 9.94492C12.6894 9.91914 12.7015 9.89134 12.7101 9.86253H12.8131C12.8733 9.86253 12.9218 9.8145 12.9223 9.75435C12.9223 9.69419 12.8738 9.64566 12.8136 9.64516L12.8131 9.64465ZM12.3296 9.97424C12.2054 9.97424 12.1048 9.87365 12.1048 9.74879C12.1048 9.62393 12.2054 9.52333 12.3296 9.52333C12.4539 9.52333 12.555 9.62393 12.555 9.74879C12.555 9.87365 12.4544 9.97424 12.3296 9.97424Z",
    fill: "url(#paint3_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8771 9.31409H9.77555C9.76747 9.28376 9.75635 9.25545 9.7417 9.22866L9.81294 9.15789C9.85538 9.11543 9.85588 9.04668 9.81294 9.00422C9.7705 8.96175 9.70179 8.96125 9.65935 9.00422L9.58912 9.07448C9.56184 9.05931 9.53305 9.04668 9.50273 9.03808V8.939C9.50273 8.87885 9.45423 8.83032 9.39411 8.83032C9.33399 8.83032 9.28549 8.87885 9.28549 8.939V9.03808C9.25568 9.04668 9.22738 9.0583 9.20061 9.07347L9.13038 9.0032C9.08794 8.96074 9.01923 8.96024 8.97679 9.0032C8.93435 9.04567 8.93385 9.11441 8.97679 9.15688L9.04752 9.22815C9.03287 9.25494 9.02125 9.28325 9.01317 9.31308H8.91162C8.8515 9.31308 8.803 9.3611 8.80249 9.42125C8.80249 9.48141 8.85099 9.52994 8.91111 9.53044H9.01418C9.02277 9.55976 9.03439 9.58756 9.04904 9.61335L8.97578 9.68664C8.93334 9.72911 8.93284 9.79785 8.97578 9.84032C9.01822 9.88278 9.08693 9.88328 9.12937 9.84032L9.20364 9.76651C9.22941 9.78067 9.25719 9.79229 9.2865 9.80038V9.90553C9.2865 9.96568 9.335 10.0142 9.39512 10.0142C9.45524 10.0142 9.50374 9.96568 9.50374 9.90553V9.80038C9.53204 9.79229 9.55932 9.78117 9.58458 9.76752L9.65834 9.84183C9.70078 9.88429 9.76949 9.8848 9.81193 9.84183C9.85437 9.79937 9.85487 9.73062 9.81193 9.68816L9.73867 9.61436C9.75332 9.58858 9.76545 9.56077 9.77404 9.53196H9.8771C9.93723 9.53196 9.98573 9.48394 9.98623 9.42378C9.98674 9.36363 9.93773 9.3151 9.87761 9.31459L9.8771 9.31409ZM9.39411 9.64368C9.26982 9.64368 9.16928 9.54308 9.16928 9.41822C9.16928 9.29336 9.26982 9.19277 9.39411 9.19277C9.51839 9.19277 9.61944 9.29336 9.61944 9.41822C9.61944 9.54308 9.5189 9.64368 9.39411 9.64368Z",
    fill: "url(#paint4_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05 2.91284H22.9484C22.9403 2.88251 22.9292 2.8542 22.9146 2.82741L22.9858 2.75664C23.0282 2.71418 23.0287 2.64543 22.9858 2.60297C22.9434 2.56051 22.8746 2.56 22.8322 2.60297L22.762 2.67323C22.7347 2.65807 22.7059 2.64543 22.6756 2.63684V2.53776C22.6756 2.47761 22.6271 2.42908 22.567 2.42908C22.5068 2.42908 22.4583 2.47761 22.4583 2.53776V2.63684C22.4285 2.64543 22.4002 2.65706 22.3735 2.67222L22.3032 2.60196C22.2608 2.5595 22.1921 2.55899 22.1496 2.60196C22.1072 2.64442 22.1067 2.71317 22.1496 2.75563L22.2204 2.82691C22.2057 2.8537 22.1941 2.88201 22.186 2.91183H22.0845C22.0243 2.91183 21.9758 2.95985 21.9753 3.02001C21.9753 3.08016 22.0238 3.12869 22.084 3.1292H22.187C22.1956 3.15852 22.2072 3.18632 22.2219 3.2121L22.1486 3.2854C22.1062 3.32786 22.1057 3.39661 22.1486 3.43907C22.1911 3.48153 22.2598 3.48204 22.3022 3.43907L22.3765 3.36527C22.4023 3.37942 22.43 3.39105 22.4593 3.39914V3.50428C22.4593 3.56443 22.5078 3.61296 22.568 3.61296C22.6281 3.61296 22.6766 3.56443 22.6766 3.50428V3.39914C22.7049 3.39105 22.7322 3.37993 22.7574 3.36628L22.8312 3.44059C22.8736 3.48305 22.9423 3.48355 22.9848 3.44059C23.0272 3.39812 23.0277 3.32938 22.9848 3.28691L22.9115 3.21311C22.9262 3.18733 22.9383 3.15953 22.9469 3.13071H23.05C23.1101 3.13071 23.1586 3.08269 23.1591 3.02254C23.1591 2.96238 23.1106 2.91385 23.0505 2.91335L23.05 2.91284ZM22.5665 3.24243C22.4422 3.24243 22.3416 3.14183 22.3416 3.01698C22.3416 2.89212 22.4422 2.79152 22.5665 2.79152C22.6907 2.79152 22.7918 2.89212 22.7918 3.01698C22.7918 3.14183 22.6912 3.24243 22.5665 3.24243Z",
    fill: "url(#paint5_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5441 3.44666H19.4425C19.4345 3.41633 19.4233 3.38802 19.4087 3.36123L19.4799 3.29046C19.5224 3.24799 19.5229 3.17925 19.4799 3.13678C19.4375 3.09432 19.3688 3.09382 19.3263 3.13678L19.2561 3.20705C19.2288 3.19188 19.2 3.17925 19.1697 3.17065V3.07157C19.1697 3.01142 19.1212 2.96289 19.0611 2.96289C19.001 2.96289 18.9525 3.01142 18.9525 3.07157V3.17065C18.9227 3.17925 18.8944 3.19087 18.8676 3.20604L18.7974 3.13577C18.7549 3.09331 18.6862 3.0928 18.6438 3.13577C18.6013 3.17823 18.6008 3.24698 18.6438 3.28944L18.7145 3.36072C18.6999 3.38751 18.6882 3.41582 18.6802 3.44565H18.5786C18.5185 3.44565 18.47 3.49367 18.4695 3.55382C18.4695 3.61398 18.518 3.66251 18.5781 3.66301H18.6812C18.6898 3.69233 18.7014 3.72013 18.716 3.74591L18.6428 3.81921C18.6003 3.86167 18.5998 3.93042 18.6428 3.97288C18.6852 4.01535 18.7539 4.01585 18.7964 3.97288L18.8706 3.89908C18.8964 3.91323 18.9242 3.92486 18.9535 3.93295V4.03809C18.9535 4.09825 19.002 4.14678 19.0621 4.14678C19.1222 4.14678 19.1707 4.09825 19.1707 4.03809V3.93295C19.199 3.92486 19.2263 3.91374 19.2516 3.90009L19.3253 3.9744C19.3678 4.01686 19.4365 4.01737 19.4789 3.9744C19.5214 3.93194 19.5219 3.86319 19.4789 3.82073L19.4057 3.74692C19.4203 3.72114 19.4324 3.69334 19.441 3.66453H19.5441C19.6042 3.66453 19.6527 3.6165 19.6532 3.55635C19.6532 3.4962 19.6047 3.44767 19.5446 3.44716L19.5441 3.44666ZM19.0611 3.77675C18.9368 3.77675 18.8363 3.67615 18.8363 3.5513C18.8363 3.42644 18.9368 3.32584 19.0611 3.32584C19.1854 3.32584 19.2864 3.42644 19.2864 3.5513C19.2864 3.67615 19.1859 3.77675 19.0611 3.77675Z",
    fill: "url(#paint6_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3204 28.9675H15.1754C15.1653 28.9311 15.1521 28.8967 15.1345 28.8644L15.2365 28.7633C15.279 28.7208 15.2795 28.6521 15.2365 28.6096L15.2047 28.5778C15.1622 28.5353 15.0935 28.5348 15.0511 28.5778L14.95 28.6784C14.9172 28.6597 14.8823 28.645 14.8455 28.6344V28.4923C14.8455 28.4322 14.797 28.3837 14.7368 28.3837H14.6919C14.6318 28.3837 14.5833 28.4322 14.5833 28.4923V28.6344C14.5474 28.6445 14.513 28.6587 14.4807 28.6769L14.3802 28.5758C14.3377 28.5333 14.269 28.5328 14.2266 28.5758L14.1947 28.6076C14.1523 28.6501 14.1518 28.7188 14.1947 28.7613L14.2963 28.8634C14.2786 28.8952 14.265 28.9296 14.2549 28.966H14.1099C14.0497 28.9655 14.0012 29.014 14.0007 29.0742V29.1192C14.0007 29.1793 14.0492 29.2279 14.1089 29.2284H14.2559C14.266 29.2637 14.2801 29.2971 14.2978 29.3285L14.1932 29.4326C14.1508 29.475 14.1503 29.5438 14.1932 29.5863L14.2251 29.6181C14.2675 29.6606 14.3362 29.6611 14.3786 29.6181L14.4842 29.513C14.5156 29.5301 14.5489 29.5438 14.5843 29.5539V29.7035C14.5843 29.7637 14.6328 29.8122 14.6929 29.8122H14.7379C14.798 29.8122 14.8465 29.7637 14.8465 29.7035V29.5539C14.8808 29.5443 14.9137 29.5312 14.9445 29.5145L15.0496 29.6201C15.092 29.6626 15.1607 29.6631 15.2032 29.6201L15.235 29.5883C15.2774 29.5458 15.2779 29.4771 15.235 29.4346L15.1309 29.33C15.1486 29.2986 15.1633 29.2653 15.1734 29.2304H15.3199C15.38 29.2309 15.4285 29.1824 15.429 29.1222V29.0772C15.429 29.0171 15.3805 28.9685 15.3209 28.968L15.3204 28.9675ZM14.7146 29.3648C14.5646 29.3648 14.4428 29.243 14.4428 29.0929C14.4428 28.9428 14.5646 28.8209 14.7146 28.8209C14.8647 28.8209 14.9864 28.9428 14.9864 29.0929C14.9864 29.243 14.8647 29.3648 14.7146 29.3648Z",
    fill: "url(#paint7_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86319 30.1115H8.76164C8.75355 30.0811 8.74244 30.0528 8.72779 30.026L8.79902 29.9552C8.84146 29.9128 8.84197 29.844 8.79902 29.8016C8.75659 29.7591 8.68788 29.7586 8.64544 29.8016L8.57521 29.8718C8.54793 29.8567 8.51913 29.844 8.48882 29.8354V29.7364C8.48882 29.6762 8.44031 29.6277 8.38019 29.6277C8.32007 29.6277 8.27157 29.6762 8.27157 29.7364V29.8354C8.24176 29.844 8.21347 29.8557 8.18669 29.8708L8.11647 29.8006C8.07403 29.7581 8.00532 29.7576 7.96288 29.8006C7.92044 29.843 7.91993 29.9118 7.96288 29.9542L8.03361 30.0255C8.01896 30.0523 8.00734 30.0806 7.99925 30.1104H7.8977C7.83758 30.1104 7.78908 30.1585 7.78857 30.2186C7.78857 30.2788 7.83708 30.3273 7.8972 30.3278H8.00026C8.00885 30.3571 8.02047 30.3849 8.03512 30.4107L7.96187 30.484C7.91943 30.5265 7.91892 30.5952 7.96187 30.6377C8.00431 30.6801 8.07302 30.6806 8.11545 30.6377L8.18972 30.5639C8.21549 30.578 8.24328 30.5897 8.27258 30.5977V30.7029C8.27258 30.763 8.32108 30.8116 8.3812 30.8116C8.44133 30.8116 8.48983 30.763 8.48983 30.7029V30.5977C8.51812 30.5897 8.5454 30.5785 8.57066 30.5649L8.64443 30.6392C8.68686 30.6817 8.75558 30.6822 8.79801 30.6392C8.84045 30.5967 8.84096 30.528 8.79801 30.4855L8.72476 30.4117C8.73941 30.3859 8.75153 30.3581 8.76012 30.3293H8.86319C8.92331 30.3293 8.97181 30.2813 8.97232 30.2211C8.97232 30.161 8.92382 30.1125 8.86369 30.112L8.86319 30.1115ZM8.38019 30.441C8.25591 30.441 8.15537 30.3404 8.15537 30.2156C8.15537 30.0907 8.25591 29.9901 8.38019 29.9901C8.50448 29.9901 8.60552 30.0907 8.60552 30.2156C8.60552 30.3404 8.50498 30.441 8.38019 30.441Z",
    fill: "url(#paint8_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07876 27.5803H3.97721C3.96913 27.55 3.95801 27.5217 3.94336 27.4949L4.0146 27.4241C4.05704 27.3817 4.05754 27.3129 4.0146 27.2705C3.97216 27.228 3.90345 27.2275 3.86101 27.2705L3.79079 27.3407C3.7635 27.3256 3.73471 27.3129 3.70439 27.3043V27.2052C3.70439 27.1451 3.65589 27.0966 3.59577 27.0966C3.53565 27.0966 3.48715 27.1451 3.48715 27.2052V27.3043C3.45734 27.3129 3.42904 27.3245 3.40227 27.3397L3.33204 27.2694C3.2896 27.227 3.22089 27.2265 3.17845 27.2694C3.13601 27.3119 3.13551 27.3807 3.17845 27.4231L3.24918 27.4944C3.23453 27.5212 3.22291 27.5495 3.21483 27.5793H3.11328C3.05316 27.5793 3.00466 27.6273 3.00415 27.6875C3.00415 27.7476 3.05265 27.7962 3.11277 27.7967H3.21584C3.22443 27.826 3.23605 27.8538 3.2507 27.8796L3.17744 27.9529C3.135 27.9953 3.1345 28.0641 3.17744 28.1066C3.21988 28.149 3.28859 28.1495 3.33103 28.1066L3.4053 28.0327C3.43107 28.0469 3.45885 28.0585 3.48816 28.0666V28.1718C3.48816 28.2319 3.53666 28.2804 3.59678 28.2804C3.6569 28.2804 3.7054 28.2319 3.7054 28.1718V28.0666C3.7337 28.0585 3.76098 28.0474 3.78624 28.0338L3.86 28.1081C3.90244 28.1505 3.97115 28.151 4.01359 28.1081C4.05603 28.0656 4.05653 27.9969 4.01359 27.9544L3.94033 27.8806C3.95498 27.8548 3.96711 27.827 3.9757 27.7982H4.07876C4.13889 27.7982 4.18739 27.7502 4.18789 27.69C4.18789 27.6299 4.13939 27.5813 4.07927 27.5808L4.07876 27.5803ZM3.59577 27.9099C3.47148 27.9099 3.37094 27.8093 3.37094 27.6845C3.37094 27.5596 3.47148 27.459 3.59577 27.459C3.72005 27.459 3.8211 27.5596 3.8211 27.6845C3.8211 27.8093 3.72056 27.9099 3.59577 27.9099Z",
    fill: "url(#paint9_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64046 30.344C5.72281 30.343 5.78849 30.2753 5.78748 30.1934C5.78647 30.111 5.71877 30.0452 5.63692 30.0463L5.38279 30.0498C5.37824 30.0129 5.37269 29.976 5.3646 29.9401L5.6061 29.8532C5.6834 29.8254 5.72331 29.7399 5.69553 29.6626C5.66774 29.5852 5.58236 29.5453 5.50506 29.5731L5.26608 29.6596C5.24234 29.612 5.21708 29.5655 5.18777 29.5215L5.38077 29.3527C5.44241 29.2986 5.44898 29.2046 5.39492 29.1424C5.34086 29.0808 5.24689 29.0742 5.18474 29.1283L4.99225 29.2966C4.96295 29.2698 4.93213 29.2445 4.8998 29.2208L5.02661 28.9948C5.06703 28.923 5.04126 28.8325 4.96952 28.7921C4.89778 28.7517 4.80734 28.7774 4.76692 28.8492L4.64112 29.0732C4.60171 29.0565 4.56079 29.0428 4.51936 29.0302L4.5618 28.7724C4.57494 28.691 4.52037 28.6147 4.43903 28.6015C4.3582 28.5884 4.2814 28.643 4.26827 28.7244L4.22583 28.9822C4.20814 28.9812 4.19097 28.9797 4.17278 28.9797C4.15105 28.9797 4.12983 28.9817 4.10811 28.9827L4.06112 28.7213C4.04647 28.6405 3.96917 28.5864 3.88834 28.601C3.8075 28.6157 3.75344 28.693 3.76809 28.7739L3.81457 29.0332C3.76557 29.0484 3.71808 29.0671 3.67159 29.0878L3.53165 28.8583C3.4887 28.7881 3.39726 28.7658 3.32703 28.8088C3.25681 28.8518 3.23458 28.9433 3.27752 29.0135L3.41696 29.2425C3.38362 29.2693 3.35128 29.2971 3.32046 29.3269L3.10776 29.1576C3.0436 29.1065 2.94963 29.1171 2.8986 29.1813C2.84757 29.2455 2.85818 29.3396 2.92235 29.3906L3.13505 29.56C3.11383 29.5943 3.09412 29.6302 3.07593 29.6671L2.81473 29.5792C2.73693 29.5529 2.65256 29.5948 2.62628 29.6727C2.60001 29.7505 2.64195 29.835 2.71975 29.8612L2.97843 29.9482C2.97085 29.9841 2.96529 30.0205 2.96125 30.0569L2.68439 30.0604C2.60203 30.0614 2.53635 30.1292 2.53737 30.2111C2.53838 30.2935 2.60608 30.3592 2.68792 30.3582L2.96276 30.3546C2.96731 30.3895 2.97236 30.4239 2.97994 30.4572L2.71874 30.5513C2.64144 30.5791 2.60153 30.6645 2.62932 30.7418C2.6571 30.8192 2.74249 30.8591 2.81979 30.8313L3.07846 30.7378C3.10069 30.7833 3.12545 30.8273 3.15273 30.8692L2.94407 31.0517C2.88243 31.1058 2.87587 31.1998 2.92992 31.262C2.98398 31.3237 3.07796 31.3302 3.1401 31.2761L3.34674 31.0957C3.37452 31.1215 3.40332 31.1457 3.43363 31.1685L3.29823 31.4101C3.25782 31.4819 3.28358 31.5724 3.35532 31.6128C3.42707 31.6533 3.5175 31.6275 3.55792 31.5557L3.69029 31.3196C3.72818 31.3358 3.76708 31.3505 3.807 31.3631L3.76254 31.6325C3.7494 31.7139 3.80396 31.7902 3.8853 31.8034C3.96665 31.8165 4.04294 31.7619 4.05607 31.6805L4.09952 31.4152C4.12327 31.4167 4.14701 31.4187 4.17126 31.4187C4.18591 31.4187 4.20006 31.4172 4.21471 31.4167L4.26271 31.6836C4.27736 31.7645 4.35466 31.8186 4.43549 31.8039C4.51633 31.7892 4.57039 31.7119 4.55574 31.631L4.50926 31.3702C4.55877 31.356 4.60727 31.3393 4.65375 31.3191L4.79218 31.5461C4.83513 31.6164 4.92657 31.6386 4.9968 31.5956C5.06703 31.5527 5.08926 31.4612 5.04631 31.3909L4.91041 31.1675C4.94527 31.1412 4.97861 31.1129 5.00994 31.083L5.21607 31.2468C5.28023 31.2979 5.3742 31.2873 5.42523 31.2231C5.47626 31.1589 5.46565 31.0648 5.40148 31.0138L5.1999 30.853C5.22264 30.8172 5.24335 30.7802 5.26255 30.7423L5.5091 30.8252C5.5869 30.8515 5.67128 30.8096 5.69755 30.7317C5.72382 30.6539 5.68189 30.5695 5.60408 30.5432L5.36258 30.4618C5.37067 30.4244 5.37723 30.386 5.38178 30.347L5.63995 30.3435L5.64046 30.344ZM3.87722 30.1984C3.87722 30.0351 4.00959 29.9027 4.17278 29.9027C4.33597 29.9027 4.46833 30.0351 4.46833 30.1984C4.46833 30.3617 4.33597 30.4941 4.17278 30.4941C4.00959 30.4941 3.87722 30.3617 3.87722 30.1984Z",
    fill: "url(#paint10_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81671 14.6228C5.28218 14.5116 4.75877 14.8549 4.64762 15.3897C4.53647 15.9245 4.87952 16.4482 5.41404 16.5594C5.94857 16.6706 6.47198 16.3274 6.58313 15.7926C6.69428 15.2578 6.35124 14.7341 5.81671 14.6228ZM5.7672 14.7806C6.03395 14.8362 6.24261 15.0151 6.3477 15.2451L5.93392 15.3816C5.88037 15.3002 5.79599 15.2391 5.69293 15.2178C5.59138 15.1966 5.49084 15.2178 5.41 15.2699L5.06443 14.9615C5.25136 14.8018 5.50751 14.727 5.76669 14.7811L5.7672 14.7806ZM5.57673 15.7759C5.47467 15.7547 5.40899 15.6546 5.43021 15.5525C5.45143 15.4504 5.55146 15.3846 5.65352 15.4059C5.75558 15.4271 5.82125 15.5272 5.80004 15.6293C5.77882 15.7314 5.67878 15.7971 5.57673 15.7759ZM4.79211 15.42C4.81535 15.3093 4.85931 15.2082 4.91993 15.1208L5.26904 15.4322C5.25742 15.4579 5.24782 15.4847 5.24227 15.5135C5.2069 15.6834 5.29026 15.8497 5.43577 15.9275L5.34331 16.3714C4.94924 16.243 4.70622 15.8355 4.79262 15.42H4.79211ZM6.40631 15.7557C6.32244 16.1601 5.95514 16.432 5.555 16.4103L5.64645 15.9715C5.81065 15.9584 5.95362 15.8386 5.98899 15.6692C5.99455 15.6419 5.99707 15.6146 5.99707 15.5879L6.41186 15.4509C6.42854 15.5494 6.42803 15.6526 6.40681 15.7562L6.40631 15.7557Z",
    fill: "url(#paint11_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21065 18.4631C6.72513 18.362 6.24921 18.6739 6.14816 19.1602C6.04712 19.646 6.35884 20.1222 6.84487 20.2233C7.33039 20.3244 7.80631 20.0125 7.90736 19.5262C8.0084 19.0404 7.69668 18.5642 7.21065 18.4631ZM7.16569 18.6062C7.40769 18.6567 7.59765 18.819 7.69314 19.0283L7.31725 19.1521C7.26875 19.0783 7.19196 19.0227 7.09849 19.003C7.00604 18.9838 6.9151 19.003 6.84133 19.0505L6.52759 18.77C6.69785 18.6249 6.93025 18.5566 7.16569 18.6057V18.6062ZM6.9929 19.511C6.89994 19.4918 6.84083 19.4008 6.86003 19.3083C6.87922 19.2158 6.97017 19.1562 7.06262 19.1754C7.15558 19.1946 7.21469 19.2856 7.1955 19.3781C7.1763 19.4711 7.08536 19.5302 6.9929 19.511ZM6.28003 19.187C6.30074 19.0864 6.34116 18.9949 6.39623 18.915L6.71351 19.1981C6.7029 19.2214 6.69431 19.2461 6.68926 19.2719C6.65743 19.4261 6.73321 19.5777 6.86508 19.648L6.78121 20.0514C6.42301 19.9346 6.20222 19.5646 6.28053 19.187H6.28003ZM7.7467 19.4923C7.67041 19.8598 7.33696 20.107 6.9732 20.0873L7.05605 19.6885C7.2056 19.6763 7.33544 19.5676 7.36727 19.4135C7.37232 19.3887 7.37485 19.3639 7.37434 19.3397L7.75124 19.2153C7.7664 19.3048 7.76589 19.3983 7.7467 19.4928V19.4923Z",
    fill: "url(#paint12_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76195 6.80072C6.29513 6.70366 5.8379 7.00343 5.74089 7.47051C5.64389 7.93759 5.94349 8.39507 6.41032 8.49213C6.87714 8.58918 7.33437 8.28942 7.43138 7.82234C7.52838 7.35525 7.22878 6.89777 6.76195 6.80072ZM6.71901 6.93872C6.95192 6.98725 7.1343 7.14345 7.22626 7.34413L6.86451 7.46343C6.81753 7.39216 6.74377 7.33908 6.65384 7.32037C6.56492 7.30167 6.47751 7.32037 6.40678 7.36587L6.10516 7.09644C6.26885 6.95692 6.49216 6.8912 6.7185 6.93872H6.71901ZM6.55279 7.80818C6.46387 7.78948 6.40628 7.70253 6.42497 7.61306C6.44366 7.52409 6.53056 7.46646 6.61999 7.48517C6.7089 7.50387 6.7665 7.59082 6.74781 7.68029C6.72911 7.76926 6.64222 7.82689 6.55279 7.80818ZM5.8672 7.4973C5.88741 7.40075 5.92581 7.31229 5.97885 7.23596L6.28351 7.50792C6.2734 7.53016 6.26532 7.55392 6.25976 7.57869C6.22894 7.7268 6.30169 7.87238 6.42901 7.94063L6.34817 8.32835C6.00361 8.21612 5.79142 7.86025 5.8672 7.4973ZM7.27728 7.79049C7.20403 8.14384 6.88321 8.38142 6.53359 8.36221L6.61342 7.97904C6.7569 7.96742 6.88169 7.86328 6.91251 7.71467C6.91756 7.69091 6.91958 7.66715 6.91958 7.64339L7.28183 7.52409C7.29648 7.61003 7.29598 7.70001 7.27728 7.79049Z",
    fill: "url(#paint13_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54818 24.0874C4.15107 24.0045 3.76205 24.2598 3.67919 24.6576C3.59633 25.0549 3.85147 25.4442 4.24908 25.5271C4.64619 25.61 5.03521 25.3547 5.11807 24.9569C5.20093 24.5595 4.94579 24.1703 4.54818 24.0874ZM4.51129 24.2047C4.70934 24.2461 4.86445 24.3791 4.94276 24.5499L4.63507 24.6515C4.59516 24.5909 4.53251 24.5459 4.45622 24.5297C4.38095 24.514 4.30617 24.5297 4.24605 24.5686L3.9894 24.3391C4.12833 24.2203 4.3188 24.1647 4.51129 24.2047ZM4.36983 24.9447C4.29405 24.9291 4.24555 24.8548 4.26121 24.7789C4.27687 24.7031 4.35114 24.6546 4.42692 24.6702C4.50271 24.6859 4.55121 24.7602 4.53554 24.836C4.51988 24.9119 4.44561 24.9604 4.36983 24.9447ZM3.7868 24.6798C3.80398 24.5975 3.83682 24.5226 3.88178 24.4574L4.14147 24.6895C4.13288 24.7087 4.12581 24.7284 4.12126 24.7496C4.09499 24.8755 4.15764 24.9983 4.26525 25.0564L4.19654 25.3876C3.90351 25.292 3.72314 24.9892 3.78731 24.6804L3.7868 24.6798ZM4.98621 24.9296C4.92356 25.2303 4.65074 25.4325 4.35366 25.4159L4.42187 25.0883C4.54363 25.0782 4.65023 24.9907 4.676 24.8649C4.68004 24.8446 4.68206 24.8244 4.68155 24.8042L4.98974 24.7026C5.00187 24.7759 5.00187 24.8522 4.9857 24.9296H4.98621Z",
    fill: "url(#paint14_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2809 31.5293C6.07477 31.3423 5.75597 31.3574 5.56904 31.5637C5.38211 31.7699 5.39726 32.0889 5.60339 32.2759C5.80953 32.463 6.12832 32.4478 6.31526 32.2416C6.50219 32.0353 6.48703 31.7164 6.2809 31.5293ZM5.62512 31.6264C5.71859 31.5238 5.85095 31.4783 5.97928 31.4914L5.9323 31.7088C5.88278 31.7113 5.83428 31.7325 5.79791 31.7725C5.76254 31.8119 5.74587 31.8614 5.74789 31.9105L5.52306 31.9827C5.50134 31.8589 5.53468 31.7275 5.62512 31.6274V31.6264ZM6.01313 31.9676C5.97726 32.007 5.91663 32.01 5.87723 31.9742C5.83782 31.9383 5.83479 31.8776 5.87066 31.8382C5.90653 31.7987 5.96716 31.7957 6.00656 31.8316C6.04597 31.8675 6.049 31.9282 6.01313 31.9676ZM5.65392 32.2203C5.61148 32.1814 5.57864 32.1359 5.5554 32.0869L5.78275 32.0141C5.79083 32.0257 5.80043 32.0368 5.81104 32.0469C5.87622 32.1061 5.97069 32.1122 6.04243 32.0682L6.21421 32.2239C6.05557 32.3639 5.81407 32.3654 5.65392 32.2198V32.2203ZM6.28646 32.141L6.1167 31.9868C6.15308 31.911 6.13843 31.818 6.07325 31.7583C6.06264 31.7487 6.05153 31.7406 6.0394 31.734L6.08639 31.5162C6.13388 31.5344 6.17885 31.5612 6.21926 31.5976C6.37538 31.7391 6.39963 31.9711 6.28646 32.141Z",
    fill: "url(#paint15_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48862 16.4715C6.27541 16.427 6.06675 16.564 6.02229 16.7773C5.97783 16.9907 6.11475 17.1994 6.32796 17.2439C6.54116 17.2884 6.74982 17.1514 6.79428 16.9381C6.83874 16.7248 6.70182 16.516 6.48862 16.4715ZM6.46891 16.5342C6.57501 16.5564 6.65837 16.6277 6.70031 16.7192L6.5351 16.7738C6.51388 16.7415 6.48003 16.7172 6.4391 16.7086C6.39869 16.7 6.35877 16.7086 6.32644 16.7293L6.18851 16.6065C6.26329 16.5428 6.36534 16.513 6.46841 16.5342H6.46891ZM6.39313 16.9315C6.35221 16.9229 6.32644 16.883 6.33503 16.8426C6.34362 16.8016 6.38353 16.7758 6.42395 16.7844C6.46487 16.793 6.49064 16.833 6.48205 16.8734C6.47346 16.9138 6.43355 16.9401 6.39313 16.9315ZM6.0804 16.7895C6.08949 16.7455 6.10717 16.7051 6.13142 16.6702L6.27086 16.7945C6.26632 16.8046 6.26228 16.8153 6.25975 16.8269C6.2456 16.8946 6.27945 16.9603 6.33705 16.9912L6.30017 17.1686C6.14304 17.1175 6.04604 16.9548 6.0804 16.7895ZM6.72355 16.9234C6.6902 17.0847 6.54369 17.1934 6.38404 17.1843L6.42041 17.0089C6.48559 17.0033 6.54268 16.9563 6.55682 16.8891C6.55884 16.8779 6.55985 16.8673 6.55985 16.8567L6.72506 16.8021C6.73163 16.8415 6.73163 16.8825 6.72304 16.9239L6.72355 16.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97348 7.50033C7.76028 7.45584 7.55162 7.59283 7.50716 7.80616C7.4627 8.01948 7.59961 8.22825 7.81282 8.27273C8.02602 8.31722 8.23468 8.18023 8.27914 7.9669C8.3236 7.75358 8.18668 7.54481 7.97348 7.50033ZM7.95378 7.56301C8.05987 7.58525 8.14324 7.65653 8.18517 7.74802L8.01996 7.80262C7.99874 7.77026 7.96489 7.746 7.92397 7.73741C7.88355 7.72881 7.84364 7.73741 7.8113 7.75813L7.67338 7.6353C7.74815 7.5716 7.85021 7.54178 7.95327 7.56301H7.95378ZM7.87799 7.95983C7.83707 7.95123 7.8113 7.9113 7.81989 7.87086C7.82848 7.82991 7.86839 7.80413 7.90881 7.81273C7.94973 7.82132 7.9755 7.86125 7.96691 7.90169C7.95832 7.94264 7.91841 7.96842 7.87799 7.95983ZM7.56526 7.81778C7.57435 7.7738 7.59204 7.73336 7.61629 7.69848L7.75573 7.82284C7.75118 7.83295 7.74714 7.84356 7.74461 7.85519C7.73047 7.92293 7.76432 7.98864 7.82191 8.01948L7.78503 8.19691C7.62791 8.14585 7.5309 7.98308 7.56526 7.81778ZM8.20841 7.95174C8.17507 8.11299 8.02855 8.22168 7.8689 8.21258L7.90528 8.03717C7.97095 8.03161 8.02754 7.9846 8.04169 7.91737C8.04421 7.90624 8.04472 7.89563 8.04472 7.88501L8.20993 7.83042C8.21649 7.86985 8.21649 7.91079 8.2079 7.95225L8.20841 7.95174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53842 8.04879C5.32522 8.0043 5.11656 8.14129 5.0721 8.35462C5.02764 8.56794 5.16456 8.77671 5.37776 8.8212C5.59097 8.86568 5.79962 8.72869 5.84408 8.51537C5.88854 8.30204 5.75163 8.09327 5.53842 8.04879ZM5.51872 8.11198C5.62482 8.13422 5.70818 8.20549 5.75011 8.29699L5.5849 8.35158C5.56368 8.31923 5.52983 8.29497 5.48891 8.28637C5.44849 8.27778 5.40858 8.28637 5.37624 8.3071L5.23832 8.18426C5.31309 8.12057 5.41515 8.09074 5.51821 8.11198H5.51872ZM5.44293 8.50879C5.40201 8.5002 5.37624 8.46027 5.38483 8.41983C5.39342 8.37888 5.43334 8.3531 5.47375 8.36169C5.51417 8.37029 5.54044 8.41022 5.53185 8.45066C5.52327 8.49161 5.48335 8.51739 5.44293 8.50879ZM5.1302 8.36675C5.13929 8.32277 5.15698 8.28233 5.18123 8.24745L5.32067 8.3718C5.31612 8.38191 5.31208 8.39253 5.30955 8.40416C5.29541 8.47189 5.32926 8.53761 5.38685 8.56844L5.34997 8.74588C5.19285 8.69482 5.09584 8.53205 5.1302 8.36675ZM5.77335 8.50071C5.74001 8.66196 5.59349 8.77064 5.43384 8.76155L5.47022 8.58614C5.5359 8.58058 5.59248 8.53356 5.60663 8.46633C5.60865 8.45521 5.60966 8.4446 5.60966 8.43398L5.77487 8.37939C5.78144 8.41882 5.78144 8.45976 5.77285 8.50121L5.77335 8.50071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5501 8.93245C10.3647 8.8642 10.1586 8.95974 10.0904 9.14526C10.0222 9.33129 10.1177 9.53703 10.3031 9.60527C10.489 9.67351 10.6946 9.57797 10.7628 9.39245C10.8311 9.20643 10.7356 9.00069 10.5501 8.93245ZM10.5239 8.98603C10.6163 9.0199 10.681 9.09522 10.7068 9.18317L10.5517 9.20997C10.537 9.17812 10.5097 9.15183 10.4739 9.13869C10.4385 9.12555 10.4016 9.12807 10.3698 9.14223L10.2627 9.01383C10.338 8.96682 10.4334 8.95267 10.5234 8.98552L10.5239 8.98603ZM10.4031 9.3328C10.3678 9.31966 10.3496 9.28074 10.3627 9.24485C10.3758 9.20946 10.4153 9.19126 10.4506 9.20441C10.486 9.21755 10.5042 9.25698 10.491 9.29236C10.4779 9.32775 10.439 9.34595 10.4031 9.3328ZM10.1409 9.16397C10.1551 9.12555 10.1763 9.09168 10.2026 9.06337L10.3112 9.19379C10.3056 9.20238 10.3006 9.21148 10.297 9.22159C10.2728 9.28731 10.3021 9.35858 10.3617 9.39043L10.3284 9.55017C10.3248 9.54916 10.3213 9.54865 10.3182 9.54764C10.1636 9.49103 10.0838 9.31915 10.1409 9.16447V9.16397ZM10.4051 9.56382L10.438 9.40661C10.49 9.40206 10.5375 9.3692 10.5562 9.31663C10.5597 9.30702 10.5618 9.29742 10.5633 9.28781L10.7189 9.26102C10.7194 9.29691 10.7143 9.33381 10.7012 9.37021C10.6547 9.49659 10.5325 9.57089 10.4051 9.56432V9.56382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.62 4.21915C13.424 4.17821 13.232 4.30408 13.1911 4.50021C13.1501 4.69635 13.2759 4.88844 13.472 4.92938C13.668 4.97033 13.86 4.84446 13.9009 4.64832C13.9418 4.45219 13.816 4.2601 13.62 4.21915ZM13.6023 4.27678C13.6998 4.297 13.7766 4.36271 13.8155 4.44713L13.664 4.49718C13.6443 4.46735 13.6134 4.44511 13.5755 4.43702C13.5382 4.42944 13.5018 4.43702 13.472 4.45623L13.3452 4.343C13.4139 4.28436 13.5078 4.25706 13.6028 4.27678H13.6023ZM13.5321 4.64175C13.4947 4.63417 13.4705 4.59727 13.4785 4.55986C13.4866 4.52245 13.523 4.49819 13.5604 4.50628C13.5978 4.51437 13.622 4.55076 13.6139 4.58817C13.6064 4.62558 13.5695 4.64984 13.5321 4.64175ZM13.2446 4.51133C13.2532 4.47089 13.2694 4.43399 13.2916 4.40164L13.4194 4.51588C13.4154 4.52549 13.4119 4.53509 13.4093 4.54571C13.3962 4.60788 13.427 4.66854 13.4806 4.69685L13.4467 4.86013C13.3022 4.81312 13.2128 4.66349 13.2446 4.51133ZM13.8362 4.63467C13.8054 4.78279 13.671 4.88288 13.524 4.87479L13.5574 4.71303C13.6175 4.70797 13.67 4.66501 13.6827 4.60283C13.6847 4.59272 13.6857 4.58261 13.6857 4.573L13.8378 4.52296C13.8438 4.55885 13.8438 4.59676 13.8357 4.63467H13.8362Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54446 26.1296C2.33833 26.0866 2.13573 26.219 2.09329 26.4258C2.05035 26.632 2.18272 26.8347 2.38935 26.8772C2.59548 26.9202 2.79808 26.7877 2.84052 26.581C2.88346 26.3747 2.75109 26.172 2.54446 26.1296ZM2.52526 26.1907C2.62832 26.2119 2.70865 26.2812 2.74958 26.3702L2.58993 26.4227C2.56921 26.3914 2.53688 26.3676 2.49697 26.3596C2.45756 26.3515 2.41916 26.3596 2.38784 26.3798L2.25446 26.2605C2.3267 26.1988 2.42522 26.17 2.52576 26.1907H2.52526ZM2.4515 26.5749C2.41209 26.5668 2.38683 26.5279 2.39491 26.4885C2.40299 26.449 2.4419 26.4238 2.4813 26.4318C2.52071 26.4399 2.54597 26.4789 2.53789 26.5183C2.52981 26.5577 2.4909 26.583 2.4515 26.5749ZM2.14887 26.4374C2.15796 26.3944 2.17463 26.3555 2.19838 26.3216L2.33327 26.442C2.32873 26.4516 2.32519 26.4622 2.32266 26.4733C2.30902 26.5385 2.34136 26.6027 2.39744 26.6325L2.36157 26.8044C2.20949 26.7549 2.11552 26.5976 2.14887 26.4369V26.4374ZM2.77181 26.5673C2.73947 26.7235 2.59751 26.8287 2.44291 26.8201L2.47827 26.6502C2.54143 26.6452 2.597 26.5997 2.61064 26.534C2.61266 26.5233 2.61367 26.5127 2.61367 26.5026L2.77383 26.4495C2.7804 26.4874 2.7804 26.5274 2.77181 26.5673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13923 25.5144C4.95179 25.4755 4.76789 25.5958 4.72899 25.7833C4.69009 25.9709 4.81033 26.1549 4.99777 26.1938C5.18521 26.2327 5.36911 26.1124 5.40801 25.9249C5.44691 25.7373 5.32667 25.5533 5.13923 25.5144ZM5.12155 25.57C5.21502 25.5897 5.28777 25.6524 5.32465 25.7333L5.18016 25.7808C5.16146 25.7525 5.13165 25.7307 5.09578 25.7232C5.05991 25.7156 5.02505 25.7232 4.99676 25.7414L4.87601 25.6337C4.94169 25.5776 5.03061 25.5508 5.12205 25.5695L5.12155 25.57ZM5.05486 25.9193C5.01899 25.9117 4.99625 25.8768 5.00333 25.8409C5.0109 25.8051 5.04577 25.7823 5.08164 25.7894C5.11751 25.797 5.14024 25.8318 5.13317 25.8677C5.12559 25.9036 5.09073 25.9264 5.05486 25.9193ZM4.77951 25.7944C4.7876 25.7555 4.80326 25.7201 4.82448 25.6893L4.94674 25.7985C4.9427 25.8076 4.93916 25.8167 4.93714 25.8268C4.92502 25.8864 4.95432 25.9441 5.00535 25.9714L4.97301 26.1266C4.83509 26.0816 4.7492 25.9395 4.77951 25.7939V25.7944ZM5.34587 25.9122C5.31657 26.0543 5.18773 26.1488 5.04728 26.1412L5.07911 25.9875C5.13671 25.983 5.18672 25.9415 5.19935 25.8819C5.20137 25.8723 5.20188 25.8627 5.20188 25.8536L5.34688 25.8056C5.35294 25.8399 5.35294 25.8763 5.34536 25.9127L5.34587 25.9122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47121 31.0243C2.26508 30.9814 2.06249 31.1138 2.02005 31.3205C1.9771 31.5268 2.10947 31.7295 2.31611 31.772C2.52224 31.8149 2.72484 31.6825 2.76728 31.4757C2.81022 31.2695 2.67785 31.0668 2.47121 31.0243ZM2.45202 31.0855C2.55508 31.1067 2.63541 31.176 2.67634 31.2649L2.51668 31.3175C2.49597 31.2862 2.46364 31.2624 2.42372 31.2543C2.38432 31.2462 2.34592 31.2543 2.31459 31.2745L2.18122 31.1552C2.25346 31.0936 2.35249 31.0648 2.45252 31.0855H2.45202ZM2.37876 31.4697C2.33935 31.4616 2.31409 31.4227 2.32217 31.3832C2.33026 31.3438 2.36916 31.3185 2.40857 31.3266C2.44797 31.3347 2.47324 31.3736 2.46515 31.4131C2.45707 31.4525 2.41817 31.4778 2.37876 31.4697ZM2.07613 31.3322C2.08522 31.2892 2.1019 31.2503 2.12564 31.2164L2.26054 31.3367C2.25599 31.3463 2.25245 31.3569 2.24993 31.3681C2.23628 31.4333 2.26862 31.4975 2.3247 31.5273L2.28883 31.6992C2.13676 31.6496 2.04278 31.4924 2.07613 31.3317V31.3322ZM2.69907 31.4621C2.66674 31.6183 2.52477 31.7234 2.37017 31.7148L2.40554 31.545C2.46869 31.5399 2.52426 31.4944 2.5379 31.4287C2.53993 31.4181 2.54094 31.4075 2.54094 31.3974L2.70109 31.3443C2.70766 31.3822 2.70715 31.4222 2.69907 31.4621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70341 33.2137C6.49677 33.1707 6.29468 33.3031 6.25174 33.5099C6.20879 33.7161 6.34116 33.9188 6.5478 33.9613C6.75393 34.0043 6.95653 33.8718 6.99897 33.6651C7.04191 33.4588 6.90954 33.2561 6.7029 33.2137H6.70341ZM6.68421 33.2743C6.78728 33.2955 6.86761 33.3648 6.90853 33.4538L6.74888 33.5063C6.72817 33.475 6.69583 33.4512 6.65592 33.4432C6.61651 33.4351 6.57811 33.4432 6.54679 33.4634L6.41341 33.3441C6.48566 33.2824 6.58468 33.2536 6.68472 33.2743H6.68421ZM6.61045 33.6585C6.57104 33.6504 6.54578 33.6115 6.55386 33.5721C6.56195 33.5326 6.60085 33.5074 6.64026 33.5154C6.67966 33.5235 6.70492 33.5625 6.69684 33.6019C6.68876 33.6413 6.64986 33.6666 6.61045 33.6585ZM6.30782 33.521C6.31691 33.478 6.33358 33.4391 6.35733 33.4052L6.49223 33.5256C6.48768 33.5352 6.48414 33.5458 6.48162 33.5569C6.46797 33.6221 6.50031 33.6863 6.55639 33.7161L6.52052 33.888C6.36845 33.8385 6.27447 33.6812 6.30782 33.5205V33.521ZM6.93076 33.6509C6.89843 33.8071 6.75646 33.9123 6.60186 33.9037L6.63722 33.7338C6.70038 33.7288 6.75595 33.6833 6.76959 33.6176C6.77161 33.6069 6.77263 33.5963 6.77263 33.5862L6.93278 33.5331C6.93935 33.571 6.93884 33.611 6.93076 33.6509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4484 30.5693C14.2503 30.5279 14.0563 30.6553 14.0149 30.8534C13.9735 31.0516 14.1008 31.2457 14.2988 31.2872C14.4969 31.3286 14.6909 31.2012 14.7323 31.0031C14.7737 30.8049 14.6464 30.6108 14.4484 30.5693ZM14.4302 30.628C14.5292 30.6487 14.6065 30.7149 14.6454 30.7999L14.4918 30.8504C14.4721 30.8201 14.4408 30.7978 14.4024 30.7897C14.365 30.7817 14.3276 30.7897 14.2978 30.809L14.1695 30.6947C14.2387 30.6356 14.3337 30.6078 14.4297 30.628H14.4302ZM14.3595 30.9965C14.3216 30.9884 14.2973 30.9515 14.3054 30.9136C14.3135 30.8757 14.3504 30.8514 14.3883 30.8595C14.4262 30.8676 14.4504 30.9045 14.4423 30.9424C14.4342 30.9803 14.3974 31.0046 14.3595 30.9965ZM14.069 30.8646C14.0775 30.8236 14.0937 30.7862 14.1165 30.7539L14.2458 30.8696C14.2412 30.8792 14.2377 30.8888 14.2357 30.8994C14.2225 30.9621 14.2539 31.0233 14.3074 31.0521L14.2731 31.2174C14.1271 31.1699 14.0371 31.0187 14.069 30.8646ZM14.6666 30.9894C14.6353 31.1396 14.4994 31.2401 14.3514 31.2321L14.3852 31.0688C14.4459 31.0637 14.4989 31.0203 14.512 30.9571C14.5141 30.947 14.5151 30.9368 14.5151 30.9267L14.6687 30.8762C14.6747 30.9126 14.6747 30.951 14.6666 30.9894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5156 18.2155C14.309 18.1725 14.1069 18.305 14.0645 18.5117C14.0215 18.718 14.1539 18.9207 14.3605 18.9631C14.5672 19.0061 14.7693 18.8737 14.8122 18.6669C14.8552 18.4607 14.7228 18.2579 14.5162 18.2155H14.5156ZM14.4964 18.2761C14.5995 18.2974 14.6798 18.3666 14.7208 18.4556L14.5611 18.5082C14.5404 18.4768 14.5081 18.4531 14.4682 18.445C14.4287 18.4369 14.3904 18.445 14.359 18.4652L14.2256 18.3459C14.2979 18.2842 14.3969 18.2554 14.497 18.2761H14.4964ZM14.4232 18.6603C14.3838 18.6522 14.3585 18.6133 14.3666 18.5739C14.3747 18.5345 14.4136 18.5092 14.453 18.5173C14.4924 18.5254 14.5177 18.5643 14.5096 18.6037C14.5015 18.6431 14.4626 18.6684 14.4232 18.6603ZM14.1201 18.5228C14.1291 18.4799 14.1458 18.4409 14.1696 18.4071L14.3045 18.5274C14.2999 18.537 14.2964 18.5476 14.2939 18.5587C14.2802 18.6239 14.3125 18.6881 14.3686 18.718L14.3328 18.8898C14.1807 18.8403 14.0867 18.6831 14.1201 18.5223V18.5228ZM14.7435 18.6527C14.7112 18.8089 14.5692 18.9141 14.4146 18.9055L14.45 18.7357C14.5131 18.7306 14.5687 18.6851 14.5823 18.6194C14.5844 18.6088 14.5854 18.5982 14.5854 18.588L14.7455 18.535C14.7521 18.5729 14.7516 18.6128 14.7435 18.6527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75406 11.5105L8.53731 11.5003L8.53277 11.6045C8.53479 11.5458 8.53479 11.4867 8.53176 11.4265C8.52873 11.3725 8.52367 11.3189 8.5166 11.2658L8.52771 11.3487L8.74294 11.3204C8.7975 11.3133 8.8359 11.2633 8.82832 11.2087L8.82681 11.1965C8.81973 11.1419 8.76972 11.1035 8.71515 11.1111L8.49993 11.1394L8.51003 11.2147C8.49892 11.144 8.48426 11.0742 8.46608 11.006L8.66817 10.9418C8.72071 10.9251 8.74951 10.869 8.73284 10.8169L8.7293 10.8053C8.71263 10.7527 8.65655 10.7239 8.60451 10.7406L8.40141 10.8053C8.38928 10.7739 8.37665 10.7431 8.36352 10.7123L8.5555 10.6172C8.60451 10.593 8.62472 10.5328 8.60047 10.4838L8.59491 10.4727C8.57066 10.4236 8.51054 10.4034 8.46153 10.4277L8.26853 10.5237C8.24327 10.4797 8.217 10.4363 8.18871 10.3948L8.35846 10.2689C8.40242 10.2361 8.41202 10.1739 8.37918 10.1294L8.37211 10.1198C8.33927 10.0758 8.27712 10.0662 8.23266 10.0991L8.06139 10.226C8.02906 10.1876 7.99521 10.1507 7.96035 10.1148L8.10585 9.95907C8.14324 9.91914 8.14122 9.85595 8.1013 9.81854L8.09221 9.81045C8.0523 9.77305 7.98915 9.77507 7.95176 9.815L7.80575 9.9712C7.76685 9.93835 7.72643 9.90751 7.685 9.87769L7.69814 9.88628L7.81686 9.70481C7.84718 9.6588 7.83404 9.59713 7.78807 9.5668L7.77796 9.56023C7.73199 9.5299 7.67035 9.54304 7.64003 9.58904L7.52131 9.77052L7.53596 9.78013C7.48341 9.74878 7.42936 9.71997 7.37429 9.69368L7.45714 9.49452C7.47836 9.44397 7.45411 9.38533 7.40359 9.3646L7.39247 9.36005C7.34195 9.33882 7.28335 9.36309 7.26263 9.41364L7.17977 9.61331C7.1343 9.59713 7.08782 9.58247 7.04033 9.56984L7.08631 9.36056C7.09793 9.30697 7.06408 9.2539 7.01052 9.24176L6.9989 9.23924C6.94535 9.22761 6.8923 9.26148 6.88018 9.31506L6.8337 9.52434C6.78166 9.51575 6.72911 9.50918 6.67657 9.50463L6.68415 9.29232C6.68617 9.23722 6.64323 9.19121 6.58816 9.18919H6.57603C6.52096 9.18667 6.47499 9.22963 6.47297 9.28473L6.46539 9.49755C6.44265 9.49755 6.41941 9.49805 6.39668 9.49907C6.37647 9.50008 6.35626 9.5021 6.33605 9.50362L6.30725 9.29434C6.29967 9.23974 6.24966 9.20183 6.19509 9.20941L6.18297 9.21093C6.1284 9.21851 6.09051 9.26856 6.09809 9.32315L6.12638 9.53192C6.08495 9.53951 6.04403 9.5481 6.00361 9.55821L5.94197 9.35955C5.92581 9.30697 5.86973 9.27766 5.81718 9.29383L5.80556 9.29737C5.75302 9.31355 5.72372 9.36966 5.73988 9.42223L5.80152 9.61988C5.75302 9.63757 5.70553 9.65729 5.65905 9.67852L5.56407 9.49603C5.5388 9.4475 5.47868 9.4283 5.42968 9.45357L5.41907 9.45913C5.37056 9.48441 5.35137 9.54456 5.37663 9.59359L5.47161 9.77557C5.43422 9.79731 5.39734 9.82006 5.36198 9.84432L5.23971 9.68256C5.20637 9.63858 5.14422 9.62999 5.10027 9.66335L5.09067 9.67043C5.04671 9.70379 5.03813 9.76597 5.07147 9.80995L5.19374 9.97171C5.1518 10.0071 5.11088 10.0445 5.07198 10.0829L4.92344 9.94745C4.88302 9.91054 4.81987 9.91307 4.78299 9.95402L4.7749 9.96312C4.73802 10.0036 4.74055 10.0667 4.78147 10.1036L4.9295 10.2391C4.89818 10.277 4.86888 10.3165 4.84008 10.3569L4.67133 10.2502C4.62485 10.2209 4.56321 10.2346 4.53391 10.2811L4.52734 10.2912C4.49804 10.3377 4.51168 10.3994 4.55816 10.4287L4.7264 10.5353C4.70417 10.5748 4.68295 10.6147 4.66325 10.6557L4.48137 10.5798C4.43085 10.5586 4.37224 10.5829 4.35102 10.6334L4.34647 10.6445C4.32525 10.6951 4.3495 10.7537 4.40003 10.775L4.58241 10.8513C4.56675 10.8958 4.5526 10.9413 4.53997 10.9873L4.34849 10.9438C4.29494 10.9317 4.24139 10.9655 4.22926 11.0191L4.22673 11.0307C4.21461 11.0843 4.24846 11.1379 4.30201 11.15L4.494 11.1935C4.48592 11.2425 4.47935 11.2921 4.4743 11.3421L4.27928 11.333C4.22421 11.3305 4.17773 11.373 4.1752 11.4281V11.4402C4.17217 11.4953 4.21461 11.5418 4.26968 11.5443L4.46571 11.5534C4.46571 11.5812 4.46621 11.6085 4.46773 11.6363C4.46874 11.6591 4.47126 11.6818 4.47278 11.7046L4.27978 11.7304C4.22522 11.7374 4.18682 11.7875 4.1944 11.8421L4.19592 11.8542C4.20299 11.9088 4.25301 11.9472 4.30757 11.9396L4.50158 11.9138C4.51067 11.9629 4.52179 12.0114 4.53442 12.0589L4.3495 12.1176C4.29696 12.1342 4.26816 12.1904 4.28484 12.2424L4.28837 12.2541C4.30504 12.3066 4.36112 12.3354 4.41316 12.3188L4.59909 12.2596C4.61121 12.291 4.62384 12.3223 4.63748 12.3531L4.46369 12.4391C4.41468 12.4633 4.39447 12.5235 4.41872 12.5725L4.42428 12.5836C4.44853 12.6327 4.50865 12.6529 4.55766 12.6286L4.73297 12.5417C4.75823 12.5857 4.784 12.6286 4.81229 12.6701L4.65618 12.7858C4.61222 12.8187 4.60262 12.8809 4.63546 12.9254L4.64253 12.935C4.67537 12.9789 4.73752 12.9885 4.78198 12.9557L4.93961 12.8389C4.97396 12.8799 5.00983 12.9193 5.04722 12.9572L4.91384 13.1003C4.87645 13.1402 4.87848 13.2034 4.91839 13.2408L4.92748 13.2489C4.96739 13.2863 5.03055 13.2843 5.06793 13.2443L5.20283 13.1003C5.2387 13.1301 5.27659 13.1584 5.31448 13.1862L5.20687 13.351C5.17656 13.397 5.18969 13.4587 5.23567 13.489L5.24577 13.4956C5.29175 13.5259 5.35339 13.5128 5.3837 13.4668L5.49283 13.3004C5.54184 13.3282 5.59185 13.3545 5.64339 13.3783L5.5676 13.5608C5.54638 13.6113 5.57063 13.67 5.62116 13.6907L5.63227 13.6952C5.68279 13.7165 5.7414 13.6922 5.76211 13.6417L5.83891 13.4566C5.88539 13.4728 5.93288 13.4875 5.98088 13.5001L5.93793 13.6947C5.92631 13.7483 5.96016 13.8014 6.01372 13.8135L6.02534 13.8161C6.07889 13.8277 6.13194 13.7938 6.14406 13.7402L6.18751 13.5431C6.24006 13.5512 6.29361 13.5567 6.34716 13.5608L6.34009 13.763C6.33807 13.8181 6.38101 13.8641 6.43608 13.8661H6.44821C6.50328 13.8686 6.54925 13.8257 6.55128 13.7706L6.55835 13.5658C6.5735 13.5658 6.58816 13.5658 6.60331 13.5648C6.63413 13.5633 6.66495 13.5608 6.69577 13.5577L6.72457 13.7701C6.73215 13.8246 6.78216 13.8626 6.83673 13.8555L6.84885 13.854C6.90342 13.8464 6.94131 13.7963 6.93424 13.7417L6.90493 13.5274C6.94586 13.5193 6.98627 13.5097 7.02619 13.4991L7.09035 13.7059C7.10652 13.7584 7.1626 13.7877 7.21514 13.7716L7.22676 13.768C7.2793 13.7519 7.30861 13.6957 7.29244 13.6432L7.22828 13.4359L7.20605 13.443C7.26566 13.4208 7.32427 13.396 7.38136 13.3687L7.36519 13.3773L7.46523 13.5699C7.49049 13.6184 7.55061 13.6376 7.59962 13.6123L7.61023 13.6068C7.65873 13.5815 7.67793 13.5213 7.65267 13.4723L7.55263 13.2797L7.49099 13.3116C7.54808 13.2797 7.60366 13.2448 7.65721 13.2079L7.78402 13.3758C7.81737 13.4197 7.87951 13.4283 7.92347 13.395L7.93306 13.3879C7.97702 13.3545 7.98561 13.2924 7.95226 13.2484L7.82394 13.0785C7.86537 13.0426 7.90629 13.0057 7.94469 12.9668L8.09928 13.1078C8.1397 13.1447 8.20286 13.1422 8.23974 13.1013L8.24782 13.0922C8.2847 13.0517 8.28218 12.9885 8.24125 12.9516L8.08463 12.8086C8.11343 12.7727 8.14071 12.7358 8.16749 12.6979L8.34735 12.8121C8.39383 12.8414 8.45547 12.8278 8.48477 12.7813L8.49134 12.7712C8.52064 12.7247 8.507 12.663 8.46052 12.6337L8.27965 12.5189C8.30238 12.478 8.3236 12.436 8.34381 12.3936L8.54287 12.4765C8.59339 12.4977 8.652 12.4734 8.67322 12.4229L8.67777 12.4118C8.69899 12.3612 8.67474 12.3026 8.62421 12.2813L8.42364 12.1979L8.41758 12.2121C8.43526 12.1626 8.45092 12.112 8.46456 12.0604L8.46355 12.0645L8.67524 12.1125C8.72879 12.1246 8.78235 12.0908 8.79447 12.0372L8.797 12.0256C8.80912 11.972 8.77527 11.9184 8.72172 11.9063L8.51003 11.8582L8.49942 11.9058C8.51458 11.8249 8.52468 11.742 8.52974 11.6581L8.52721 11.7132L8.74395 11.7233C8.79902 11.7258 8.8455 11.6833 8.84803 11.6282V11.6161C8.85106 11.561 8.80862 11.5145 8.75355 11.512L8.75406 11.5105ZM6.573 12.9547C5.78737 12.9951 5.11745 12.39 5.07753 11.604C5.03712 10.8179 5.64187 10.1476 6.42749 10.1077C7.21312 10.0673 7.88305 10.6723 7.92296 11.4584C7.96338 12.2444 7.35862 12.9147 6.573 12.9547Z",
    fill: "url(#paint16_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25963 11.245C6.94185 11.1788 6.63113 11.383 6.56495 11.7005C6.49877 12.0184 6.70288 12.3293 7.02016 12.3955C7.33794 12.4618 7.64866 12.2575 7.71484 11.9401C7.78103 11.6221 7.57692 11.3112 7.25963 11.245ZM6.97873 12.2838C6.7443 12.2075 6.60032 11.9653 6.65134 11.7187C6.66498 11.6529 6.69126 11.5928 6.72713 11.5407L6.93477 11.7257C6.9277 11.7409 6.92214 11.7571 6.91861 11.7738C6.89789 11.8744 6.9474 11.9724 7.0338 12.0189L6.97873 12.2838ZM7.03026 11.7975C7.04289 11.7369 7.102 11.6979 7.16263 11.7106C7.22326 11.7232 7.26216 11.7824 7.24953 11.843C7.2369 11.9037 7.17779 11.9426 7.11716 11.93C7.05653 11.9173 7.01763 11.8582 7.03026 11.7975ZM7.61026 11.9178C7.56024 12.1579 7.34199 12.3197 7.10453 12.3066L7.15909 12.0447C7.2566 12.0366 7.34148 11.9669 7.3627 11.8658C7.36624 11.8496 7.36725 11.8334 7.36725 11.8172L7.6138 11.7359C7.6239 11.7945 7.6234 11.8557 7.61077 11.9173L7.61026 11.9178ZM7.32935 11.6954C7.29753 11.6469 7.24751 11.611 7.18638 11.5979C7.12625 11.5852 7.06664 11.5978 7.01864 11.6292L6.81352 11.4457C6.92467 11.3507 7.07674 11.3062 7.23084 11.3385C7.38897 11.3714 7.51326 11.478 7.5759 11.6145L7.32986 11.6959L7.32935 11.6954Z",
    fill: "url(#paint17_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43669 12.1363H6.37707C6.37253 12.1186 6.36596 12.1019 6.35737 12.0862L6.3993 12.0448C6.42406 12.02 6.42456 11.9796 6.3993 11.9543C6.37455 11.9295 6.33413 11.929 6.30887 11.9543L6.26744 11.9952C6.25178 11.9861 6.2346 11.9791 6.21641 11.974V11.9159C6.21641 11.8805 6.18761 11.8522 6.15275 11.8522C6.11789 11.8522 6.0891 11.881 6.0891 11.9159V11.974C6.07141 11.9791 6.05474 11.9861 6.03908 11.9947L5.99815 11.9533C5.9734 11.9285 5.93298 11.928 5.90822 11.9533C5.88347 11.978 5.88296 12.0185 5.90822 12.0438L5.94965 12.0857C5.94106 12.1014 5.9345 12.1181 5.92944 12.1358H5.86983C5.83446 12.1358 5.80617 12.1641 5.80566 12.1995C5.80566 12.2348 5.83396 12.2631 5.86932 12.2637H5.92995C5.935 12.2808 5.94157 12.297 5.95016 12.3122L5.90721 12.3551C5.88246 12.3799 5.88195 12.4204 5.90721 12.4456C5.93248 12.4709 5.97239 12.4709 5.99765 12.4456L6.0411 12.4022C6.05626 12.4108 6.07242 12.4173 6.0896 12.4219V12.4835C6.0896 12.5189 6.1184 12.5472 6.15326 12.5472C6.18812 12.5472 6.21692 12.5184 6.21692 12.4835V12.4219C6.23359 12.4173 6.24976 12.4108 6.26441 12.4027L6.30786 12.4461C6.33261 12.4709 6.37303 12.4714 6.39829 12.4461C6.42305 12.4214 6.42355 12.3809 6.39829 12.3562L6.35535 12.3132C6.36394 12.298 6.37101 12.2818 6.37606 12.2647H6.43669C6.47206 12.2647 6.50035 12.2364 6.50085 12.201C6.50085 12.1656 6.47256 12.1373 6.4372 12.1368L6.43669 12.1363ZM6.15326 12.3299C6.08051 12.3299 6.02139 12.2707 6.02139 12.1979C6.02139 12.1251 6.08051 12.066 6.15326 12.066C6.22601 12.066 6.28512 12.1251 6.28512 12.1979C6.28512 12.2707 6.22601 12.3299 6.15326 12.3299Z",
    fill: "url(#paint18_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2493 11.3562L12.1088 11.337L12.1043 11.3684C12.1094 11.3148 12.1119 11.2607 12.1104 11.2056L12.1119 11.2415L12.2533 11.2359C12.2892 11.2344 12.317 11.2041 12.316 11.1682V11.1601C12.3145 11.1242 12.2842 11.0964 12.2483 11.0979L12.1068 11.1035L12.1094 11.1717C12.1073 11.1333 12.1043 11.0949 12.0987 11.056C12.0942 11.0211 12.0876 10.9867 12.08 10.9523L12.0917 11.0054L12.2301 10.9751C12.265 10.9675 12.2872 10.9326 12.2796 10.8977L12.2781 10.8902C12.2705 10.8553 12.2357 10.833 12.2008 10.8406L12.0624 10.871L12.073 10.9195C12.0619 10.874 12.0482 10.8295 12.0331 10.786L12.1609 10.733C12.1942 10.7193 12.2099 10.6814 12.1963 10.648L12.1932 10.641C12.1796 10.6076 12.1417 10.5919 12.1083 10.6056L11.98 10.6586C11.9704 10.6389 11.9603 10.6192 11.9502 10.6L12.0699 10.5272C12.1008 10.5085 12.1104 10.4686 12.0917 10.4377L12.0876 10.4312C12.0689 10.4003 12.029 10.3907 11.9982 10.4094L11.878 10.4827C11.8593 10.4554 11.8396 10.4286 11.8188 10.4029L11.9224 10.3114C11.9492 10.2876 11.9522 10.2467 11.9285 10.2194L11.9234 10.2133C11.8997 10.1865 11.8588 10.1835 11.8315 10.2072L11.7269 10.2992C11.7037 10.276 11.6799 10.2537 11.6552 10.2325L11.7415 10.1233C11.7638 10.095 11.7587 10.0541 11.7309 10.0318L11.7249 10.0268C11.6966 10.0045 11.6557 10.0096 11.6334 10.0374L11.547 10.1471C11.5198 10.1279 11.492 10.1102 11.4637 10.093L11.4728 10.098L11.54 9.97319C11.5571 9.94184 11.545 9.90191 11.5137 9.88523L11.5066 9.88169C11.4753 9.8645 11.4354 9.87663 11.4187 9.90798L11.3515 10.0328L11.3616 10.0384C11.3257 10.0212 11.2889 10.005 11.2515 9.99088L11.2944 9.85692C11.3055 9.82255 11.2863 9.78615 11.2525 9.77503L11.2449 9.7725C11.2106 9.76138 11.1742 9.78059 11.1631 9.81446L11.1201 9.94892C11.0893 9.94083 11.0585 9.93426 11.0272 9.9282L11.0459 9.78969C11.0504 9.7543 11.0256 9.72145 10.9898 9.71639L10.9817 9.71538C10.9463 9.71083 10.9135 9.7356 10.9084 9.77149L10.8897 9.9105C10.8554 9.90798 10.821 9.90646 10.7862 9.90646L10.7791 9.76795C10.7771 9.73206 10.7468 9.70426 10.7109 9.70628H10.7028C10.6669 9.7083 10.6391 9.73914 10.6412 9.77503L10.6482 9.91404C10.6336 9.91556 10.6184 9.91708 10.6038 9.9191C10.5906 9.92112 10.5775 9.92314 10.5644 9.92567L10.5341 9.7907C10.526 9.75582 10.4916 9.73358 10.4563 9.74167L10.4487 9.74318C10.4138 9.75127 10.3916 9.78564 10.3997 9.82103L10.4295 9.95499C10.4032 9.96206 10.3769 9.97015 10.3512 9.97875L10.3001 9.85288C10.2865 9.81951 10.2486 9.80384 10.2153 9.81699L10.2077 9.82002C10.1743 9.83367 10.1582 9.87158 10.1718 9.90494L10.2228 10.0303C10.192 10.0445 10.1627 10.0601 10.1334 10.0763L10.0617 9.96308C10.0425 9.93275 10.0021 9.92365 9.97175 9.94286L9.96518 9.9469C9.93486 9.96611 9.92577 10.0065 9.94497 10.0369L10.0167 10.1501C9.99347 10.1663 9.97124 10.183 9.94901 10.2007L9.8606 10.1021C9.83685 10.0753 9.79542 10.0733 9.76865 10.097L9.76258 10.1021C9.73581 10.1258 9.73378 10.1673 9.75753 10.1941L9.84594 10.2927C9.82068 10.3179 9.79593 10.3442 9.77269 10.3715L9.66861 10.2917C9.64032 10.2699 9.59939 10.275 9.57767 10.3038L9.57262 10.3099C9.55089 10.3382 9.55595 10.3791 9.58474 10.4008L9.68882 10.4807C9.67063 10.507 9.65345 10.5343 9.63729 10.5621L9.52159 10.5019C9.48976 10.4853 9.45035 10.4979 9.43368 10.5297L9.43014 10.5368C9.41347 10.5687 9.4261 10.6081 9.45793 10.6248L9.57363 10.6849C9.5615 10.7117 9.54988 10.739 9.53927 10.7668L9.4165 10.7274C9.38215 10.7163 9.34577 10.7355 9.33466 10.7694L9.33213 10.7769C9.32102 10.8113 9.34021 10.8477 9.37406 10.8588L9.49734 10.8983C9.48926 10.9281 9.48269 10.9584 9.47713 10.9892L9.35032 10.9716C9.31495 10.9665 9.28211 10.9913 9.27706 11.0272L9.27605 11.0352C9.271 11.0706 9.29576 11.1035 9.33163 11.1085L9.45894 11.1262C9.45642 11.1586 9.4549 11.1909 9.4544 11.2238L9.32708 11.2289C9.29121 11.2304 9.26342 11.2607 9.26443 11.2966V11.3047C9.26595 11.3406 9.29626 11.3684 9.33213 11.3674L9.46046 11.3623C9.46197 11.3805 9.46399 11.3982 9.46652 11.4164C9.46854 11.4311 9.47107 11.4457 9.47359 11.4604L9.34931 11.4877C9.31445 11.4953 9.29222 11.5301 9.2998 11.565L9.30131 11.5726C9.30889 11.6075 9.34375 11.6297 9.37861 11.6221L9.5034 11.5948C9.51199 11.6262 9.5221 11.657 9.53271 11.6873L9.41549 11.7359C9.38215 11.7495 9.36649 11.7874 9.38013 11.8208L9.38316 11.8284C9.3968 11.8617 9.43469 11.8774 9.46804 11.8638L9.58575 11.8152C9.59535 11.8349 9.60546 11.8547 9.61607 11.8739L9.50795 11.9396C9.47713 11.9583 9.46753 11.9982 9.48622 12.0291L9.49027 12.0356C9.50896 12.0665 9.54887 12.0761 9.57969 12.0574L9.68882 11.9911C9.70751 12.0184 9.72671 12.0447 9.74743 12.07L9.65244 12.1539C9.62567 12.1777 9.62264 12.2186 9.64638 12.2459L9.65143 12.252C9.67518 12.2788 9.7161 12.2818 9.74338 12.2581L9.83938 12.1736C9.86413 12.1984 9.88939 12.2222 9.91617 12.2444L9.83736 12.345C9.81513 12.3733 9.82018 12.4143 9.84797 12.4365L9.85403 12.4416C9.88232 12.4638 9.92324 12.4587 9.94547 12.4309L10.0253 12.3298C10.0506 12.3475 10.0763 12.3637 10.1026 12.3794L10.0415 12.4926C10.0243 12.5245 10.0364 12.5639 10.0677 12.5806L10.0748 12.5841C10.1066 12.6013 10.146 12.5897 10.1627 12.5578L10.2244 12.4436C10.2577 12.4592 10.2916 12.4734 10.3264 12.486L10.287 12.6094C10.2759 12.6438 10.2951 12.6801 10.3289 12.6913L10.3365 12.6938C10.3709 12.7049 10.4072 12.6857 10.4184 12.6513L10.4583 12.527C10.4896 12.5351 10.5209 12.5416 10.5533 12.5472L10.5361 12.6761C10.5315 12.7115 10.5563 12.7443 10.5922 12.7494L10.6002 12.7504C10.6356 12.755 10.6685 12.7302 10.6735 12.6943L10.6907 12.5639C10.7255 12.5664 10.7604 12.5669 10.7958 12.5664L10.8023 12.6983C10.8039 12.7342 10.8347 12.762 10.8705 12.76H10.8786C10.9145 12.758 10.9423 12.7272 10.9403 12.6913L10.9337 12.5578C10.9433 12.5568 10.9529 12.5558 10.963 12.5548C10.9832 12.5523 11.0029 12.5487 11.0226 12.5452L11.0529 12.6817C11.061 12.7165 11.0954 12.7388 11.1307 12.7307L11.1383 12.7292C11.1732 12.7211 11.1954 12.6867 11.1873 12.6513L11.1565 12.5133C11.1828 12.5058 11.2085 12.4972 11.2338 12.4881L11.2868 12.619C11.3005 12.6523 11.3384 12.6685 11.3717 12.6549L11.3793 12.6518C11.4126 12.6382 11.4288 12.6003 11.4152 12.5669L11.3616 12.4355L11.3475 12.441C11.3854 12.4234 11.4217 12.4041 11.4576 12.3829L11.4475 12.3895L11.5233 12.5093C11.5425 12.5396 11.5829 12.5487 11.6127 12.5295L11.6193 12.5255C11.6496 12.5063 11.6587 12.4658 11.6395 12.4355L11.5637 12.3157L11.5253 12.3399C11.5607 12.3162 11.595 12.2904 11.6279 12.2631L11.7198 12.3652C11.7441 12.392 11.785 12.394 11.8118 12.3703L11.8178 12.3652C11.8446 12.3415 11.8466 12.3 11.8229 12.2732L11.7299 12.1696C11.7552 12.1438 11.7794 12.1175 11.8022 12.0902L11.9108 12.1736C11.9391 12.1954 11.98 12.1903 12.0017 12.1615L12.0068 12.1554C12.0285 12.1271 12.0235 12.0862 11.9947 12.0644L11.885 11.98C11.9017 11.9553 11.9179 11.9295 11.9325 11.9037L12.0558 11.9679C12.0876 11.9846 12.127 11.9719 12.1437 11.9401L12.1472 11.933C12.1639 11.9012 12.1513 11.8617 12.1195 11.8451L11.9952 11.7804C12.0078 11.7526 12.0194 11.7242 12.03 11.6949L12.1644 11.7379C12.1988 11.749 12.2352 11.7298 12.2463 11.6959L12.2488 11.6884C12.2599 11.654 12.2407 11.6176 12.2069 11.6065L12.072 11.563L12.0689 11.5726C12.0775 11.5392 12.0851 11.5054 12.0912 11.4715V11.474L12.2311 11.4932C12.2665 11.4983 12.2993 11.4735 12.3044 11.4376L12.3054 11.4295C12.3104 11.3942 12.2857 11.3613 12.2498 11.3562H12.2493ZM10.9347 10.3174C11.3156 10.3806 11.6284 10.6784 11.6976 11.0757L11.353 11.0747C11.297 10.874 11.1368 10.7173 10.9347 10.6657V10.3174ZM10.6311 10.3184V10.6698C10.434 10.7254 10.2794 10.8811 10.2259 11.0792L9.86514 11.0782C9.93082 10.6971 10.2314 10.3847 10.6311 10.3184ZM10.6381 12.1554C10.2486 12.0943 9.9283 11.7889 9.86413 11.3815L10.2249 11.3825C10.2784 11.5847 10.4366 11.7435 10.6381 11.7975V12.1554ZM10.7902 11.5225C10.6301 11.5225 10.5002 11.3926 10.5002 11.2324C10.5002 11.0721 10.6301 10.9422 10.7902 10.9422C10.9504 10.9422 11.0802 11.0721 11.0802 11.2324C11.0802 11.3926 10.9504 11.5225 10.7902 11.5225ZM10.9418 12.1524V11.798C11.1449 11.7435 11.304 11.5827 11.3566 11.379L11.7016 11.38C11.642 11.7657 11.3424 12.0832 10.9418 12.1529V12.1524Z",
    fill: "url(#paint19_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75422 8.33036L4.68652 8.44763L4.83354 8.53205L4.90478 8.4082C4.926 8.36574 4.94469 8.32176 4.9644 8.27829L4.81081 8.20752C4.79212 8.24847 4.77443 8.29042 4.75422 8.33036Z",
    fill: "url(#paint20_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89502 8.00985L5.05366 8.0695C5.08347 7.97901 5.11631 7.88954 5.14309 7.79804L4.9799 7.75305C4.95464 7.83949 4.92281 7.92442 4.89502 8.00985Z",
    fill: "url(#paint21_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06849 7.27734L5.05182 7.41181C5.04879 7.43405 5.04677 7.4568 5.04323 7.47904L5.02808 7.54526L5.19429 7.57862L5.20996 7.50886C5.214 7.48561 5.21602 7.46185 5.21956 7.43809L5.23724 7.29605L5.069 7.27734H5.06849Z",
    fill: "url(#paint22_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80339 9.41821L3.68921 9.491L3.78015 9.63406L3.90039 9.55723C3.9398 9.53043 3.97618 9.49909 4.01407 9.47028L3.9105 9.33582C3.87463 9.36311 3.84027 9.39243 3.80339 9.41821Z",
    fill: "url(#paint23_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07666 9.19977L4.18933 9.32665C4.25753 9.26043 4.32927 9.19724 4.39445 9.12798L4.27117 9.01172C4.20953 9.07743 4.14133 9.13708 4.07666 9.19977Z",
    fill: "url(#paint24_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49348 8.74338C4.46721 8.78028 4.44246 8.81769 4.41113 8.85054L4.54249 8.95771C4.57533 8.92283 4.6016 8.8834 4.62939 8.84448L4.71225 8.72821L4.57179 8.63318L4.49298 8.74338H4.49348Z",
    fill: "url(#paint25_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45693 9.94038L2.32153 9.95049L2.33568 10.1193L2.47815 10.1082L2.61861 10.0834L2.58981 9.91663L2.45693 9.94038Z",
    fill: "url(#paint26_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80005 9.87418L2.84097 10.0385C2.93242 10.0117 3.02487 9.98843 3.11531 9.9581L3.05973 9.79785C2.97435 9.82667 2.88644 9.8484 2.80005 9.87418Z",
    fill: "url(#paint27_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38107 9.66336L3.32095 9.69419C3.30074 9.7043 3.27902 9.71138 3.2583 9.71997L3.32499 9.87567C3.34672 9.86657 3.36996 9.85899 3.39118 9.84837L3.45483 9.81602L3.58215 9.75081L3.50182 9.60168L3.38107 9.66336Z",
    fill: "url(#paint28_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9579 9.75131L0.896263 9.72351L0.830078 9.87971L0.895252 9.90903C0.917482 9.91813 0.940217 9.9247 0.962447 9.93279L1.09785 9.97879L1.14938 9.81753L1.02105 9.77406C0.999834 9.76648 0.978109 9.76041 0.957395 9.75182L0.9579 9.75131Z",
    fill: "url(#paint29_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48843 9.90496L1.35656 9.87463L1.31665 10.0394L1.45609 10.0713C1.47933 10.0758 1.50257 10.0829 1.52581 10.0859L1.59654 10.095L1.62181 9.92721L1.55461 9.91912C1.53238 9.91659 1.51066 9.90951 1.48843 9.90496Z",
    fill: "url(#paint30_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83347 9.95398L1.81982 10.1228C1.91481 10.1284 2.01029 10.1284 2.10528 10.1314L2.10376 9.96207C2.01383 9.95903 1.9234 9.95954 1.83296 9.95398H1.83347Z",
    fill: "url(#paint31_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06746 6.57524L5.2357 6.55451C5.22307 6.45999 5.20337 6.36647 5.1872 6.27295L5.02148 6.30884C5.03664 6.39781 5.05533 6.48627 5.06746 6.57575V6.57524Z",
    fill: "url(#paint32_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9299 5.97223C4.94354 6.01519 4.95466 6.05917 4.96729 6.10214L5.12997 6.05462C5.11683 6.00862 5.10471 5.96262 5.09006 5.91713L5.03751 5.78418L4.87988 5.84585L4.92939 5.97172L4.9299 5.97223Z",
    fill: "url(#paint33_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68201 5.4308C4.7007 5.46164 4.71687 5.49348 4.73304 5.52533L4.79467 5.64614L4.94776 5.57285L4.88258 5.44546C4.8649 5.41159 4.84772 5.37722 4.82802 5.34436L5.00586 5.23972L4.48901 4.93591L4.49356 5.54201L4.68251 5.4308H4.68201Z",
    fill: "url(#paint34_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54429 13.984L5.49023 13.9592L5.43213 14.0962L5.48922 14.122C5.50842 14.1301 5.52863 14.1356 5.54833 14.1427L5.66756 14.1832L5.71303 14.0411L5.60037 14.0032C5.58168 13.9966 5.56248 13.9911 5.54429 13.9835V13.984Z",
    fill: "url(#paint35_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01019 14.119L5.8945 14.0922L5.85913 14.2367L5.9814 14.2645C6.00211 14.2686 6.02181 14.2752 6.04303 14.2777L6.10518 14.2858L6.12741 14.1387L6.06829 14.1316C6.04859 14.1291 6.02939 14.1235 6.01019 14.1195V14.119Z",
    fill: "url(#paint36_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51167 13.2459L4.4753 13.1989L4.36011 13.2934L4.39901 13.3429C4.41265 13.3591 4.4273 13.3738 4.44195 13.3889L4.52835 13.4799L4.63444 13.3758L4.5526 13.2893C4.53896 13.2747 4.52481 13.261 4.51218 13.2459H4.51167Z",
    fill: "url(#paint37_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77137 13.5052L4.67285 13.617L4.76783 13.6994C4.79815 13.7282 4.83503 13.7494 4.86837 13.7747L4.95679 13.6549C4.92546 13.6306 4.8906 13.6109 4.86181 13.5836L4.77238 13.5052H4.77137Z",
    fill: "url(#paint38_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03003 13.888L5.24778 14.0133L5.31548 13.8804L5.10935 13.7621L5.03003 13.888Z",
    fill: "url(#paint39_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.955 12.1702C3.94994 12.151 3.94338 12.1323 3.93933 12.1131L3.92872 12.0544L3.78271 12.0843L3.79383 12.1459C3.79838 12.1662 3.80494 12.1864 3.8105 12.2066L3.84486 12.3274L3.98733 12.2844L3.955 12.1702Z",
    fill: "url(#paint40_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04885 12.4629L3.90991 12.516C3.94124 12.5938 3.96852 12.6732 4.00944 12.7465L4.14333 12.6813C4.10392 12.612 4.07866 12.5367 4.04885 12.4634V12.4629Z",
    fill: "url(#paint41_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10034 12.9219L4.23574 13.1337L4.357 13.0477L4.22917 12.847L4.10034 12.9219Z",
    fill: "url(#paint42_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97522 10.7856L3.83224 10.7446C3.81203 10.826 3.79435 10.9079 3.77515 10.9893L3.92116 11.0171C3.93934 10.9398 3.95602 10.8624 3.97522 10.7856Z",
    fill: "url(#paint43_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87959 11.3225L3.89425 11.2042L3.74672 11.1865L3.73106 11.3114L3.72803 11.4367L3.87707 11.4413L3.87959 11.3225Z",
    fill: "url(#paint44_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87608 11.6288L3.72754 11.6348C3.73411 11.7183 3.73966 11.8022 3.74775 11.8851L3.89527 11.8659L3.87658 11.6288H3.87608Z",
    fill: "url(#paint45_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60752 9.68515L4.49991 9.58203L4.33521 9.77159L4.45141 9.86461L4.60752 9.68515Z",
    fill: "url(#paint46_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34034 10.0173L4.21757 9.93286C4.16604 9.99908 4.12714 10.0734 4.08521 10.1462L4.21505 10.2195C4.25496 10.1512 4.29184 10.0805 4.34034 10.0178V10.0173Z",
    fill: "url(#paint47_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05537 10.5475L4.07962 10.4934L4.12863 10.3852L3.99424 10.3215L3.9427 10.4358L3.91694 10.4934L3.89673 10.5531L4.03668 10.6041L4.05537 10.5475Z",
    fill: "url(#paint48_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67812 9.00371L5.63114 8.86267L5.39722 8.95417L5.45683 9.09065L5.67812 9.00371Z",
    fill: "url(#paint49_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18357 9.23065C5.21591 9.2079 5.25329 9.19324 5.28815 9.17403L5.21843 9.0426C5.18206 9.06282 5.14265 9.07849 5.10829 9.10225L5.0022 9.16999L5.08303 9.29485L5.18307 9.23065H5.18357Z",
    fill: "url(#paint50_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78946 9.51232C4.80462 9.49968 4.82079 9.48755 4.83594 9.47542L4.92941 9.40212L4.83999 9.28333L4.74096 9.36067C4.72479 9.37381 4.70762 9.38645 4.69195 9.39959L4.64648 9.44306L4.74652 9.55326L4.78946 9.51232Z",
    fill: "url(#paint51_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70679 8.87286C6.7856 8.88044 6.86442 8.89207 6.94273 8.90117L6.96597 8.75407C6.88311 8.74396 6.79975 8.73183 6.71689 8.72424L6.70679 8.87286Z",
    fill: "url(#paint52_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51841 8.86877V8.71965C6.43455 8.71409 6.35118 8.72672 6.26782 8.73178L6.28146 8.87989C6.36078 8.87534 6.43909 8.8627 6.51892 8.86877H6.51841Z",
    fill: "url(#paint53_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92014 8.93505C5.93934 8.9305 5.95905 8.92797 5.97875 8.92444L6.09596 8.9032L6.07222 8.7561L5.94844 8.77835C5.92772 8.78239 5.90701 8.78542 5.8868 8.78997L5.82617 8.80716L5.86305 8.95123L5.92014 8.93505Z",
    fill: "url(#paint54_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99262 9.13513L7.91431 9.26201C7.94967 9.28021 7.9815 9.30397 8.01333 9.32722L8.11033 9.39648L8.19976 9.27718L8.0977 9.20439C8.06385 9.17962 8.03 9.15535 7.99262 9.13564V9.13513Z",
    fill: "url(#paint55_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53491 9.06793C7.60665 9.1013 7.68042 9.13163 7.75064 9.16752L7.81935 9.03558C7.74509 8.99716 7.66728 8.96532 7.5915 8.92993L7.53491 9.06743V9.06793Z",
    fill: "url(#paint56_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16447 8.79443L7.13062 8.93951L7.24631 8.9663L7.35898 9.00422L7.40596 8.86268L7.28673 8.82274L7.16447 8.79443Z",
    fill: "url(#paint57_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67107 9.72412L8.55688 9.81966C8.60488 9.88285 8.65641 9.943 8.70138 10.0087L8.82364 9.92379C8.77615 9.85505 8.72159 9.79085 8.67107 9.72463V9.72412Z",
    fill: "url(#paint58_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3563 9.40454L8.25879 9.51676L8.34872 9.59461C8.37752 9.62191 8.40379 9.65173 8.43107 9.68055L8.53818 9.57742C8.50888 9.5476 8.48109 9.51575 8.45077 9.48694L8.3563 9.40454Z",
    fill: "url(#paint59_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26433 14.6183L6.86151 14.266L6.25928 13.9111L6.26433 14.6183Z",
    fill: "url(#paint60_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5118 3.69753L26.3628 3.70916L26.378 3.89569L26.5351 3.88356L26.6907 3.85576L26.6589 3.67175L26.5118 3.69753Z",
    fill: "url(#paint61_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8906 3.6247L26.9356 3.80618C27.0366 3.77635 27.1387 3.75108 27.2382 3.71721L27.1771 3.54028C27.0831 3.57213 26.9861 3.59589 26.8906 3.6242V3.6247Z",
    fill: "url(#paint62_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8578 3.48921L24.7895 3.45837L24.7168 3.63075L24.7885 3.6631C24.8128 3.67321 24.8381 3.68029 24.8628 3.68939L25.0124 3.73994L25.0694 3.5615L24.928 3.51398C24.9042 3.50589 24.8805 3.49881 24.8573 3.48921H24.8578Z",
    fill: "url(#paint63_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4426 3.6591L25.2971 3.62573L25.2532 3.80771L25.4068 3.8431C25.4325 3.84815 25.4578 3.85624 25.4841 3.85927L25.5624 3.86888L25.5902 3.68387L25.5159 3.67477C25.4911 3.67173 25.4674 3.66415 25.4426 3.6591Z",
    fill: "url(#paint64_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8237 3.71313L25.8091 3.89967C25.9142 3.90624 26.0193 3.90573 26.1243 3.90927L26.1228 3.72223C26.0233 3.7192 25.9238 3.7192 25.8242 3.71364L25.8237 3.71313Z",
    fill: "url(#paint65_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5603 2.56159L23.5144 2.50244L23.3699 2.62123L23.4184 2.68341C23.4356 2.70363 23.4542 2.72183 23.4719 2.74104L23.5806 2.85528L23.7139 2.72436L23.6109 2.61618C23.5942 2.59798 23.576 2.58029 23.5598 2.56159H23.5603Z",
    fill: "url(#paint66_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8862 2.8877L23.7625 3.02772L23.8817 3.13135C23.9201 3.16774 23.9661 3.19403 24.008 3.22588L24.1186 3.07524C24.0792 3.04491 24.0353 3.02014 23.9994 2.98576L23.8867 2.8877H23.8862Z",
    fill: "url(#paint67_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2114 3.36843L24.4848 3.52564L24.5701 3.35933L24.311 3.21021L24.2114 3.36843Z",
    fill: "url(#paint68_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.861 1.2104C22.8544 1.18665 22.8469 1.16289 22.8413 1.13862L22.8282 1.06482L22.6448 1.10273L22.6589 1.18058C22.665 1.20636 22.6731 1.23113 22.6796 1.25691L22.7226 1.40856L22.9014 1.35447L22.8605 1.21091L22.861 1.2104Z",
    fill: "url(#paint69_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9783 1.5779L22.8035 1.64462C22.8429 1.74219 22.8772 1.84228 22.9288 1.93377L23.0965 1.85137C23.047 1.76443 23.0152 1.6699 22.9778 1.57739L22.9783 1.5779Z",
    fill: "url(#paint70_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0435 2.15469L23.2137 2.42109L23.3663 2.31291L23.2056 2.06067L23.0435 2.15469Z",
    fill: "url(#paint71_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2185 3.07875L27.5218 3.1379L27.6582 3.32746L27.5319 3.39216L27.4652 3.42603C27.443 3.43715 27.4192 3.44474 27.396 3.45434L27.4698 3.62621C27.494 3.6161 27.5193 3.60801 27.5425 3.59639L27.6127 3.5605L27.7532 3.48871L27.691 3.37397L27.9341 3.71164L28.218 3.07825L28.2185 3.07875Z",
    fill: "url(#paint72_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8131 6.23604L27.8056 6.08691L27.6191 6.09702L27.6267 6.25474L27.65 6.41094L27.8349 6.38415L27.8131 6.23604Z",
    fill: "url(#paint73_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9511 6.90632C27.9218 6.81128 27.901 6.71372 27.8753 6.61768L27.6924 6.65761C27.7192 6.75922 27.7419 6.86234 27.7727 6.96293L27.9511 6.90682V6.90632Z",
    fill: "url(#paint74_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0404 4.65734C28.0494 4.63409 28.0565 4.61033 28.0671 4.58758L28.1 4.52035L27.9297 4.4425L27.8954 4.51327C27.8847 4.53703 27.8767 4.56231 27.8671 4.58708L27.8125 4.73519L27.9888 4.79737L28.0404 4.65734Z",
    fill: "url(#paint75_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8637 5.24125C27.8673 5.21648 27.8753 5.19272 27.8814 5.16846L27.9188 5.02389L27.7384 4.97485L27.699 5.12752C27.693 5.1533 27.6844 5.17807 27.6808 5.20435L27.6687 5.2822L27.8526 5.31506L27.8637 5.24125Z",
    fill: "url(#paint76_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8167 5.54756L27.6307 5.52734C27.6216 5.63198 27.6186 5.73763 27.6125 5.84227L27.7995 5.84581C27.8055 5.74623 27.8081 5.64664 27.8167 5.54756Z",
    fill: "url(#paint77_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9119 3.17069C28.8912 3.18686 28.8725 3.20557 28.8528 3.22275L28.7356 3.3284L28.8629 3.46539L28.9741 3.3653C28.9928 3.34913 29.0104 3.33144 29.0301 3.31577L29.0903 3.27128L28.9756 3.12317L28.9119 3.17018V3.17069Z",
    fill: "url(#paint78_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4518 3.62113C28.4144 3.65854 28.3866 3.70353 28.3538 3.74447L28.5013 3.85973C28.5326 3.8208 28.5584 3.77784 28.5942 3.74296L28.6953 3.63326L28.5589 3.50537L28.4523 3.62164L28.4518 3.62113Z",
    fill: "url(#paint79_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3613 4.04871L28.2062 3.94458L28.041 4.21401L28.2052 4.30349L28.3613 4.04871Z",
    fill: "url(#paint80_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4505 2.81079L29.1802 2.97306L29.2837 3.12875L29.5399 2.97508L29.4505 2.81079Z",
    fill: "url(#paint81_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1511 7.3932L28.09 7.2648L28.0576 7.19757C28.047 7.17482 28.0399 7.15106 28.0313 7.12781L27.8576 7.19656C27.8672 7.22133 27.8742 7.2466 27.8853 7.27036L27.9192 7.34164L27.9869 7.48419L28.1036 7.42555L27.759 7.65909L28.3835 7.96088L28.3436 7.26227L28.1501 7.3932H28.1511Z",
    fill: "url(#paint82_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40743 21.9061L3.32861 22.0334L3.48826 22.131L3.57112 21.9965L3.64084 21.855L3.47311 21.7721L3.40743 21.9061Z",
    fill: "url(#paint83_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57202 21.5568L3.74531 21.6276C3.78068 21.5285 3.82059 21.4309 3.85242 21.3309L3.67357 21.2758C3.64376 21.3708 3.60537 21.4628 3.57202 21.5568Z",
    fill: "url(#paint84_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32457 23.0769C2.30385 23.091 2.28415 23.1062 2.26293 23.1193L2.19775 23.1562L2.29375 23.317L2.36246 23.2781C2.38469 23.2644 2.40591 23.2482 2.42763 23.2336L2.55646 23.1426L2.44632 22.9915L2.32406 23.0774L2.32457 23.0769Z",
    fill: "url(#paint85_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80105 22.6967C2.78387 22.7149 2.76367 22.7295 2.74548 22.7467L2.63281 22.8448L2.75356 22.9878L2.87279 22.8842C2.8925 22.8665 2.91321 22.8508 2.9314 22.8316L2.98546 22.774L2.85259 22.6426L2.80156 22.6972L2.80105 22.6967Z",
    fill: "url(#paint86_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01367 22.4707L3.15564 22.5925C3.22284 22.5117 3.28447 22.4262 3.34914 22.3433L3.19707 22.2341C3.13594 22.3125 3.07733 22.3934 3.01367 22.4702V22.4707Z",
    fill: "url(#paint87_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.823602 23.6111C0.798846 23.6141 0.77409 23.6182 0.749334 23.6202L0.674561 23.6227L0.68517 23.8098L0.763985 23.8072C0.790257 23.8052 0.816024 23.8012 0.842295 23.7981L0.998915 23.7779L0.972138 23.5929L0.824107 23.6121L0.823602 23.6111Z",
    fill: "url(#paint88_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35009 23.5161L1.20459 23.549L1.2445 23.732L1.39809 23.6971C1.45013 23.6875 1.49863 23.6663 1.54865 23.6511L1.49257 23.4727C1.44508 23.4868 1.3991 23.5075 1.34959 23.5161H1.35009Z",
    fill: "url(#paint89_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71533 23.3963L1.78404 23.5702L2.07253 23.4418L1.98866 23.275L1.71533 23.3963Z",
    fill: "url(#paint90_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25808 20.7652L3.91453 20.1621L3.55127 20.7596L3.78468 20.7611L3.76245 20.9017L3.75083 20.9755C3.74679 21.0002 3.73871 21.024 3.73315 21.0477L3.91554 21.0897C3.9216 21.0639 3.93019 21.0392 3.93423 21.0129L3.94686 20.935L3.97162 20.7793L3.84228 20.7616L4.25808 20.7647V20.7652Z",
    fill: "url(#paint91_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3248 32.5984L13.098 32.561L13.0894 32.6121C13.1 32.5256 13.1061 32.4377 13.1061 32.3482L13.1071 32.4063L13.337 32.4033C13.3951 32.4023 13.4415 32.3548 13.441 32.2961V32.2835C13.44 32.2254 13.392 32.1789 13.3339 32.1794L13.1041 32.1824L13.1056 32.2931C13.1041 32.2309 13.1005 32.1683 13.0934 32.1051C13.0874 32.0479 13.0778 31.9918 13.0672 31.9362L13.0838 32.0232L13.3097 31.9792C13.3668 31.9681 13.4042 31.913 13.393 31.8553L13.3905 31.8427C13.3794 31.7856 13.3243 31.7482 13.2672 31.7593L13.0414 31.8033L13.0566 31.8821C13.0404 31.8078 13.0202 31.735 12.9969 31.6643L13.2066 31.5834C13.2612 31.5627 13.288 31.5015 13.2672 31.4469L13.2627 31.4348C13.242 31.3802 13.1808 31.3534 13.1263 31.3741L12.9156 31.455C12.901 31.4226 12.8858 31.3908 12.8696 31.3589L13.0667 31.2462C13.1172 31.2174 13.1349 31.1527 13.1061 31.1021L13.0995 31.091C13.0707 31.0405 13.006 31.0228 12.9555 31.0521L12.7575 31.1658C12.7282 31.1208 12.6973 31.0769 12.665 31.0344L12.8368 30.8908C12.8812 30.8534 12.8873 30.7872 12.8499 30.7422L12.8418 30.7326C12.8045 30.6881 12.7383 30.6821 12.6933 30.7195L12.52 30.8646C12.4836 30.8256 12.4452 30.7887 12.4063 30.7528L12.5503 30.579C12.5877 30.534 12.5811 30.4677 12.5367 30.4303L12.5266 30.4222C12.4816 30.3848 12.4154 30.3914 12.378 30.4359L12.2336 30.6103C12.1901 30.5784 12.1456 30.5481 12.1002 30.5193L12.1148 30.5279L12.229 30.3282C12.2578 30.2777 12.2406 30.2135 12.1901 30.1842L12.179 30.1776C12.1285 30.1488 12.0643 30.166 12.035 30.2165L11.9208 30.4162L11.937 30.4253C11.8794 30.3955 11.8208 30.3682 11.7602 30.3439L11.8349 30.128C11.8541 30.0729 11.8248 30.0128 11.7698 29.9936L11.7576 29.9895C11.7026 29.9703 11.6424 29.9996 11.6237 30.0547L11.5485 30.2711C11.499 30.2569 11.4489 30.2448 11.3984 30.2337L11.4343 30.0098C11.4434 29.9521 11.4045 29.898 11.3469 29.8889L11.3343 29.8869C11.2767 29.8778 11.2226 29.9167 11.2135 29.9744L11.1776 30.1988C11.1221 30.1933 11.0665 30.1892 11.0099 30.1882L11.0043 29.9633C11.0028 29.9051 10.9543 29.8591 10.8962 29.8606H10.8836C10.8255 29.8621 10.7795 29.9107 10.7805 29.9688L10.7861 30.1943C10.7618 30.1963 10.7376 30.1978 10.7133 30.2003C10.6916 30.2029 10.6709 30.2059 10.6492 30.2089L10.6057 29.9895C10.5946 29.9324 10.539 29.8955 10.4819 29.9066L10.4693 29.9092C10.4122 29.9203 10.3748 29.9759 10.3864 30.033L10.4299 30.2519C10.3864 30.2625 10.344 30.2741 10.3021 30.2878L10.2243 30.0815C10.2036 30.0269 10.1429 29.9996 10.0884 30.0199L10.0762 30.0244C10.0217 30.0451 9.9944 30.1058 10.0146 30.1604L10.0919 30.3656C10.0419 30.3874 9.99288 30.4116 9.94488 30.4369L9.83323 30.2504C9.80342 30.2003 9.73875 30.1842 9.68873 30.214L9.67762 30.2205C9.6276 30.2504 9.61143 30.3151 9.64124 30.3651L9.7529 30.5517C9.71501 30.5769 9.67762 30.6032 9.64124 30.631L9.5018 30.4677C9.46391 30.4233 9.39722 30.4182 9.35326 30.4561L9.34367 30.4642C9.29921 30.5021 9.29415 30.5688 9.33204 30.6128L9.47149 30.7761C9.42905 30.816 9.38863 30.858 9.34973 30.9015L9.18401 30.7675C9.13854 30.7311 9.07236 30.7377 9.03598 30.7832L9.0279 30.7933C8.99152 30.8388 8.99809 30.905 9.04356 30.9414L9.20877 31.0754C9.17795 31.1173 9.14915 31.1613 9.12187 31.2053L8.93696 31.1032C8.88593 31.0748 8.82177 31.0936 8.79347 31.1446L8.78741 31.1557C8.75912 31.2068 8.77781 31.271 8.82884 31.2993L9.01375 31.4014C8.99304 31.4444 8.97283 31.4878 8.95464 31.5323L8.7576 31.4636C8.70253 31.4444 8.64241 31.4732 8.62321 31.5283L8.61917 31.5404C8.59997 31.5955 8.62877 31.6557 8.68384 31.6749L8.88138 31.7441C8.86724 31.7922 8.85562 31.8412 8.84501 31.8907L8.63989 31.8569C8.58229 31.8473 8.52823 31.8862 8.51863 31.9438L8.51661 31.9564C8.50701 32.0141 8.54592 32.0682 8.60351 32.0778L8.80914 32.1116C8.80358 32.1642 8.79954 32.2168 8.79802 32.2699L8.59138 32.2729C8.53328 32.2739 8.4868 32.3214 8.48731 32.3801V32.3927C8.48832 32.4508 8.53632 32.4973 8.59442 32.4968L8.80206 32.4938C8.80409 32.5231 8.80611 32.5519 8.80964 32.5812C8.81217 32.6055 8.81621 32.6293 8.81924 32.653L8.61665 32.6925C8.55956 32.7036 8.52217 32.7587 8.53328 32.8158L8.53581 32.8284C8.54693 32.8856 8.602 32.923 8.65909 32.9118L8.86269 32.8724C8.87583 32.9235 8.88997 32.9745 8.90665 33.0241L8.71517 33.0979C8.66111 33.1186 8.63382 33.1798 8.65454 33.2344L8.65909 33.2465C8.6798 33.3011 8.74093 33.3279 8.7955 33.3071L8.98849 33.2328C9.00314 33.2652 9.01881 33.2975 9.03497 33.3294L8.85663 33.4315C8.80611 33.4603 8.78842 33.525 8.81773 33.5756L8.82429 33.5867C8.85309 33.6372 8.91776 33.6549 8.96828 33.6256L9.14814 33.5225C9.17745 33.567 9.20776 33.611 9.24009 33.6529L9.08246 33.7848C9.038 33.8223 9.03194 33.8885 9.06933 33.9335L9.07741 33.9436C9.1148 33.9881 9.18149 33.9941 9.22595 33.9567L9.38509 33.8233C9.424 33.8642 9.46441 33.9036 9.50635 33.9415L9.37398 34.1008C9.33659 34.1458 9.34316 34.212 9.38762 34.2494L9.39772 34.2575C9.44269 34.2949 9.50887 34.2883 9.54626 34.2438L9.67964 34.0831C9.71955 34.1124 9.76098 34.1402 9.80291 34.1665L9.69934 34.3475C9.67055 34.398 9.68772 34.4622 9.73825 34.4915L9.74936 34.4981C9.79988 34.5269 9.86405 34.5097 9.89335 34.4592L9.99793 34.2767C10.0515 34.303 10.106 34.3278 10.1616 34.3495L10.0929 34.5476C10.0737 34.6027 10.103 34.6629 10.1581 34.6821L10.1702 34.6862C10.2253 34.7054 10.2854 34.676 10.3046 34.6209L10.3743 34.4208C10.4248 34.4349 10.4759 34.4471 10.5274 34.4577L10.4941 34.6659C10.485 34.7236 10.5239 34.7777 10.5815 34.7868L10.5941 34.7888C10.6517 34.7979 10.7058 34.7589 10.7148 34.7013L10.7482 34.4905C10.8043 34.4956 10.8609 34.4981 10.9179 34.4991L10.923 34.7129C10.9245 34.7711 10.9725 34.8171 11.0311 34.8156H11.0437C11.1018 34.814 11.1478 34.7655 11.1468 34.7074L11.1413 34.4905C11.1569 34.489 11.1726 34.488 11.1887 34.4865C11.2216 34.4829 11.2539 34.4784 11.2857 34.4733L11.3297 34.6958C11.3408 34.7529 11.3964 34.7903 11.4535 34.7787L11.4661 34.7761C11.5232 34.765 11.5606 34.7094 11.549 34.6523L11.5045 34.4273C11.547 34.4162 11.5894 34.4036 11.6308 34.3894L11.7117 34.6038C11.7324 34.6584 11.793 34.6856 11.8476 34.6654L11.8597 34.6609C11.9142 34.6402 11.9415 34.5795 11.9213 34.5249L11.84 34.3096L11.8167 34.3181C11.8789 34.2909 11.939 34.261 11.9971 34.2287L11.9804 34.2388L12.0987 34.4359C12.1285 34.486 12.1931 34.5022 12.2432 34.4723L12.2543 34.4658C12.3043 34.4359 12.3204 34.3712 12.2906 34.3212L12.1724 34.124L12.1093 34.162C12.1679 34.1245 12.2245 34.0846 12.2785 34.0416L12.423 34.211C12.4609 34.2555 12.5271 34.2605 12.5715 34.2226L12.5811 34.214C12.6256 34.1761 12.6307 34.1099 12.5928 34.0654L12.4468 33.894C12.4887 33.8536 12.5291 33.8121 12.5675 33.7682L12.7398 33.9077C12.7853 33.9441 12.8514 33.9375 12.8878 33.892L12.8959 33.8819C12.9323 33.8364 12.9257 33.7702 12.8802 33.7338L12.7059 33.5928C12.7342 33.5528 12.761 33.5124 12.7863 33.4709L12.9838 33.5801C13.0348 33.6084 13.099 33.5897 13.1273 33.5387L13.1334 33.5275C13.1616 33.4765 13.143 33.4123 13.0919 33.384L12.8934 33.2743C12.9146 33.2293 12.9348 33.1838 12.953 33.1378L13.1687 33.2131C13.2238 33.2323 13.2839 33.2035 13.3031 33.1484L13.3072 33.1363C13.3264 33.0812 13.2976 33.021 13.2425 33.0018L13.0252 32.926L13.0197 32.9412C13.0353 32.8876 13.0485 32.833 13.0596 32.7779V32.7824L13.2859 32.8198C13.3435 32.8294 13.3976 32.7905 13.4072 32.7329L13.4092 32.7203C13.4188 32.6626 13.3799 32.6085 13.3223 32.5989L13.3248 32.5984ZM11.1185 33.844C10.2905 33.936 9.54424 33.339 9.45229 32.51C9.36034 31.6814 9.95701 30.9348 10.7856 30.8428C11.6136 30.7508 12.3599 31.3478 12.4518 32.1768C12.5438 33.0054 11.9471 33.752 11.1185 33.844Z",
    fill: "url(#paint92_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9648 31.1218C10.2934 31.1218 9.74927 31.6663 9.74927 32.3381C9.74927 33.0099 10.2934 33.5543 10.9648 33.5543C11.6363 33.5543 12.1804 33.0099 12.1804 32.3381C12.1804 31.6663 11.6363 31.1218 10.9648 31.1218ZM10.9648 33.0614C10.5657 33.0614 10.2419 32.7374 10.2419 32.3381C10.2419 31.9387 10.5657 31.6147 10.9648 31.6147C11.364 31.6147 11.6878 31.9387 11.6878 32.3381C11.6878 32.7374 11.364 33.0614 10.9648 33.0614Z",
    fill: "url(#paint93_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2949 4.08212L18.0943 4.05685L18.0822 4.1534C18.0882 4.0988 18.0928 4.04421 18.0943 3.98861C18.0958 3.93805 18.0943 3.88801 18.0923 3.83847L18.0963 3.91632L18.2979 3.9057C18.3489 3.90318 18.3883 3.8592 18.3858 3.80814V3.79702C18.3828 3.74596 18.3388 3.70653 18.2878 3.70906L18.0862 3.71968L18.0897 3.79045C18.0847 3.72372 18.0761 3.65801 18.0645 3.5933L18.257 3.54882C18.307 3.53719 18.3378 3.48765 18.3262 3.43761L18.3237 3.42649C18.312 3.37644 18.2625 3.34561 18.2125 3.35723L18.0195 3.40222C18.0109 3.3724 18.0013 3.34257 17.9912 3.31325L18.1766 3.23895C18.2241 3.21974 18.2474 3.16615 18.2282 3.11864L18.2241 3.10802C18.2049 3.0605 18.1514 3.03725 18.1039 3.05646L17.9175 3.13127C17.8973 3.08831 17.876 3.04635 17.8533 3.0054L18.02 2.90127C18.0635 2.87397 18.0766 2.81685 18.0498 2.77338L18.0438 2.76377C18.0165 2.7203 17.9594 2.70716 17.9159 2.73395L17.7477 2.83909C17.7204 2.80118 17.6921 2.76428 17.6623 2.72839L17.8088 2.59494C17.8467 2.56056 17.8493 2.50192 17.8149 2.46401L17.8073 2.45542C17.773 2.4175 17.7144 2.41498 17.6765 2.44935L17.5294 2.58331C17.4956 2.54995 17.4607 2.5181 17.4244 2.48777L17.436 2.49687L17.5598 2.33713C17.5911 2.29669 17.584 2.23856 17.5436 2.20722L17.5345 2.20014C17.4941 2.1688 17.436 2.17587 17.4047 2.21631L17.2809 2.37605L17.294 2.38616C17.2475 2.35331 17.1995 2.32247 17.15 2.29366L17.2415 2.11521C17.2647 2.06972 17.247 2.01361 17.2011 1.99035L17.1909 1.9853C17.1455 1.96205 17.0894 1.97974 17.0662 2.02574L16.9747 2.20469C16.9333 2.18649 16.8913 2.1693 16.8489 2.15414L16.9075 1.96356C16.9227 1.91453 16.8949 1.86297 16.8459 1.8478L16.8353 1.84477C16.7863 1.82961 16.7347 1.85741 16.7196 1.90644L16.661 2.09752C16.6135 2.08589 16.5655 2.07578 16.5165 2.0677L16.5392 1.87106C16.5453 1.82 16.5084 1.774 16.4579 1.76844L16.4468 1.76692C16.3957 1.76086 16.3497 1.79776 16.3442 1.84831L16.3215 2.04495C16.3002 2.04343 16.279 2.04192 16.2573 2.04141C16.2381 2.04091 16.2194 2.04141 16.2007 2.04141L16.1896 1.84477C16.1866 1.79371 16.1431 1.75479 16.0921 1.75732H16.081C16.0299 1.76086 15.9905 1.80433 15.9936 1.85589L16.0047 2.05152C15.9658 2.05556 15.9269 2.06062 15.889 2.06719L15.8465 1.87813C15.8354 1.82809 15.7859 1.79675 15.7359 1.80787L15.7248 1.8104C15.6748 1.82152 15.6434 1.87106 15.6546 1.9211L15.697 2.10915C15.6505 2.12179 15.6056 2.13695 15.5606 2.15313L15.4858 1.97671C15.4661 1.92969 15.4115 1.90745 15.3646 1.92767L15.3539 1.93222C15.307 1.95194 15.2847 2.00653 15.3049 2.05354L15.3792 2.22946C15.3428 2.24715 15.307 2.26535 15.2721 2.28506L15.1706 2.12583C15.1433 2.08286 15.0857 2.06972 15.0427 2.09752L15.0331 2.10359C14.9902 2.13088 14.9771 2.18851 15.0048 2.23148L15.1064 2.39071C15.0645 2.42054 15.024 2.45188 14.9851 2.48474L14.8573 2.34775C14.8225 2.31034 14.7638 2.30832 14.7265 2.3432L14.7184 2.35078C14.681 2.38566 14.679 2.4443 14.7138 2.4817L14.8411 2.61819C14.8093 2.65105 14.779 2.68542 14.7497 2.72081L14.6012 2.60909C14.5602 2.57825 14.5021 2.58634 14.4713 2.62729L14.4648 2.63639C14.4339 2.67733 14.4425 2.73547 14.4834 2.7663L14.632 2.87802C14.6087 2.9129 14.586 2.94828 14.5648 2.98468L14.4016 2.90076C14.3561 2.87751 14.3001 2.8952 14.2768 2.9407L14.2718 2.95081C14.2485 2.9963 14.2662 3.05241 14.3117 3.07567L14.4754 3.16009C14.4572 3.20053 14.441 3.24147 14.4259 3.28343L14.2515 3.22934C14.2025 3.21418 14.151 3.24147 14.1353 3.29051L14.1318 3.30112C14.1167 3.35016 14.1439 3.40172 14.1929 3.41739L14.3678 3.47198C14.3566 3.51697 14.3465 3.56247 14.3384 3.60847L14.1581 3.58572C14.1076 3.57915 14.0611 3.61554 14.0545 3.66609L14.053 3.67722C14.0464 3.72777 14.0828 3.77427 14.1333 3.78084L14.3147 3.80359C14.3132 3.82937 14.3112 3.85465 14.3107 3.88093C14.3102 3.90216 14.3107 3.9234 14.3107 3.94463L14.1293 3.95423C14.0783 3.95676 14.0388 4.00074 14.0414 4.05179V4.06291C14.0444 4.11397 14.0884 4.1534 14.1394 4.15087L14.3213 4.14127C14.3263 4.18727 14.3329 4.23327 14.341 4.27876L14.1652 4.31971C14.1151 4.33134 14.0843 4.38087 14.0959 4.43092L14.0985 4.44204C14.1101 4.49208 14.1596 4.52292 14.2096 4.51129L14.3864 4.47035C14.395 4.50068 14.4046 4.5305 14.4152 4.55982L14.2475 4.62705C14.2 4.64626 14.1768 4.69985 14.196 4.74736L14.2 4.75798C14.2192 4.8055 14.2728 4.82875 14.3203 4.80954L14.4895 4.7418C14.5097 4.78427 14.5304 4.82622 14.5537 4.86666L14.4001 4.9622C14.3566 4.9895 14.3435 5.04662 14.3703 5.09009L14.3763 5.0997C14.4036 5.14317 14.4607 5.15631 14.5042 5.12952L14.6593 5.03297C14.6881 5.07341 14.7184 5.11284 14.7502 5.15075L14.6158 5.27359C14.5779 5.30797 14.5754 5.3666 14.6098 5.40452L14.6173 5.4126C14.6517 5.45052 14.7103 5.45304 14.7482 5.41867L14.8841 5.29482C14.9154 5.32515 14.9477 5.35447 14.9811 5.38278L14.8689 5.52735C14.8376 5.56779 14.8447 5.62593 14.8851 5.65727L14.8942 5.66434C14.9346 5.69569 14.9927 5.68861 15.024 5.64817L15.1372 5.50208C15.1807 5.5319 15.2251 5.55971 15.2711 5.58549L15.1872 5.74927C15.164 5.79476 15.1817 5.85087 15.2276 5.87413L15.2377 5.87918C15.2832 5.90244 15.3393 5.88474 15.3625 5.83874L15.4474 5.67294C15.4894 5.69114 15.5323 5.70832 15.5762 5.72349L15.5217 5.90092C15.5065 5.94995 15.5343 6.00151 15.5833 6.01668L15.5939 6.02022C15.6429 6.03538 15.6945 6.00758 15.7096 5.95855L15.7647 5.77909C15.8127 5.79072 15.8622 5.79982 15.9117 5.8074L15.89 5.99444C15.8839 6.04549 15.9203 6.09149 15.9713 6.09705L15.9824 6.09857C16.0335 6.10464 16.0795 6.06774 16.085 6.01718L16.1067 5.82762C16.1209 5.82813 16.1345 5.82964 16.1482 5.82964C16.177 5.83065 16.2058 5.83015 16.2346 5.82964L16.2457 6.02881C16.2487 6.07987 16.2922 6.1193 16.3432 6.11626H16.3543C16.4053 6.11272 16.4442 6.06925 16.4417 6.01769L16.4306 5.8165C16.469 5.81195 16.5074 5.80588 16.5453 5.79881L16.5892 5.99545C16.6003 6.04549 16.6499 6.07683 16.6999 6.06571L16.711 6.06319C16.761 6.05206 16.7923 6.00253 16.7812 5.95248L16.7367 5.75533L16.7155 5.75988C16.7726 5.74371 16.8287 5.725 16.8838 5.70377L16.8681 5.71035L16.9469 5.89637C16.9666 5.94338 17.0212 5.96562 17.0682 5.9454L17.0788 5.94085C17.1258 5.92063 17.148 5.86655 17.1278 5.81953L17.049 5.63351L16.9894 5.65878C17.0449 5.63351 17.099 5.6052 17.1515 5.57487L17.2566 5.74017C17.2839 5.78314 17.3415 5.79628 17.3844 5.76848L17.394 5.76241C17.437 5.73511 17.4501 5.67749 17.4223 5.63452L17.3157 5.4672C17.3572 5.43737 17.3976 5.40553 17.436 5.37267L17.5689 5.51522C17.6037 5.55263 17.6623 5.55465 17.6997 5.51977L17.7078 5.51219C17.7452 5.47731 17.7472 5.41867 17.7123 5.38126L17.5779 5.2372C17.6073 5.20585 17.6355 5.17401 17.6628 5.14064L17.8215 5.25994C17.8624 5.29078 17.9205 5.28269 17.9513 5.24174L17.9579 5.23265C17.9887 5.1917 17.9801 5.13357 17.9397 5.10273L17.7805 4.98293C17.8048 4.94653 17.8275 4.90912 17.8493 4.87121L18.0281 4.96321C18.0736 4.98647 18.1297 4.96877 18.1529 4.92328L18.1579 4.91317C18.1812 4.86767 18.1635 4.81156 18.118 4.78831L17.9382 4.6958L17.9316 4.70844C17.9518 4.66345 17.97 4.61795 17.9867 4.57145L17.9857 4.57549L18.1787 4.63565C18.2277 4.65081 18.2792 4.62352 18.2949 4.57448L18.2984 4.56387C18.3136 4.51483 18.2863 4.46277 18.2373 4.4476L18.0443 4.38745L18.0306 4.43092C18.0508 4.35661 18.0665 4.28079 18.0771 4.20344L18.0705 4.2545L18.2711 4.27977C18.3216 4.28635 18.3681 4.24995 18.3747 4.1994L18.3762 4.18828C18.3828 4.13773 18.3464 4.09122 18.2959 4.08465L18.2949 4.08212ZM14.9932 4.25905C14.8139 4.25905 14.6684 4.11346 14.6684 3.93401C14.6684 3.75456 14.8139 3.60897 14.9932 3.60897C15.1726 3.60897 15.3181 3.75456 15.3181 3.93401C15.3181 4.11346 15.1726 4.25905 14.9932 4.25905ZM16.1805 2.42104C16.3599 2.42104 16.5054 2.56663 16.5054 2.74608C16.5054 2.92553 16.3599 3.07112 16.1805 3.07112C16.0011 3.07112 15.8556 2.92553 15.8556 2.74608C15.8556 2.56663 16.0011 2.42104 16.1805 2.42104ZM16.1805 5.44698C16.0011 5.44698 15.8556 5.30139 15.8556 5.12194C15.8556 4.94249 16.0011 4.7969 16.1805 4.7969C16.3599 4.7969 16.5054 4.94249 16.5054 5.12194C16.5054 5.30139 16.3599 5.44698 16.1805 5.44698ZM16.2128 4.46024C15.9228 4.46024 15.6879 4.22518 15.6879 3.93502C15.6879 3.64486 15.9228 3.4098 16.2128 3.4098C16.5028 3.4098 16.7378 3.64486 16.7378 3.93502C16.7378 4.22518 16.5028 4.46024 16.2128 4.46024ZM17.3673 4.25905C17.1879 4.25905 17.0424 4.11346 17.0424 3.93401C17.0424 3.75456 17.1879 3.60897 17.3673 3.60897C17.5466 3.60897 17.6921 3.75456 17.6921 3.93401C17.6921 4.11346 17.5466 4.25905 17.3673 4.25905Z",
    fill: "url(#paint94_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 4.49005C18.4434 4.63361 18.5525 4.74987 18.6919 4.76453V4.21606C18.5525 4.23022 18.4434 4.34699 18.4434 4.49055V4.49005Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9976 4.49006C18.9976 4.3465 18.8885 4.23024 18.749 4.21558V4.76405C18.8885 4.74989 18.9976 4.63312 18.9976 4.48956V4.49006Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9106 6.38261C14.9106 6.5014 15.0011 6.59795 15.1163 6.60958V6.15564C15.0006 6.16727 14.9106 6.26382 14.9106 6.38261Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.369 6.38261C15.369 6.26382 15.2785 6.16727 15.1633 6.15564V6.60958C15.279 6.59795 15.369 6.5014 15.369 6.38261Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2244 2.06165C22.2244 2.18903 22.3214 2.29215 22.4451 2.30479V1.81799C22.3214 1.83063 22.2244 1.93426 22.2244 2.06114V2.06165Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7154 2.06163C22.7154 1.93424 22.6184 1.83112 22.4946 1.81848V2.30528C22.6184 2.29264 22.7154 2.18901 22.7154 2.06213V2.06163Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1577 6.74158C19.1577 6.86896 19.2547 6.97209 19.3785 6.98472V6.49792C19.2547 6.51056 19.1577 6.61419 19.1577 6.74107V6.74158Z",
    fill: "url(#paint95_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6493 6.74156C19.6493 6.61417 19.5522 6.51105 19.4285 6.49841V6.98521C19.5522 6.97257 19.6493 6.86895 19.6493 6.74207V6.74156Z",
    fill: "url(#paint96_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8164 7.68884C17.8164 7.81623 17.9134 7.91935 18.0372 7.93199V7.44519C17.9134 7.45783 17.8164 7.56146 17.8164 7.68834V7.68884Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3075 7.68883C18.3075 7.56144 18.2105 7.45832 18.0867 7.44568V7.93248C18.2105 7.91984 18.3075 7.81621 18.3075 7.68933V7.68883Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01111 3.11666C7.10104 3.20664 7.2425 3.21119 7.339 3.13233L6.99494 2.78809C6.91663 2.88464 6.92118 3.02618 7.01111 3.11616V3.11666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35865 2.76933C7.26872 2.67935 7.12726 2.6748 7.03076 2.75315L7.37482 3.0974C7.45313 3.00085 7.44858 2.85931 7.35865 2.76933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84961 6.51611C5.84961 6.6435 5.94661 6.74662 6.07039 6.75926V6.27246C5.94661 6.2851 5.84961 6.38873 5.84961 6.51561V6.51611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34115 6.5161C6.34115 6.38871 6.24414 6.28559 6.12036 6.27295V6.75975C6.24414 6.74711 6.34115 6.64348 6.34115 6.5166V6.5161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31274 8.55579C7.31274 8.68317 7.40975 8.7863 7.53353 8.79893V8.31213C7.40975 8.32477 7.31274 8.4284 7.31274 8.55528V8.55579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80379 8.55577C7.80379 8.42838 7.70679 8.32526 7.58301 8.31262V8.79942C7.70679 8.78678 7.80379 8.68316 7.80379 8.55627V8.55577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1289 9.25288C13.2183 9.34285 13.3603 9.34791 13.4568 9.26956L13.1138 8.9248C13.035 9.02136 13.039 9.1629 13.1289 9.25288Z",
    fill: "url(#paint97_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4771 8.90608C13.3876 8.8161 13.2457 8.81104 13.1492 8.8894L13.4922 9.23415C13.571 9.1376 13.567 8.99606 13.4771 8.90608Z",
    fill: "url(#paint98_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6738 12.8242C11.6738 12.9516 11.7708 13.0547 11.8946 13.0674V12.5806C11.7708 12.5932 11.6738 12.6968 11.6738 12.8237V12.8242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1654 12.8242C12.1654 12.6968 12.0684 12.5937 11.9446 12.5811V13.0679C12.0684 13.0552 12.1654 12.9516 12.1654 12.8247V12.8242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07197 12.292C8.98053 12.3804 8.97345 12.522 9.05025 12.6195L9.40037 12.2819C9.30539 12.2015 9.16342 12.2035 9.07197 12.292Z",
    fill: "url(#paint99_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41311 12.6458C9.50456 12.5573 9.51163 12.4158 9.43484 12.3182L9.08472 12.6559C9.1797 12.7363 9.32167 12.7343 9.41311 12.6458Z",
    fill: "url(#paint100_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.595 10.8265C21.595 10.9539 21.692 11.057 21.8158 11.0697V10.5829C21.692 10.5955 21.595 10.6992 21.595 10.826V10.8265Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0865 10.8265C22.0865 10.6991 21.9895 10.596 21.8657 10.5834V11.0702C21.9895 11.0575 22.0865 10.9539 22.0865 10.827V10.8265Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3062 17.6022C13.3956 17.6927 13.5371 17.6978 13.6341 17.6199L13.292 17.2742C13.2132 17.3702 13.2168 17.5118 13.3062 17.6022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 17.2565C13.5659 17.166 13.4244 17.1609 13.3274 17.2388L13.6694 17.5845C13.7482 17.4885 13.7447 17.3469 13.6553 17.2565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08203 19.468C8.08203 19.5954 8.17903 19.6985 8.30281 19.7112V19.2244C8.17903 19.237 8.08203 19.3406 8.08203 19.4675V19.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57357 19.468C8.57357 19.3406 8.47656 19.2375 8.35278 19.2249V19.7117C8.47656 19.699 8.57357 19.5954 8.57357 19.4685V19.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.669 29.4709C15.5417 29.4709 15.4387 29.568 15.426 29.6919H15.9126C15.8999 29.568 15.7964 29.4709 15.6695 29.4709H15.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6691 29.9628C15.7964 29.9628 15.8994 29.8658 15.9121 29.7419H15.4255C15.4382 29.8658 15.5417 29.9628 15.6686 29.9628H15.6691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1976 33.6763C13.0703 33.6763 12.9672 33.7733 12.9546 33.8972H13.4411C13.4285 33.7733 13.3249 33.6763 13.1981 33.6763H13.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1976 34.1677C13.3249 34.1677 13.428 34.0706 13.4406 33.9468H12.9541C12.9667 34.0706 13.0703 34.1677 13.1971 34.1677H13.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62778 33.9143C8.50046 33.9143 8.3974 34.0114 8.38477 34.1352H8.8713C8.85867 34.0114 8.7551 33.9143 8.62828 33.9143H8.62778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6278 34.4056C8.75511 34.4056 8.85818 34.3085 8.87081 34.1847H8.38428C8.39691 34.3085 8.50048 34.4056 8.62729 34.4056H8.6278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40431 32.9797C6.49374 33.0697 6.63571 33.0747 6.73221 32.9964L6.38916 32.6516C6.31034 32.7482 6.31438 32.8897 6.40431 32.9797Z",
    fill: "url(#paint101_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75294 32.6329C6.66351 32.5429 6.52155 32.5379 6.42505 32.6162L6.7681 32.961C6.84691 32.8644 6.84287 32.7229 6.75294 32.6329Z",
    fill: "url(#paint102_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16832 30.5876C6.04101 30.5876 5.93744 30.6842 5.9248 30.8075L6.41134 30.8091C6.39871 30.6852 6.29564 30.5882 6.16883 30.5876H6.16832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16733 31.0794C6.29465 31.0794 6.39822 30.9829 6.41085 30.8596L5.92432 30.858C5.93695 30.9819 6.04001 31.0789 6.16682 31.0794H6.16733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16879 26.6396C3.04148 26.6396 2.93841 26.7367 2.92578 26.8606H3.41231C3.39968 26.7367 3.29611 26.6396 3.1693 26.6396H3.16879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16881 27.1315C3.29613 27.1315 3.39919 27.0345 3.41182 26.9106H2.92529C2.93792 27.0345 3.04149 27.1315 3.16831 27.1315H3.16881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9944 2.40531C19.7898 2.36285 19.5892 2.49428 19.5468 2.69901C19.5043 2.90373 19.6357 3.10442 19.8403 3.14688C20.0449 3.18934 20.2455 3.05791 20.2879 2.85318C20.3304 2.64846 20.199 2.44777 19.9944 2.40531ZM19.9752 2.46546C20.0773 2.48669 20.1571 2.55544 20.1975 2.6434L20.0389 2.69547C20.0182 2.66413 19.9858 2.64087 19.9464 2.63278C19.9075 2.6247 19.8691 2.63278 19.8383 2.65301L19.7059 2.53472C19.7777 2.47355 19.8757 2.44474 19.9747 2.46546H19.9752ZM19.9025 2.84661C19.8636 2.83852 19.8383 2.80011 19.8464 2.76118C19.8545 2.72226 19.8929 2.69698 19.9318 2.70507C19.9707 2.71316 19.9959 2.75158 19.9878 2.7905C19.9798 2.82943 19.9414 2.8547 19.9025 2.84661ZM19.6024 2.71063C19.6109 2.66817 19.6281 2.62975 19.6514 2.59588L19.7853 2.71518C19.7807 2.72479 19.7772 2.7354 19.7746 2.74602C19.761 2.81072 19.7933 2.87391 19.8489 2.90373L19.8135 3.07409C19.6625 3.02505 19.5695 2.86885 19.6029 2.70962L19.6024 2.71063ZM20.2202 2.83903C20.1879 2.99371 20.0475 3.09785 19.8944 3.08976L19.9292 2.92092C19.9919 2.91587 20.047 2.87037 20.0601 2.80567C20.0621 2.79505 20.0631 2.78494 20.0631 2.77433L20.2218 2.72175C20.2283 2.75967 20.2278 2.7991 20.2197 2.83852L20.2202 2.83903Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55032 2.87443C6.34571 2.83196 6.14513 2.96339 6.10269 3.16812C6.06025 3.37285 6.19161 3.57353 6.39623 3.616C6.60084 3.65846 6.80142 3.52703 6.84386 3.3223C6.8863 3.11757 6.75494 2.91689 6.55032 2.87443ZM6.53112 2.93458C6.63318 2.95581 6.713 3.02456 6.75342 3.11252L6.59478 3.16458C6.57407 3.13324 6.54173 3.10999 6.50233 3.1019C6.46342 3.09381 6.42503 3.1019 6.39421 3.12212L6.26184 3.00383C6.33358 2.94267 6.43159 2.91385 6.53062 2.93458H6.53112ZM6.45837 3.31573C6.41947 3.30764 6.39421 3.26922 6.40229 3.2303C6.41037 3.19138 6.44877 3.1661 6.48767 3.17419C6.52658 3.18228 6.55184 3.22069 6.54375 3.25962C6.53567 3.29854 6.49727 3.32382 6.45837 3.31573ZM6.15827 3.17924C6.16686 3.13678 6.18403 3.09836 6.20727 3.06449L6.34116 3.18379C6.33661 3.1934 6.33307 3.20401 6.33055 3.21463C6.31691 3.27933 6.34924 3.34252 6.40482 3.37234L6.36945 3.5427C6.21839 3.49367 6.12543 3.33747 6.15877 3.17823L6.15827 3.17924ZM6.77616 3.30815C6.74382 3.46283 6.60337 3.56696 6.45029 3.55888L6.48515 3.39004C6.5478 3.38498 6.60286 3.33949 6.616 3.27478C6.61802 3.26417 6.61903 3.25406 6.61903 3.24344L6.77767 3.19087C6.78424 3.22878 6.78374 3.26821 6.77565 3.30764L6.77616 3.30815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3016 29.3876C12.9839 29.3214 12.6726 29.5256 12.6065 29.8435C12.5403 30.1615 12.7444 30.4729 13.0622 30.5391C13.38 30.6053 13.6912 30.4011 13.7574 30.0832C13.8235 29.7652 13.6194 29.4538 13.3016 29.3876ZM13.2723 29.4811C13.431 29.514 13.5548 29.6206 13.6174 29.7571L13.3714 29.8385C13.3395 29.79 13.2895 29.7536 13.2284 29.7409C13.1683 29.7283 13.1086 29.7409 13.0601 29.7723L12.8545 29.5888C12.9657 29.4937 13.1177 29.4493 13.2723 29.4811ZM13.1592 30.073C13.0985 30.0604 13.0596 30.0008 13.0723 29.9401C13.0849 29.8794 13.1445 29.8405 13.2051 29.8532C13.2658 29.8658 13.3047 29.9254 13.292 29.9861C13.2794 30.0468 13.2198 30.0857 13.1592 30.073ZM12.6928 29.8612C12.7065 29.7955 12.7328 29.7354 12.7686 29.6833L12.9763 29.8688C12.9692 29.884 12.9636 29.9002 12.9601 29.9168C12.9394 30.0174 12.9889 30.116 13.0753 30.162L13.0202 30.4269C12.7858 30.3506 12.6413 30.1084 12.6928 29.8612ZM13.6523 30.0609C13.6023 30.3015 13.384 30.4633 13.146 30.4502L13.2006 30.1883C13.2981 30.1802 13.383 30.1099 13.4042 30.0094C13.4077 29.9932 13.4087 29.977 13.4087 29.9608L13.6553 29.8794C13.6654 29.9381 13.6649 29.9992 13.6523 30.0609Z",
    fill: "url(#paint103_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9364 11.0752C22.3124 11.0752 21.8052 11.5832 21.8052 12.207C21.8052 12.8308 22.3129 13.3388 22.9364 13.3388C23.5598 13.3388 24.0676 12.8308 24.0676 12.207C24.0676 11.5832 23.5598 11.0752 22.9364 11.0752ZM22.9364 13.1695C22.4625 13.1695 22.0684 12.8247 21.9896 12.3728C22.0068 12.3784 22.0249 12.3819 22.0436 12.3819C22.414 12.3819 22.7843 12.3819 23.1546 12.3819H23.1708C23.1708 12.3819 23.1723 12.3844 23.1733 12.386C23.1683 12.3905 23.1622 12.3941 23.1577 12.3991C23.0824 12.4744 23.0066 12.5497 22.9318 12.6251C22.8828 12.6746 22.8687 12.7464 22.8929 12.8055C22.9227 12.8778 22.9889 12.9177 23.0566 12.9183C23.1056 12.9183 23.1481 12.899 23.1829 12.8642C23.3547 12.6923 23.5265 12.5209 23.6977 12.3491C23.7124 12.3344 23.7276 12.3192 23.7392 12.302C23.7852 12.2333 23.7766 12.1453 23.7215 12.0913C23.628 11.9987 23.5351 11.9052 23.4416 11.8122C23.3542 11.7248 23.2668 11.6368 23.1789 11.5494C23.1233 11.4943 23.049 11.4806 22.9829 11.5145C22.9237 11.5453 22.8874 11.5938 22.8818 11.6621C22.8778 11.7136 22.897 11.7571 22.9328 11.793C23.0071 11.8683 23.0819 11.9426 23.1567 12.0175C23.1617 12.0225 23.1668 12.0281 23.1733 12.0346C23.1688 12.0346 23.1678 12.0346 23.1663 12.0346C22.7934 12.0346 22.42 12.0346 22.0472 12.0346C22.0335 12.0346 22.0199 12.0351 22.0063 12.0382C22.0002 12.0392 21.9946 12.0417 21.9891 12.0432C22.0669 11.5903 22.4615 11.244 22.9364 11.244C23.4669 11.244 23.8983 11.6757 23.8983 12.2065C23.8983 12.7373 23.4669 13.169 22.9364 13.169V13.1695Z",
    fill: "url(#paint104_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4769 7.28744C14.1009 7.28744 14.6081 6.77941 14.6081 6.15562C14.6081 5.53183 14.1003 5.0238 13.4769 5.0238C12.8535 5.0238 12.3457 5.53183 12.3457 6.15562C12.3457 6.77941 12.8535 7.28744 13.4769 7.28744ZM13.4769 5.19315C13.9508 5.19315 14.3449 5.5379 14.4237 5.98982C14.4065 5.98426 14.3883 5.98072 14.3696 5.98072C13.9993 5.98072 13.629 5.98072 13.2586 5.98072H13.2425C13.2425 5.98072 13.241 5.97819 13.24 5.97668C13.245 5.97213 13.2511 5.96859 13.2556 5.96353C13.3309 5.88821 13.4067 5.81289 13.4814 5.73757C13.5305 5.68803 13.5446 5.61625 13.5204 5.55711C13.4905 5.48482 13.4244 5.44489 13.3567 5.44438C13.3077 5.44438 13.2652 5.46359 13.2304 5.49847C13.0586 5.67034 12.8868 5.84171 12.7155 6.01358C12.7009 6.02824 12.6857 6.0434 12.6741 6.06059C12.6281 6.12934 12.6367 6.21729 12.6918 6.27138C12.7852 6.36389 12.8782 6.45741 12.9717 6.55042C13.0591 6.63787 13.1465 6.72583 13.2344 6.81328C13.29 6.86838 13.3642 6.88203 13.4304 6.84816C13.4895 6.81733 13.5259 6.7688 13.5315 6.70055C13.5355 6.64899 13.5163 6.60552 13.4804 6.56963C13.4062 6.49431 13.3314 6.42 13.2566 6.34519C13.2516 6.34013 13.2465 6.33457 13.24 6.328C13.2445 6.328 13.2455 6.328 13.247 6.328C13.6199 6.328 13.9932 6.328 14.3661 6.328C14.3797 6.328 14.3934 6.32749 14.407 6.32446C14.4131 6.32345 14.4186 6.32092 14.4242 6.31941C14.3464 6.77234 13.9518 7.1186 13.4769 7.1186C12.9464 7.1186 12.515 6.68691 12.515 6.15613C12.515 5.62535 12.9464 5.19365 13.4769 5.19365V5.19315Z",
    fill: "url(#paint105_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46212 3.33655C6.99731 3.33655 6.6189 3.71517 6.6189 4.18023C6.6189 4.64529 6.99731 5.02391 7.46212 5.02391C7.92692 5.02391 8.30534 4.64529 8.30534 4.18023C8.30534 3.71517 7.92692 3.33655 7.46212 3.33655ZM7.46212 4.89754C7.10896 4.89754 6.81543 4.64074 6.75682 4.30408C6.76945 4.30812 6.78309 4.31065 6.79724 4.31065C7.07309 4.31065 7.34895 4.31065 7.6248 4.31065H7.63692C7.63692 4.31065 7.63844 4.31267 7.63895 4.31368C7.6349 4.31672 7.63086 4.31975 7.62733 4.32329C7.57125 4.3794 7.51466 4.43551 7.45909 4.49162C7.42271 4.52852 7.4121 4.58211 7.43029 4.62608C7.45252 4.68017 7.50152 4.70949 7.55205 4.71C7.58842 4.71 7.62025 4.69534 7.64602 4.66956C7.77384 4.54167 7.90166 4.41377 8.02948 4.28538C8.0406 4.27425 8.05171 4.26313 8.0603 4.24999C8.09415 4.19893 8.08809 4.13322 8.04717 4.09278C7.97745 4.02353 7.90823 3.95427 7.83901 3.88502C7.77384 3.81981 7.70867 3.75409 7.64299 3.68939C7.60156 3.64844 7.54598 3.63833 7.49698 3.66361C7.45252 3.68636 7.42574 3.72275 7.4217 3.77381C7.41867 3.81223 7.43332 3.84458 7.45959 3.87137C7.51466 3.92748 7.57074 3.98258 7.62631 4.03869C7.63036 4.04273 7.63389 4.04678 7.63895 4.05183C7.63591 4.05183 7.6349 4.05183 7.63389 4.05183C7.35602 4.05183 7.07815 4.05183 6.79977 4.05183C6.78966 4.05183 6.77905 4.05234 6.76945 4.05436C6.76491 4.05537 6.76086 4.05689 6.75632 4.0584C6.81442 3.72073 7.10846 3.46292 7.46212 3.46292C7.8572 3.46292 8.17903 3.78442 8.17903 4.18023C8.17903 4.57604 7.85771 4.89754 7.46212 4.89754Z",
    fill: "url(#paint106_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 19.1415C12.2296 19.4524 12.4843 19.7031 12.795 19.7C13.1057 19.697 13.3563 19.4422 13.3532 19.1314C13.3502 18.8205 13.0956 18.5697 12.7849 18.5728C12.4741 18.5758 12.2236 18.8306 12.2266 19.1415ZM13.2689 19.1319C13.2709 19.3679 13.1011 19.5656 12.8768 19.607C12.8793 19.5984 12.8814 19.5893 12.8809 19.5802C12.8793 19.3957 12.8773 19.2112 12.8758 19.0267V19.0186C12.8758 19.0186 12.8773 19.0176 12.8778 19.0171C12.8798 19.0196 12.8819 19.0227 12.8844 19.0247C12.9223 19.0621 12.9597 19.099 12.9981 19.1364C13.0228 19.1607 13.0587 19.1673 13.088 19.1551C13.1239 19.14 13.1431 19.1066 13.1431 19.0732C13.1431 19.049 13.133 19.0277 13.1153 19.0105C13.0289 18.9256 12.943 18.8412 12.8566 18.7563C12.849 18.7492 12.8414 18.7416 12.8329 18.7361C12.7985 18.7138 12.7545 18.7184 12.7278 18.7457C12.6823 18.7927 12.6363 18.8392 12.5904 18.8862C12.5469 18.9302 12.504 18.9741 12.4605 19.0181C12.4332 19.0459 12.4267 19.0833 12.4443 19.1157C12.46 19.145 12.4843 19.1632 12.5181 19.1652C12.5439 19.1667 12.5651 19.1571 12.5833 19.1394C12.6202 19.102 12.657 19.0646 12.6939 19.0267C12.6964 19.0242 12.699 19.0217 12.7025 19.0181C12.7025 19.0202 12.7025 19.0212 12.7025 19.0217C12.704 19.2077 12.706 19.3932 12.7076 19.5792C12.7076 19.5858 12.7076 19.5929 12.7096 19.5995C12.7101 19.6025 12.7111 19.605 12.7121 19.608C12.4863 19.5711 12.3125 19.3765 12.3105 19.14C12.3079 18.8756 12.5211 18.6587 12.7854 18.6562C13.0496 18.6537 13.2663 18.867 13.2689 19.1314V19.1319Z",
    fill: "url(#paint107_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0073 33.0965C14.0063 33.513 14.3438 33.8522 14.7601 33.8537C15.1764 33.8547 15.5154 33.517 15.5169 33.1005C15.5179 32.684 15.1805 32.3448 14.7642 32.3433C14.3478 32.3418 14.0088 32.6799 14.0073 33.0965ZM15.4038 33.1005C15.4028 33.417 15.1724 33.6788 14.8713 33.7309C14.8748 33.7192 14.8773 33.7076 14.8773 33.695C14.8778 33.4478 14.8788 33.2006 14.8793 32.9534V32.9428C14.8793 32.9428 14.8814 32.9418 14.8819 32.9413C14.8849 32.9448 14.8874 32.9489 14.8905 32.9519C14.9405 33.0024 14.9905 33.053 15.041 33.103C15.0739 33.1359 15.1219 33.1455 15.1613 33.1293C15.2098 33.1096 15.236 33.0656 15.2365 33.0201C15.2365 32.9873 15.2239 32.959 15.2007 32.9357C15.0865 32.821 14.9723 32.7057 14.8581 32.5915C14.8485 32.5814 14.8384 32.5713 14.8268 32.5637C14.7813 32.5328 14.7222 32.5384 14.6858 32.5748C14.6237 32.637 14.5616 32.6991 14.4994 32.7608C14.4408 32.8189 14.3822 32.8771 14.3236 32.9357C14.2867 32.9726 14.2776 33.0222 14.3004 33.0666C14.3206 33.1061 14.3529 33.1308 14.3984 33.1344C14.4327 33.1369 14.4615 33.1243 14.4858 33.1005C14.5358 33.051 14.5858 33.0014 14.6358 32.9514C14.6394 32.9478 14.6429 32.9443 14.6474 32.9403C14.6474 32.9433 14.6474 32.9443 14.6474 32.9448C14.6469 33.1935 14.6459 33.4427 14.6454 33.6914C14.6454 33.7005 14.6454 33.7096 14.6474 33.7187C14.6485 33.7228 14.6495 33.7263 14.651 33.7304C14.3494 33.6778 14.119 33.4139 14.12 33.097C14.121 32.7431 14.4095 32.4555 14.7631 32.4565C15.1168 32.4575 15.4043 32.7462 15.4033 33.1L15.4038 33.1005Z",
    fill: "url(#paint108_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 14.036H21.8777V14.172H21.9626V14.036Z",
    fill: "url(#paint109_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 13.7924H21.8777V13.9283H21.9626V13.7924Z",
    fill: "url(#paint110_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 13.5492H21.8777V13.6852H21.9626V13.5492Z",
    fill: "url(#paint111_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 14.7689H21.8777V14.9049H21.9626V14.7689Z",
    fill: "url(#paint112_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 14.5248H21.8777V14.6608H21.9626V14.5248Z",
    fill: "url(#paint113_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 14.2816H21.8777V14.4176H21.9626V14.2816Z",
    fill: "url(#paint114_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 15.502H21.8777V15.6379H21.9626V15.502Z",
    fill: "url(#paint115_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 15.2578H21.8777V15.3938H21.9626V15.2578Z",
    fill: "url(#paint116_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 15.0146H21.8777V15.1506H21.9626V15.0146Z",
    fill: "url(#paint117_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 16.235H21.8777V16.371H21.9626V16.235Z",
    fill: "url(#paint118_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 15.9907H21.8777V16.1267H21.9626V15.9907Z",
    fill: "url(#paint119_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 15.7477H21.8777V15.8837H21.9626V15.7477Z",
    fill: "url(#paint120_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 16.7238H21.8777V16.8597H21.9626V16.7238Z",
    fill: "url(#paint121_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9626 16.4806H21.8777V16.6166H21.9626V16.4806Z",
    fill: "url(#paint122_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9622 17.1039V16.9679H21.8778V17.1039H21.5105L21.9197 17.8156L22.3295 17.1039H21.9622Z",
    fill: "url(#paint123_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1779 17.979L14.042 17.9802L14.0428 18.0651L14.1787 18.0639L14.1779 17.979Z",
    fill: "url(#paint124_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.933 17.9814L13.7971 17.9825L13.7979 18.0675L13.9338 18.0663L13.933 17.9814Z",
    fill: "url(#paint125_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6903 17.9829L13.5544 17.9841L13.5552 18.0691L13.6911 18.0678L13.6903 17.9829Z",
    fill: "url(#paint126_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9103 17.9723L14.7744 17.9735L14.7752 18.0584L14.9111 18.0572L14.9103 17.9723Z",
    fill: "url(#paint127_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6659 17.9744L14.53 17.9756L14.5308 18.0605L14.6667 18.0593L14.6659 17.9744Z",
    fill: "url(#paint128_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4233 17.9762L14.2874 17.9774L14.2881 18.0623L14.424 18.0611L14.4233 17.9762Z",
    fill: "url(#paint129_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6422 17.9657L15.5063 17.9669L15.5071 18.0518L15.643 18.0506L15.6422 17.9657Z",
    fill: "url(#paint130_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 17.9681L15.2625 17.9692L15.2632 18.0542L15.3991 18.053L15.3984 17.9681Z",
    fill: "url(#paint131_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1559 17.9696L15.02 17.9708L15.0208 18.0557L15.1567 18.0545L15.1559 17.9696Z",
    fill: "url(#paint132_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3747 17.959L16.2388 17.9602L16.2395 18.0451L16.3754 18.0439L16.3747 17.959Z",
    fill: "url(#paint133_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.131 17.9616L15.9951 17.9628L15.9959 18.0477L16.1318 18.0465L16.131 17.9616Z",
    fill: "url(#paint134_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8883 17.9634L15.7524 17.9646L15.7532 18.0495L15.8891 18.0483L15.8883 17.9634Z",
    fill: "url(#paint135_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.863 17.9552L16.7271 17.9564L16.7278 18.0413L16.8637 18.0402L16.863 17.9552Z",
    fill: "url(#paint136_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.62 17.9568L16.4841 17.958L16.4849 18.0429L16.6208 18.0417L16.62 17.9568Z",
    fill: "url(#paint137_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8197 17.988L17.1048 17.5846L17.1078 17.9521L16.9719 17.9531L16.9729 18.038L17.1088 18.0365L17.1083 17.9951L17.1119 18.404L17.8197 17.988Z",
    fill: "url(#paint138_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 16.983H13.8853V17.0801H13.9454V16.983Z",
    fill: "url(#paint139_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 16.8096H13.8853V16.9066H13.9454V16.8096Z",
    fill: "url(#paint140_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 16.6362H13.8853V16.7333H13.9454V16.6362Z",
    fill: "url(#paint141_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 17.5046H13.8853V17.6017H13.9454V17.5046Z",
    fill: "url(#paint142_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 17.3308H13.8853V17.4279H13.9454V17.3308Z",
    fill: "url(#paint143_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 17.158H13.8853V17.2545H13.9454V17.158Z",
    fill: "url(#paint144_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.0264H13.8853V18.1234H13.9454V18.0264Z",
    fill: "url(#paint145_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 17.8524H13.8853V17.949H13.9454V17.8524Z",
    fill: "url(#paint146_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 17.6796H13.8853V17.7766H13.9454V17.6796Z",
    fill: "url(#paint147_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.5481H13.8853V18.6452H13.9454V18.5481Z",
    fill: "url(#paint148_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.3741H13.8853V18.4712H13.9454V18.3741Z",
    fill: "url(#paint149_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.2013H13.8853V18.2983H13.9454V18.2013Z",
    fill: "url(#paint150_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.8959H13.8853V18.9929H13.9454V18.8959Z",
    fill: "url(#paint151_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9454 18.7229H13.8853V18.82H13.9454V18.7229Z",
    fill: "url(#paint152_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9453 19.1663V19.0692H13.8852V19.1663H13.624L13.915 19.6728L14.2071 19.1663H13.9453Z",
    fill: "url(#paint153_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1999 24.4034L16.115 24.4042L16.1162 24.5402L16.201 24.5394L16.1999 24.4034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2025 24.6471L16.1177 24.6478L16.1189 24.7838L16.2038 24.783L16.2025 24.6471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2047 24.8907L16.1199 24.8915L16.1211 25.0275L16.206 25.0267L16.2047 24.8907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1935 23.6705L16.1086 23.6713L16.1098 23.8072L16.1947 23.8065L16.1935 23.6705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.196 23.9141L16.1111 23.9149L16.1123 24.0509L16.1972 24.0501L16.196 23.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1982 24.1573L16.1133 24.1581L16.1145 24.2941L16.1994 24.2933L16.1982 24.1573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1869 22.9376L16.1021 22.9384L16.1032 23.0743L16.1881 23.0736L16.1869 22.9376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1894 23.1812L16.1045 23.182L16.1057 23.318L16.1906 23.3172L16.1894 23.1812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1921 23.4244L16.1072 23.4252L16.1084 23.5611L16.1933 23.5604L16.1921 23.4244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1806 22.2052L16.0957 22.2059L16.0969 22.3419L16.1818 22.3412L16.1806 22.2052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1833 22.4484L16.0984 22.4492L16.0996 22.5852L16.1845 22.5844L16.1833 22.4484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.185 22.6915L16.1001 22.6923L16.1013 22.8282L16.1862 22.8275L16.185 22.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1763 21.6069L16.1748 21.4709L16.1324 21.4714L16.5421 21.4679L16.1263 20.7596L15.7231 21.4749L16.0904 21.4719L16.0915 21.6079L16.1763 21.6069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1759 21.7159L16.0911 21.7167L16.0923 21.8527L16.1771 21.8519L16.1759 21.7159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1781 21.9592L16.0933 21.96L16.0945 22.0959L16.1794 22.0952L16.1781 21.9592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11808 23.4164L5.0332 23.4171L5.03439 23.5531L5.11926 23.5523L5.11808 23.4164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12076 23.6604L5.03589 23.6611L5.03712 23.7971L5.122 23.7963L5.12076 23.6604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12296 23.9038L5.03809 23.9045L5.0393 24.0405L5.12417 24.0398L5.12296 23.9038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11173 22.6841L5.02686 22.6848L5.02804 22.8208L5.11292 22.82L5.11173 22.6841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11393 22.9276L5.02905 22.9283L5.03029 23.0643L5.11516 23.0635L5.11393 22.9276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11564 23.1708L5.03076 23.1715L5.03195 23.3075L5.11682 23.3067L5.11564 23.1708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10489 21.9512L5.02002 21.9519L5.02121 22.0879L5.10608 22.0871L5.10489 21.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10734 22.1952L5.02246 22.1959L5.02369 22.3319L5.10857 22.3311L5.10734 22.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10953 22.4383L5.02466 22.4391L5.02589 22.5751L5.11077 22.5743L5.10953 22.4383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09855 21.2183L5.01367 21.219L5.01486 21.355L5.09973 21.3542L5.09855 21.2183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10074 21.4622L5.01587 21.463L5.0171 21.599L5.10198 21.5982L5.10074 21.4622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10294 21.7054L5.01807 21.7062L5.0193 21.8422L5.10417 21.8414L5.10294 21.7054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09379 20.6211L5.09278 20.4852H5.04984L5.46008 20.4816L5.04428 19.7739L4.64111 20.4892L5.00791 20.4857L5.00942 20.6217L5.09379 20.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09464 20.7293L5.00977 20.7301L5.011 20.8661L5.09587 20.8653L5.09464 20.7293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09635 20.9725L5.01147 20.9733L5.01271 21.1092L5.09758 21.1085L5.09635 20.9725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 10.8341H3.44043V10.9701H3.52531V10.8341Z",
    fill: "url(#paint154_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 10.59H3.44043V10.7259H3.52531V10.59Z",
    fill: "url(#paint155_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 10.3468H3.44043V10.4828H3.52531V10.3468Z",
    fill: "url(#paint156_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 11.5665H3.44043V11.7025H3.52531V11.5665Z",
    fill: "url(#paint157_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 11.3229H3.44043V11.4589H3.52531V11.3229Z",
    fill: "url(#paint158_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 11.0798H3.44043V11.2158H3.52531V11.0798Z",
    fill: "url(#paint159_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 12.2996H3.44043V12.4355H3.52531V12.2996Z",
    fill: "url(#paint160_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 12.0559H3.44043V12.1919H3.52531V12.0559Z",
    fill: "url(#paint161_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 11.8123H3.44043V11.9482H3.52531V11.8123Z",
    fill: "url(#paint162_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 13.0326H3.44043V13.1686H3.52531V13.0326Z",
    fill: "url(#paint163_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 12.7883H3.44043V12.9243H3.52531V12.7883Z",
    fill: "url(#paint164_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 12.5453H3.44043V12.6813H3.52531V12.5453Z",
    fill: "url(#paint165_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 13.5214H3.44043V13.6573H3.52531V13.5214Z",
    fill: "url(#paint166_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52531 13.2782H3.44043V13.4142H3.52531V13.2782Z",
    fill: "url(#paint167_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5254 13.9015V13.7655H3.44052V13.9015H3.07373L3.48296 14.6132L3.8927 13.9015H3.5254Z",
    fill: "url(#paint168_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8324 34.9203L11.8323 34.9795L11.9273 34.9797L11.9274 34.9206L11.8324 34.9203Z",
    fill: "url(#paint169_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.661 34.9177L11.6609 34.9768L11.7559 34.977L11.756 34.9179L11.661 34.9177Z",
    fill: "url(#paint170_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4916 34.9199L11.4915 34.979L11.5864 34.9793L11.5866 34.9201L11.4916 34.9199Z",
    fill: "url(#paint171_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3446 34.9219L12.3445 34.9811L12.4395 34.9813L12.4396 34.9222L12.3446 34.9219Z",
    fill: "url(#paint172_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1745 34.921L12.1743 34.9801L12.2693 34.9804L12.2695 34.9212L12.1745 34.921Z",
    fill: "url(#paint173_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0043 34.921L12.0042 34.9801L12.0991 34.9804L12.0993 34.9212L12.0043 34.921Z",
    fill: "url(#paint174_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8568 34.9229L12.8567 34.9821L12.9517 34.9823L12.9518 34.9232L12.8568 34.9229Z",
    fill: "url(#paint175_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6867 34.9229L12.6865 34.9821L12.7815 34.9823L12.7817 34.9232L12.6867 34.9229Z",
    fill: "url(#paint176_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5163 34.9224L12.5161 34.9816L12.6111 34.9818L12.6112 34.9227L12.5163 34.9224Z",
    fill: "url(#paint177_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3688 34.9245L13.3687 34.9836L13.4636 34.9839L13.4638 34.9247L13.3688 34.9245Z",
    fill: "url(#paint178_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 34.9239L13.1985 34.983L13.2935 34.9833L13.2936 34.9241L13.1986 34.9239Z",
    fill: "url(#paint179_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0285 34.9234L13.0283 34.9825L13.1233 34.9828L13.1235 34.9237L13.0285 34.9234Z",
    fill: "url(#paint180_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7108 34.9255L13.7107 34.9846L13.8057 34.9849L13.8058 34.9257L13.7108 34.9255Z",
    fill: "url(#paint181_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5407 34.925L13.5405 34.9841L13.6355 34.9844L13.6357 34.9252L13.5407 34.925Z",
    fill: "url(#paint182_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4737 34.9567L13.9771 34.6686L13.9766 34.9254H13.8811V34.9845L13.9761 34.985V34.9552L13.9756 35.2418L14.4737 34.9567Z",
    fill: "url(#paint183_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.1871H13.6331V31.2822H13.6922V31.1871Z",
    fill: "url(#paint184_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.0168H13.6331V31.1119H13.6922V31.0168Z",
    fill: "url(#paint185_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 30.8464H13.6331V30.9415H13.6922V30.8464Z",
    fill: "url(#paint186_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.6997H13.6331V31.7947H13.6922V31.6997Z",
    fill: "url(#paint187_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.5288H13.6331V31.6238H13.6922V31.5288Z",
    fill: "url(#paint188_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.359H13.6331V31.454H13.6922V31.359Z",
    fill: "url(#paint189_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.2123H13.6331V32.3073H13.6922V32.2123Z",
    fill: "url(#paint190_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.0415H13.6331V32.1365H13.6922V32.0415Z",
    fill: "url(#paint191_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 31.8716H13.6331V31.9666H13.6922V31.8716Z",
    fill: "url(#paint192_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.7249H13.6331V32.8199H13.6922V32.7249Z",
    fill: "url(#paint193_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.5541H13.6331V32.6491H13.6922V32.5541Z",
    fill: "url(#paint194_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.3842H13.6331V32.4792H13.6922V32.3842Z",
    fill: "url(#paint195_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 33.0667H13.6331V33.1617H13.6922V33.0667Z",
    fill: "url(#paint196_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 32.8962H13.6331V32.9913H13.6922V32.8962Z",
    fill: "url(#paint197_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6922 33.3325V33.2369H13.6331V33.3325H13.376L13.6624 33.8299L13.9489 33.3325H13.6922Z",
    fill: "url(#paint198_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9537 30.2063L15.9536 30.2467L16.0188 30.2469L16.0189 30.2064L15.9537 30.2063Z",
    fill: "url(#paint199_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 30.2068L16.0713 30.2472L16.1365 30.2474L16.1366 30.2069L16.0714 30.2068Z",
    fill: "url(#paint200_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1874 30.2064L16.1873 30.2468L16.2524 30.247L16.2525 30.2066L16.1874 30.2064Z",
    fill: "url(#paint201_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6039 30.2053L15.6038 30.2457L15.6689 30.2459L15.669 30.2055L15.6039 30.2053Z",
    fill: "url(#paint202_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7203 30.2053L15.7202 30.2457L15.7854 30.2459L15.7855 30.2055L15.7203 30.2053Z",
    fill: "url(#paint203_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8368 30.2058L15.8367 30.2462L15.9018 30.2464L15.902 30.2059L15.8368 30.2058Z",
    fill: "url(#paint204_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2528 30.2043L15.2527 30.2448L15.3179 30.2449L15.318 30.2045L15.2528 30.2043Z",
    fill: "url(#paint205_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3678 30.2019L15.3677 30.2423L15.4328 30.2425L15.433 30.2021L15.3678 30.2019Z",
    fill: "url(#paint206_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4857 30.2048L15.4856 30.2452L15.5508 30.2454L15.5509 30.205L15.4857 30.2048Z",
    fill: "url(#paint207_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9017 30.2032L14.9016 30.2437L14.9668 30.2438L14.9669 30.2034L14.9017 30.2032Z",
    fill: "url(#paint208_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0187 30.2038L15.0186 30.2443L15.0837 30.2444L15.0838 30.204L15.0187 30.2038Z",
    fill: "url(#paint209_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1346 30.2038L15.1345 30.2443L15.1997 30.2444L15.1998 30.204L15.1346 30.2038Z",
    fill: "url(#paint210_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5506 30.2027L14.5505 30.2432L14.6157 30.2433L14.6158 30.2029L14.5506 30.2027Z",
    fill: "url(#paint211_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 30.2027L14.6675 30.2432L14.7327 30.2433L14.7328 30.2029L14.6676 30.2027Z",
    fill: "url(#paint212_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7836 30.2032L14.7834 30.2437L14.8486 30.2438L14.8487 30.2034L14.7836 30.2032Z",
    fill: "url(#paint213_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.209 30.2191L14.549 30.4167L14.55 30.0239L14.209 30.2191Z",
    fill: "url(#paint214_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 4.60535H11.7942V4.69886H11.8523V4.60535Z",
    fill: "url(#paint215_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 4.4375H11.7942V4.53102H11.8523V4.4375Z",
    fill: "url(#paint216_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 4.27014H11.7942V4.36366H11.8523V4.27014Z",
    fill: "url(#paint217_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.10925H11.7942V5.20277H11.8523V5.10925Z",
    fill: "url(#paint218_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 4.94141H11.7942V5.03492H11.8523V4.94141Z",
    fill: "url(#paint219_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 4.77417H11.7942V4.86769H11.8523V4.77417Z",
    fill: "url(#paint220_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.61328H11.7942V5.7068H11.8523V5.61328Z",
    fill: "url(#paint221_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.44543H11.7942V5.53895H11.8523V5.44543Z",
    fill: "url(#paint222_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.27808H11.7942V5.37159H11.8523V5.27808Z",
    fill: "url(#paint223_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 6.11719H11.7942V6.21071H11.8523V6.11719Z",
    fill: "url(#paint224_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.94946H11.7942V6.04298H11.8523V5.94946Z",
    fill: "url(#paint225_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 5.7821H11.7942V5.87562H11.8523V5.7821Z",
    fill: "url(#paint226_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 6.45337H11.7942V6.54689H11.8523V6.45337Z",
    fill: "url(#paint227_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 6.28613H11.7942V6.37965H11.8523V6.28613Z",
    fill: "url(#paint228_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8522 6.71473V6.62122H11.7941V6.71473H11.5415L11.8229 7.20406L12.1043 6.71473H11.8522Z",
    fill: "url(#paint229_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7168 4.7776L11.7166 4.85596L11.8418 4.85629L11.8421 4.77793L11.7168 4.7776Z",
    fill: "url(#paint230_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9416 4.77822L11.9414 4.85657L12.0667 4.8569L12.0669 4.77854L11.9416 4.77822Z",
    fill: "url(#paint231_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1657 4.77846L12.1655 4.85681L12.2908 4.85712L12.291 4.77877L12.1657 4.77846Z",
    fill: "url(#paint232_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 4.77602L11.0415 4.85437L11.1668 4.85468L11.167 4.77632L11.0417 4.77602Z",
    fill: "url(#paint233_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 4.77614L11.2664 4.85449L11.3917 4.85482L11.3919 4.77647L11.2666 4.77614Z",
    fill: "url(#paint234_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4909 4.77712L11.4907 4.85547L11.616 4.8558L11.6162 4.77744L11.4909 4.77712Z",
    fill: "url(#paint235_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3664 4.77406L10.3662 4.85242L10.4915 4.85275L10.4917 4.77439L10.3664 4.77406Z",
    fill: "url(#paint236_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5913 4.77455L10.5911 4.85291L10.7164 4.85323L10.7166 4.77488L10.5913 4.77455Z",
    fill: "url(#paint237_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8151 4.77516L10.8149 4.85352L10.9402 4.85384L10.9404 4.77549L10.8151 4.77516Z",
    fill: "url(#paint238_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69063 4.77211L9.69043 4.85046L9.81572 4.85079L9.81593 4.77244L9.69063 4.77211Z",
    fill: "url(#paint239_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91598 4.7726L9.91577 4.85095L10.0411 4.85128L10.0413 4.77293L9.91598 4.7726Z",
    fill: "url(#paint240_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1399 4.77309L10.1396 4.85144L10.2649 4.85177L10.2651 4.77342L10.1399 4.77309Z",
    fill: "url(#paint241_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2402 4.77101L9.23999 4.84937L9.36529 4.84969L9.36549 4.77134L9.2402 4.77101Z",
    fill: "url(#paint242_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46407 4.77162L9.46387 4.84998L9.58916 4.8503L9.58937 4.77195L9.46407 4.77162Z",
    fill: "url(#paint243_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0169 4.43188L8.36011 4.80798L9.01488 5.18761L9.01538 4.84892L9.14068 4.84943L9.14119 4.77108L9.01589 4.77057L9.0169 4.43188Z",
    fill: "url(#paint244_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.871045 28.5823C0.871045 28.7835 0.774041 28.9619 0.625 29.0746V30.7731C0.631063 30.7721 0.637125 30.7716 0.643188 30.7706L0.695226 31.0016C0.708362 31.0602 0.766463 31.0971 0.825069 31.084L0.838205 31.081C0.896811 31.0678 0.933692 31.0097 0.920557 30.9505L0.868518 30.7185L0.843257 30.7241C0.910452 30.7054 0.976131 30.6831 1.0408 30.6584L1.02211 30.6665L1.11456 30.8853C1.1378 30.9409 1.20197 30.9667 1.25704 30.943L1.26916 30.9379C1.32474 30.9147 1.3505 30.8505 1.32676 30.7954L1.2343 30.5765L1.16458 30.6058C1.22975 30.576 1.29341 30.5431 1.35505 30.5072L1.47883 30.7013C1.51116 30.7519 1.57836 30.767 1.62939 30.7347L1.6405 30.7276C1.69102 30.6953 1.70618 30.628 1.67385 30.577L1.54906 30.3803C1.59756 30.345 1.64505 30.3081 1.69052 30.2691L1.84663 30.4365C1.88756 30.4804 1.95677 30.483 2.00073 30.4415L2.01033 30.4324C2.05428 30.3915 2.05681 30.3222 2.01538 30.2782L1.85724 30.1089C1.8916 30.0725 1.92494 30.0346 1.95728 29.9957L2.14371 30.1357C2.1917 30.1721 2.25991 30.162 2.29628 30.1139L2.30437 30.1033C2.34024 30.0553 2.33064 29.9871 2.28264 29.9507L2.0952 29.8096C2.1235 29.7672 2.15078 29.7232 2.17604 29.6782L2.38621 29.7864C2.43977 29.8137 2.50545 29.7929 2.53273 29.7394L2.53879 29.7277C2.56607 29.6742 2.54536 29.6084 2.49181 29.5811L2.28062 29.4725L2.27304 29.4871C2.29679 29.4345 2.31801 29.3805 2.33771 29.3259L2.3362 29.3304L2.56304 29.4012C2.62064 29.4189 2.68127 29.387 2.69945 29.3294L2.7035 29.3168C2.72118 29.2591 2.68935 29.1985 2.63175 29.1803L2.40491 29.1095L2.38925 29.1606C2.41299 29.0736 2.43118 28.9841 2.44431 28.8932L2.43674 28.9528L2.67217 28.9826C2.73179 28.9902 2.78635 28.9477 2.79393 28.8881L2.79545 28.875C2.80302 28.8153 2.76059 28.7607 2.70097 28.7531L2.46553 28.7233L2.45139 28.8365C2.45897 28.7728 2.46402 28.7081 2.46604 28.6424C2.46756 28.5828 2.46604 28.5241 2.46351 28.466L2.46806 28.5575L2.70501 28.5454C2.76513 28.5423 2.81111 28.4908 2.80808 28.4311V28.418C2.80403 28.3578 2.75301 28.3118 2.69289 28.3149L2.45594 28.327L2.46048 28.4099C2.45442 28.3315 2.44431 28.2542 2.43067 28.1784L2.65651 28.1258C2.71512 28.1122 2.75149 28.0535 2.73785 27.9949L2.73482 27.9817C2.72118 27.9231 2.66257 27.8867 2.60397 27.9003L2.37712 27.9529C2.36702 27.9175 2.3559 27.8827 2.34378 27.8483L2.56153 27.7613C2.6171 27.7391 2.64438 27.6754 2.62215 27.6198L2.6171 27.6077C2.59487 27.5516 2.53121 27.5248 2.47564 27.547L2.25637 27.6345C2.23263 27.5844 2.20787 27.5349 2.18059 27.4868L2.37661 27.3645C2.42764 27.3327 2.4433 27.2654 2.41148 27.2144L2.4044 27.2033C2.37257 27.1522 2.30538 27.1365 2.25435 27.1684L2.05681 27.2917C2.02498 27.2467 1.99113 27.2038 1.95627 27.1613L2.12855 27.0041C2.17301 26.9637 2.17604 26.8949 2.13562 26.8504L2.12653 26.8408C2.08611 26.7963 2.0174 26.7933 1.97294 26.8337L1.80015 26.9915C1.76024 26.9525 1.71932 26.9151 1.67688 26.8792L1.69052 26.8898L1.83602 26.7023C1.87291 26.6548 1.86432 26.5865 1.81683 26.5496L1.80622 26.5416C1.75872 26.5047 1.69052 26.5132 1.65364 26.5608L1.50813 26.7483L1.52329 26.7599C1.46873 26.7215 1.41265 26.6851 1.35454 26.6513L1.46216 26.4415C1.48944 26.3879 1.46822 26.3222 1.41517 26.2949L1.40355 26.2888C1.35 26.2615 1.28432 26.2827 1.25704 26.3363L1.14942 26.5466C1.10092 26.5249 1.05141 26.5052 1.00139 26.487L1.0701 26.263C1.08779 26.2054 1.05545 26.1447 0.997856 26.127L0.985225 26.123C0.92763 26.1053 0.867003 26.1377 0.84932 26.1953L0.780609 26.4197C0.730087 26.4071 0.678554 26.3965 0.626516 26.3874V28.0889C0.775557 28.2016 0.87256 28.3801 0.87256 28.5813L0.871045 28.5823ZM1.61019 28.1986C1.82087 28.1986 1.99214 28.3695 1.99214 28.5808C1.99214 28.7921 1.82137 28.9629 1.61019 28.9629C1.399 28.9629 1.22824 28.7921 1.22824 28.5808C1.22824 28.3695 1.399 28.1986 1.61019 28.1986Z",
    fill: "url(#paint245_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17549 33.3172C2.22162 33.4856 1.58454 34.396 1.75278 35.3504C1.76237 35.406 1.77501 35.4606 1.78966 35.5136H2.06399C2.04176 35.4464 2.02358 35.3767 2.01095 35.3044C1.97608 35.1067 1.98265 34.9116 2.02459 34.7271L2.80465 35.0112C2.80213 35.0607 2.80465 35.1118 2.81375 35.1628C2.838 35.3003 2.90216 35.4201 2.99209 35.5136H3.96819C4.11217 35.363 4.18594 35.1487 4.14704 34.9278C4.13845 34.8787 4.1243 34.8322 4.10662 34.7883L4.70076 34.2893C4.79271 34.4405 4.8594 34.6113 4.89174 34.7963C4.93569 35.045 4.91397 35.2902 4.83919 35.5136H5.17113C5.23883 35.2695 5.25449 35.0066 5.20801 34.7407C5.03977 33.7863 4.12986 33.1489 3.17599 33.3172H3.17549ZM3.53824 35.3756C3.35636 35.408 3.18256 35.2862 3.15023 35.1037C3.11789 34.9212 3.23965 34.7478 3.42204 34.7155C3.60392 34.6831 3.77772 34.8049 3.81005 34.9874C3.84239 35.1694 3.72063 35.3433 3.53824 35.3756ZM3.86714 34.49C3.72517 34.3909 3.54582 34.3459 3.36242 34.3783C3.18105 34.4101 3.02998 34.5117 2.93045 34.6503L2.15746 34.3687C2.36107 33.9825 2.73392 33.6908 3.19721 33.6089C3.67313 33.525 4.13542 33.6817 4.46078 33.9911L3.86714 34.4895V34.49Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54676 35.3555L6.26585 35.3115C6.27091 35.2574 6.27495 35.2028 6.27697 35.1482L6.56141 35.1421C6.65285 35.1401 6.72561 35.0643 6.72359 34.9728C6.72157 34.8813 6.64578 34.8085 6.55434 34.8105L6.26939 34.8166C6.26686 34.7852 6.26383 34.7534 6.25979 34.7221L6.54019 34.6725C6.63012 34.6569 6.69024 34.5704 6.67458 34.4804C6.65892 34.3905 6.57252 34.3298 6.48259 34.346L6.20219 34.3955C6.19007 34.3445 6.17643 34.2939 6.16178 34.2439L6.42955 34.1463C6.51543 34.115 6.55989 34.0199 6.52857 33.934C6.49725 33.848 6.40226 33.8036 6.31638 33.8349L6.04911 33.9325C6.0284 33.8849 6.00667 33.8379 5.98394 33.7914L6.22998 33.6489C6.3093 33.6029 6.33608 33.5018 6.29061 33.4224C6.24463 33.3431 6.14359 33.3163 6.06427 33.3618L5.81822 33.5038C5.78943 33.4603 5.75962 33.4184 5.7288 33.3769L5.94655 33.1939C6.01678 33.1348 6.02587 33.0307 5.96676 32.9604C5.90815 32.8901 5.80357 32.881 5.73335 32.9402L5.51559 33.1232C5.47972 33.0858 5.44335 33.0488 5.40596 33.013L5.58835 32.7951C5.64695 32.7248 5.63786 32.6202 5.56763 32.5615C5.49741 32.5029 5.39282 32.512 5.33422 32.5823L5.15133 32.8001C5.1099 32.7693 5.06746 32.7395 5.02401 32.7112L5.16598 32.465C5.21145 32.3856 5.18467 32.2845 5.10535 32.2385C5.02603 32.1925 4.92499 32.2198 4.87901 32.2992L4.73755 32.5444C4.69107 32.5211 4.64408 32.4994 4.59659 32.4786L4.69359 32.2122C4.72492 32.1263 4.68046 32.0313 4.59457 31.9999C4.50868 31.9686 4.4137 32.0131 4.38237 32.099L4.28588 32.3649C4.23636 32.3502 4.18635 32.3361 4.13582 32.324L4.18483 32.0459C4.20049 31.956 4.14037 31.87 4.05044 31.8538C3.96051 31.8382 3.87462 31.8983 3.85846 31.9883L3.80945 32.2663C3.75792 32.2603 3.70638 32.2557 3.65435 32.2527V31.9706C3.65435 31.8791 3.58008 31.8048 3.48863 31.8048C3.39719 31.8048 3.32292 31.8791 3.32292 31.9706V32.2527C3.27391 32.2557 3.2244 32.2598 3.17489 32.2653L3.12689 31.9873C3.11123 31.8973 3.02534 31.8367 2.93541 31.8523C2.84548 31.868 2.78485 31.9539 2.80052 32.0439L2.84851 32.3209C2.7894 32.3346 2.7318 32.3507 2.67421 32.3679L2.5762 32.1041C2.54437 32.0181 2.44888 31.9747 2.36299 32.0065C2.2771 32.0384 2.23365 32.1339 2.26548 32.2198L2.36299 32.4827C2.31853 32.5024 2.27458 32.5226 2.23163 32.5444L2.09118 32.3022C2.0452 32.2229 1.94365 32.1961 1.86484 32.2421C1.78602 32.2881 1.75874 32.3897 1.80472 32.4685L1.94517 32.7107C1.89919 32.741 1.85473 32.7728 1.81128 32.8057L1.63041 32.5924C1.5713 32.5226 1.46672 32.514 1.397 32.5732C1.32728 32.6323 1.31869 32.737 1.3778 32.8067L1.55817 33.02C1.51522 33.061 1.4743 33.1029 1.43388 33.1464L1.21765 32.9695C1.14691 32.9114 1.04233 32.922 0.984232 32.9927C0.926131 33.0635 0.936741 33.1681 1.00747 33.2263L1.22371 33.4032C1.19339 33.4447 1.1646 33.4871 1.13681 33.5306L0.893291 33.3941C0.813466 33.3491 0.712421 33.3774 0.667456 33.4573C0.622491 33.5372 0.650783 33.6383 0.730609 33.6833L0.973622 33.8197C0.951392 33.8652 0.930678 33.9112 0.910974 33.9577L0.648257 33.8652C0.640679 33.8627 0.632595 33.8612 0.624512 33.8597V34.2085L0.799825 34.2701C0.783152 34.3283 0.768501 34.3864 0.755365 34.4456L0.624512 34.4248V34.7605L0.704337 34.7731C0.699285 34.8277 0.695243 34.8823 0.693222 34.9374L0.624512 34.9389V35.2705L0.700295 35.269C0.702822 35.3009 0.705853 35.3327 0.709895 35.3646L0.624512 35.3797V35.5137H1.13428C1.13075 35.4955 1.12671 35.4778 1.12317 35.4601C0.893291 34.1549 1.76379 32.9108 3.06828 32.6803C4.37278 32.4503 5.61613 33.3213 5.84652 34.6265C5.90007 34.9298 5.8935 35.2291 5.83641 35.5137H6.68671C6.68418 35.4358 6.62709 35.3676 6.54726 35.3555H6.54676Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1787 8.15643C17.1787 8.09425 17.1282 8.0437 17.066 8.0437C17.0039 8.0437 16.9534 8.09425 16.9534 8.15643V8.43547H17.1787V8.15643Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6182 12.8242C21.6803 12.8242 21.7309 12.7736 21.7309 12.7114C21.7309 12.6493 21.6803 12.5987 21.6182 12.5987H21.3393V12.6058C21.3373 12.5259 21.3333 12.4466 21.3267 12.3677V12.3707L21.6046 12.3409C21.6667 12.3343 21.7112 12.2787 21.7046 12.2166C21.698 12.1544 21.6425 12.1099 21.5803 12.1165L21.3029 12.1458C21.2923 12.0654 21.2797 11.9855 21.2645 11.9067L21.5369 11.847C21.5975 11.8339 21.6364 11.7737 21.6227 11.7126C21.6096 11.6519 21.5495 11.613 21.4884 11.6266L21.2165 11.6863C21.2014 11.6241 21.1842 11.5624 21.1665 11.5013L21.4313 11.4153C21.4904 11.3961 21.5232 11.3324 21.504 11.2733C21.4848 11.2142 21.4212 11.1813 21.3621 11.2005L21.0973 11.2864C21.0695 11.2076 21.0402 11.1297 21.0079 11.0534L21.261 10.9392C21.3176 10.9134 21.3429 10.8467 21.3176 10.79C21.2918 10.7334 21.2251 10.7081 21.1686 10.7334L20.9149 10.8482C20.8871 10.7905 20.8578 10.7339 20.8275 10.6778L21.069 10.5388C21.1231 10.508 21.1418 10.4387 21.1105 10.3846C21.0796 10.3305 21.0104 10.3118 20.9564 10.3432L20.7144 10.4822C20.6588 10.3912 20.5987 10.3027 20.5365 10.2163L20.5734 10.2663L20.7982 10.101C20.8482 10.0641 20.8588 9.99336 20.822 9.94332C20.7851 9.89328 20.7144 9.88215 20.6643 9.91956L20.4395 10.0849L20.4668 10.1218C20.4016 10.0363 20.3329 9.95343 20.2617 9.87305L20.3188 9.93624L20.5264 9.74971C20.5729 9.70826 20.5764 9.63699 20.535 9.59048C20.4936 9.54397 20.4223 9.54043 20.3759 9.58189L20.1682 9.76842L20.2101 9.81492C20.1258 9.72343 20.0379 9.63547 19.9459 9.55156L19.9782 9.57986L20.1626 9.37059C20.2041 9.32408 20.1995 9.2528 20.1525 9.21135C20.1061 9.1699 20.0348 9.17445 19.9934 9.22146L19.809 9.43074L19.9176 9.52679C19.8247 9.44338 19.7287 9.36401 19.6286 9.28869L19.6594 9.31094L19.8226 9.08447C19.859 9.03392 19.8479 8.96366 19.7974 8.92675C19.7468 8.89036 19.6766 8.90148 19.6397 8.95203L19.4766 9.17849L19.5968 9.26544C19.4533 9.15979 19.3033 9.06324 19.1471 8.97629L19.281 9.05262L19.4195 8.80998C19.4503 8.7559 19.4316 8.68715 19.3775 8.65631C19.3235 8.62548 19.2548 8.64418 19.2239 8.69827L19.0855 8.94091L19.1007 8.9495C19.0032 8.89693 18.9031 8.8484 18.8016 8.80341L18.8769 8.83627L18.9885 8.58049C19.0133 8.52336 18.9875 8.45664 18.9304 8.43187C18.8733 8.4071 18.8066 8.43288 18.7819 8.49L18.6702 8.74579L18.7031 8.75994C18.6076 8.72051 18.5101 8.68462 18.411 8.65176L18.4914 8.67805L18.5773 8.41266C18.5965 8.35352 18.5641 8.28982 18.505 8.27061C18.4459 8.2514 18.3822 8.28376 18.363 8.34341L18.2772 8.60879L18.3125 8.62042C18.1999 8.58605 18.0852 8.55673 17.9685 8.53145L18.0473 8.54763L18.1039 8.27415C18.1165 8.21299 18.0776 8.15334 18.0165 8.1407C17.9553 8.12806 17.8957 8.16698 17.8831 8.22815L17.8265 8.50163L17.8972 8.51629C17.7714 8.49152 17.6436 8.4718 17.5138 8.45815L17.5946 8.46624L17.6219 8.18822C17.6279 8.12604 17.5825 8.07094 17.5208 8.06487C17.4587 8.05881 17.4036 8.1043 17.3976 8.16597L17.3703 8.444L17.49 8.45563C17.3506 8.44198 17.2091 8.4344 17.0661 8.4344C16.9231 8.4344 16.7797 8.44198 16.6392 8.45563L16.7256 8.44653L16.6963 8.16901C16.6897 8.10683 16.6342 8.06235 16.572 8.06892C16.5099 8.07549 16.4654 8.13109 16.472 8.19327L16.5018 8.47079L16.6139 8.45866C16.4806 8.47281 16.3487 8.49303 16.2194 8.51881L16.2633 8.50921L16.2037 8.23674C16.1906 8.17608 16.1304 8.13716 16.0693 8.15081C16.0082 8.16446 15.9698 8.22411 15.9834 8.28527L16.043 8.55774L16.1562 8.53297C16.043 8.55774 15.9314 8.58605 15.8218 8.61941L15.8581 8.60778L15.7722 8.34239C15.753 8.28325 15.6894 8.25039 15.6303 8.2696C15.5712 8.28881 15.5383 8.3525 15.5575 8.41165L15.6434 8.67704L15.7232 8.65126C15.6146 8.68715 15.508 8.72607 15.4034 8.77056L15.411 8.76702L15.2963 8.51275C15.2706 8.45613 15.2039 8.43086 15.1473 8.45613C15.0907 8.48191 15.0654 8.54864 15.0907 8.60526L15.2054 8.85952L15.268 8.83122C15.0109 8.95051 14.7679 9.09458 14.542 9.26039L14.6234 9.20023L14.4582 8.97528C14.4213 8.92524 14.3505 8.91462 14.3005 8.95152C14.2505 8.98843 14.2399 9.0592 14.2768 9.10924L14.442 9.33419L14.491 9.2983C14.397 9.36907 14.3066 9.44388 14.2192 9.52224L14.294 9.455L14.1075 9.24724C14.0661 9.20074 13.9949 9.1972 13.9484 9.23865C13.9019 9.2801 13.8984 9.35138 13.9398 9.39788L14.1262 9.60564L14.1752 9.56167C14.0833 9.64608 13.9954 9.73404 13.911 9.82604L13.9378 9.79571L13.7286 9.6112C13.6821 9.56975 13.6109 9.5743 13.5695 9.62131C13.528 9.66782 13.5326 9.7391 13.5796 9.78055L13.7887 9.96556L13.8655 9.87862C13.7918 9.96202 13.721 10.048 13.6538 10.1364L13.6695 10.1147L13.4432 9.95141C13.3926 9.91501 13.3224 9.92613 13.2855 9.97668C13.2492 10.0272 13.2603 10.0975 13.3108 10.1344L13.5371 10.2977L13.5745 10.2461C13.5174 10.327 13.4624 10.4089 13.4108 10.4933L13.1688 10.3553C13.1148 10.3245 13.0461 10.3432 13.0152 10.3973C12.9844 10.4513 13.0031 10.5201 13.0572 10.5509L13.2992 10.6889C13.2623 10.7577 13.2279 10.8274 13.1946 10.8982L12.9389 10.787C12.8819 10.7622 12.8152 10.788 12.7904 10.8451C12.7657 10.9023 12.7914 10.969 12.8485 10.9938L13.1042 11.105C13.0804 11.1641 13.0572 11.2238 13.0359 11.2839L12.7712 11.198C12.7121 11.1788 12.6484 11.2111 12.6292 11.2703C12.61 11.3294 12.6424 11.3931 12.7015 11.4123L12.9662 11.4982C12.944 11.5741 12.9238 11.6509 12.9056 11.7282L12.6328 11.6716C12.5716 11.659 12.512 11.6979 12.4994 11.7591C12.4868 11.8202 12.5257 11.8799 12.5868 11.8925L12.8596 11.9492C12.846 12.026 12.8339 12.1028 12.8243 12.1812L12.5464 12.1539C12.4842 12.1478 12.4292 12.1933 12.4231 12.255C12.417 12.3172 12.4625 12.3723 12.5242 12.3783L12.802 12.4056V12.4021C12.7975 12.4688 12.7944 12.5365 12.7924 12.6043V12.5972H12.5135C12.4514 12.5972 12.4009 12.6478 12.4009 12.7099C12.4009 12.7721 12.4514 12.8227 12.5135 12.8227H12.7924V12.8211C12.7944 12.898 12.7985 12.9743 12.804 13.0506L12.5267 13.08C12.4645 13.0865 12.4201 13.1421 12.4266 13.2043C12.4332 13.2665 12.4888 13.311 12.5509 13.3044L12.8278 13.2751C12.8384 13.3555 12.851 13.4353 12.8657 13.5142L12.5944 13.5733C12.5338 13.5865 12.4949 13.6466 12.5085 13.7078C12.5216 13.7685 12.5817 13.8074 12.6429 13.7937L12.9137 13.7346C12.9288 13.7968 12.9455 13.8584 12.9637 13.9196L12.7 14.005C12.6409 14.0242 12.608 14.0879 12.6272 14.1471C12.6464 14.2062 12.7101 14.2391 12.7692 14.2199L13.0324 14.1344C13.0602 14.2133 13.0895 14.2911 13.1218 14.368L12.8702 14.4817C12.8136 14.5075 12.7884 14.5742 12.8136 14.6308C12.8394 14.6875 12.9061 14.7127 12.9627 14.6875L13.2138 14.5737C13.2416 14.6313 13.2709 14.6885 13.3012 14.7446L13.0622 14.8821C13.0082 14.9129 12.9895 14.9822 13.0208 15.0363C13.0516 15.0903 13.1208 15.109 13.1749 15.0777L13.4144 14.9402C13.4593 15.014 13.5068 15.0853 13.5563 15.1561L13.3335 15.3203C13.2835 15.3572 13.2729 15.428 13.3098 15.4781C13.3467 15.5281 13.4174 15.5392 13.4674 15.5018L13.6907 15.3375C13.7301 15.3881 13.77 15.4376 13.8115 15.4862L13.6053 15.6712C13.5589 15.7126 13.5553 15.7839 13.5967 15.8304C13.6382 15.8769 13.7094 15.8804 13.7559 15.839L13.962 15.6535C14.0232 15.7182 14.0868 15.7814 14.152 15.8425L13.9691 16.0498C13.9277 16.0963 13.9322 16.1676 13.9792 16.209C14.0257 16.2505 14.0969 16.2459 14.1383 16.1989L14.3212 15.9917C14.3702 16.0326 14.4203 16.0725 14.4708 16.1115L14.3091 16.3354C14.2727 16.3859 14.2839 16.4562 14.3344 16.4931C14.3849 16.5295 14.4551 16.5184 14.492 16.4678L14.6532 16.2444C14.7173 16.2884 14.7825 16.3308 14.8492 16.3718L14.7133 16.6104C14.6825 16.6645 14.7012 16.7332 14.7552 16.7641C14.8093 16.7949 14.878 16.7762 14.9088 16.7221L15.0452 16.483C15.1139 16.5199 15.1837 16.5548 15.2544 16.5876L15.1443 16.8399C15.1195 16.897 15.1453 16.9637 15.2024 16.9885C15.2594 17.0133 15.3261 16.9875 15.3509 16.9304L15.461 16.6781C15.5201 16.7019 15.5798 16.7251 15.6404 16.7464L15.5555 17.0082C15.5363 17.0674 15.5686 17.1311 15.6278 17.1503C15.6869 17.1695 15.7505 17.1371 15.7697 17.078L15.8546 16.8161C15.9304 16.8384 16.0072 16.8586 16.085 16.8768L16.0289 17.1467C16.0163 17.2079 16.0552 17.2675 16.1163 17.2802C16.1774 17.2928 16.2371 17.2539 16.2497 17.1927L16.3058 16.9228C16.3826 16.9364 16.4599 16.9481 16.5377 16.9582L16.5109 17.2327C16.5048 17.2948 16.5503 17.3499 16.6119 17.356C16.6741 17.3621 16.7291 17.3166 16.7352 17.2549L16.762 16.9799C16.8256 16.9845 16.8893 16.9875 16.9535 16.989V17.2655C16.9535 17.3277 17.004 17.3782 17.0661 17.3782C17.1283 17.3782 17.1788 17.3277 17.1788 17.2655V16.989C17.2551 16.987 17.3314 16.9829 17.4066 16.9769L17.4359 17.2514C17.4425 17.3135 17.4981 17.358 17.5602 17.3515C17.6224 17.3449 17.6668 17.2893 17.6603 17.2271L17.631 16.9526C17.7113 16.942 17.7911 16.9294 17.8704 16.9142L17.929 17.1831C17.9422 17.2438 18.0023 17.2827 18.0634 17.2691C18.1241 17.2559 18.163 17.1958 18.1493 17.1346L18.0907 16.8657C18.1529 16.8505 18.2145 16.8333 18.2756 16.8156L18.3605 17.0775C18.3797 17.1366 18.4434 17.1695 18.5025 17.1503C18.5616 17.1311 18.5944 17.0674 18.5752 17.0082L18.4909 16.7464C18.5697 16.7186 18.6475 16.6892 18.7243 16.6569L18.8369 16.9071C18.8627 16.9637 18.9294 16.989 18.986 16.9637C19.0426 16.938 19.0678 16.8712 19.0426 16.8146L18.9294 16.5644C18.987 16.5366 19.0441 16.5073 19.1002 16.4769L19.2371 16.715C19.2679 16.7691 19.3371 16.7878 19.3912 16.7565C19.4452 16.7256 19.4639 16.6564 19.4326 16.6023L19.2957 16.3637C19.3694 16.3187 19.4407 16.2707 19.5114 16.2217L19.6751 16.4441C19.712 16.4941 19.7827 16.5047 19.8327 16.4678C19.8828 16.4309 19.8934 16.3602 19.8565 16.3101L19.6923 16.0872C19.7428 16.0478 19.7923 16.0073 19.8408 15.9659L20.0257 16.1716C20.0672 16.2181 20.1389 16.2217 20.1849 16.1802C20.2314 16.1388 20.2349 16.0675 20.1935 16.021L20.0086 15.8147C20.0732 15.7531 20.1364 15.6899 20.197 15.6247L20.4047 15.8082C20.4511 15.8496 20.5224 15.8451 20.5638 15.798C20.6052 15.7515 20.6007 15.6803 20.5537 15.6388L20.3466 15.4558C20.3875 15.4068 20.4274 15.3567 20.4663 15.3062L20.6906 15.4685C20.7411 15.5049 20.8114 15.4937 20.8482 15.4432C20.8846 15.3926 20.8735 15.3224 20.823 15.2855L20.5992 15.1237C20.6431 15.0595 20.6856 14.9943 20.726 14.9276L20.9655 15.0641C21.0195 15.0949 21.0882 15.0762 21.119 15.0221C21.1499 14.968 21.1312 14.8993 21.0771 14.8684L20.8371 14.7314C20.874 14.6627 20.9084 14.5929 20.9417 14.5222L21.1953 14.6329C21.2524 14.6576 21.3191 14.6319 21.3439 14.5747C21.3686 14.5176 21.3429 14.4509 21.2858 14.4261L21.0321 14.3154C21.0559 14.2563 21.0786 14.1966 21.1003 14.136L21.3636 14.2214C21.4227 14.2406 21.4863 14.2082 21.5055 14.1486C21.5247 14.0894 21.4924 14.0258 21.4333 14.0065L21.1701 13.9211C21.1923 13.8453 21.2125 13.7685 21.2307 13.6911L21.5025 13.7477C21.5636 13.7604 21.6233 13.7214 21.6359 13.6603C21.6485 13.5991 21.6096 13.5395 21.5485 13.5268L21.2767 13.4702C21.2903 13.3934 21.3019 13.316 21.3115 13.2382L21.5884 13.2655C21.6505 13.2715 21.7056 13.2261 21.7117 13.1644C21.7177 13.1022 21.6723 13.0471 21.6106 13.041L21.3333 13.0137C21.3378 12.95 21.3408 12.8853 21.3423 12.8211V12.8227H21.6212L21.6182 12.8242ZM13.4598 12.6169C13.4598 10.6242 15.0745 9.00865 17.0661 9.00865C17.9235 9.00865 18.7106 9.30841 19.3295 9.80835L18.6778 10.4877C18.4717 10.3326 18.261 10.2203 18.0453 10.1521C17.733 10.053 17.4365 10.0414 17.155 10.1167C16.8736 10.192 16.6281 10.3386 16.4189 10.557C16.1704 10.8163 16.0324 11.0792 16.0052 11.3461C15.9779 11.613 16.0132 11.8607 16.1097 12.0892C16.1956 12.2924 16.3174 12.5244 16.474 12.7853L15.8465 13.4394C15.841 13.4151 15.8364 13.3903 15.8339 13.3651C15.8137 13.1886 15.8607 13.0284 15.9748 12.8843L14.9326 11.8834C14.7133 12.1448 14.5769 12.4395 14.5228 12.7681C14.4688 13.0961 14.5041 13.4298 14.6294 13.7685C14.7062 13.9767 14.8169 14.1749 14.9593 14.3639L14.3541 14.9948C13.7973 14.3599 13.4593 13.5283 13.4593 12.6174L13.4598 12.6169ZM16.7877 13.9267C16.7003 14.0177 16.5932 14.0571 16.4669 14.0445C16.4442 14.0424 16.421 14.0374 16.3977 14.0318L16.8676 13.542C16.9171 13.6906 16.8913 13.8185 16.7877 13.9267ZM17.3455 11.8764C17.295 11.7227 17.3213 11.5918 17.4248 11.4836C17.5122 11.3926 17.6138 11.3527 17.73 11.3633C17.7598 11.3658 17.7896 11.3724 17.8194 11.382L17.3455 11.8759V11.8764ZM17.0656 16.2252C16.276 16.2252 15.5459 15.9704 14.9518 15.5397L15.5328 14.9341C15.7313 15.0838 15.9364 15.195 16.1486 15.2663C16.4563 15.3699 16.7509 15.3881 17.0318 15.3214C17.3127 15.2546 17.5602 15.1101 17.7739 14.8871C18.023 14.6192 18.162 14.3488 18.1913 14.0753C18.2206 13.8018 18.1887 13.5531 18.0958 13.3282C18.0144 13.1305 17.8967 12.8975 17.7441 12.628L18.3257 12.0214C18.3363 12.1786 18.2883 12.3293 18.1812 12.4729L19.1557 13.4085C19.4937 12.9819 19.6519 12.5305 19.6301 12.0553C19.614 11.706 19.4872 11.3734 19.2502 11.0569L19.8964 10.3831C20.3809 10.9973 20.6709 11.7727 20.6709 12.6164C20.6709 14.6091 19.0562 16.2247 17.0646 16.2247L17.0656 16.2252Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8387 9.06031L15.0342 8.94808L14.8953 8.70595C14.8645 8.65186 14.7953 8.63316 14.7412 8.6645C14.6871 8.69533 14.6684 8.76459 14.6998 8.81868L14.8387 9.06081V9.06031Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93872 27.7427L6.69318 27.9631C6.6467 28.0045 6.64316 28.0758 6.68459 28.1223L6.70429 28.144C6.74572 28.1905 6.81696 28.1941 6.86344 28.1526L7.10898 27.9322L6.93872 27.7427Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88595 29.472C8.86676 29.5311 8.89859 29.5948 8.9582 29.6145L8.98599 29.6236C9.0451 29.6428 9.10876 29.611 9.12846 29.5513L9.23102 29.2379L8.98902 29.1586L8.88595 29.472Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7569 25.0291L15.4311 24.9942C15.4392 24.8936 15.4442 24.793 15.4462 24.6919L15.7736 24.6889C15.8358 24.6884 15.8858 24.6373 15.8853 24.5752V24.5458C15.8843 24.4837 15.8337 24.4336 15.7711 24.4341L15.4442 24.4372C15.4417 24.3649 15.4376 24.2931 15.4316 24.2208L15.7564 24.1859C15.8186 24.1793 15.863 24.1237 15.8565 24.0616L15.8534 24.0322C15.8469 23.9701 15.7913 23.9256 15.7292 23.9322L15.4048 23.967C15.3932 23.8801 15.38 23.7931 15.3639 23.7062L15.6817 23.6375C15.7423 23.6243 15.7812 23.5642 15.7681 23.5035L15.762 23.4747C15.7489 23.414 15.6887 23.3751 15.6281 23.3882L15.3103 23.4575C15.2896 23.3721 15.2659 23.2871 15.2401 23.2022L15.5488 23.0996C15.6079 23.0799 15.6397 23.0162 15.62 22.957L15.6109 22.9292C15.5912 22.8701 15.5276 22.8383 15.4685 22.858L15.1598 22.9606C15.135 22.8928 15.1092 22.8251 15.0815 22.7584L15.3785 22.6259C15.4356 22.6007 15.4609 22.5339 15.4356 22.4768L15.4235 22.45C15.3982 22.3929 15.3315 22.3676 15.2745 22.3929L14.9774 22.5253C14.939 22.4445 14.8981 22.3651 14.8546 22.2857L15.136 22.122C15.1901 22.0906 15.2083 22.0214 15.1769 21.9678L15.1623 21.9425C15.131 21.8884 15.0618 21.8702 15.0082 21.9016L14.7263 22.0658C14.6798 21.991 14.6313 21.9172 14.5808 21.8444L14.8435 21.6508C14.8935 21.6139 14.9041 21.5432 14.8672 21.4931L14.8501 21.4694C14.8132 21.4193 14.7425 21.4087 14.6924 21.4456L14.4292 21.6392C14.3853 21.5826 14.3393 21.5265 14.2923 21.4714L14.5353 21.2525C14.5818 21.211 14.5853 21.1398 14.5439 21.0933L14.5242 21.0715C14.4828 21.025 14.4115 21.0215 14.365 21.0629L14.122 21.2813C14.0624 21.2186 14.0018 21.1575 13.9402 21.0988L14.1584 20.8557C14.1998 20.8092 14.1963 20.7379 14.1498 20.6964L14.1281 20.6767C14.0816 20.6353 14.0104 20.6388 13.969 20.6853L13.7507 20.928C13.681 20.8683 13.6102 20.8107 13.538 20.7556L13.728 20.4912C13.7643 20.4407 13.7527 20.3699 13.7022 20.334L13.6784 20.3168C13.6279 20.2804 13.5572 20.292 13.5208 20.3426L13.3309 20.607C13.2707 20.566 13.2101 20.5271 13.149 20.4892L13.3122 20.2076C13.3435 20.1535 13.3253 20.0848 13.2712 20.0534L13.246 20.0388C13.1919 20.0074 13.1232 20.0256 13.0919 20.0797L12.9287 20.3613C12.8458 20.3163 12.7625 20.2728 12.6776 20.2329L12.8085 19.9357C12.8337 19.8785 12.8074 19.8118 12.7509 19.787L12.7241 19.7754C12.667 19.7501 12.6003 19.7764 12.5755 19.833L12.4447 20.1303C12.3775 20.103 12.3103 20.0772 12.2421 20.0529L12.3431 19.7441C12.3623 19.6849 12.3305 19.6212 12.2709 19.6015L12.2431 19.5924C12.184 19.5732 12.1203 19.6051 12.1006 19.6647L11.9991 19.9741C11.9056 19.9463 11.8116 19.922 11.7167 19.9003L11.7828 19.5803C11.7955 19.5191 11.7561 19.4595 11.6954 19.4468L11.6666 19.4408C11.6055 19.4281 11.5459 19.4676 11.5333 19.5282L11.4671 19.8487C11.3958 19.8361 11.3246 19.825 11.2534 19.8153L11.2882 19.4898C11.2948 19.4276 11.2498 19.372 11.1882 19.3655L11.1589 19.3624C11.0967 19.3558 11.0412 19.4008 11.0346 19.4625L10.9997 19.7886C10.8992 19.7805 10.7987 19.7754 10.6976 19.7734L10.6946 19.4458C10.6941 19.3836 10.6431 19.3336 10.5809 19.3341H10.5516C10.4895 19.3351 10.4395 19.3857 10.44 19.4484L10.443 19.7754C10.3707 19.7779 10.299 19.7825 10.2268 19.7881L10.1919 19.4625C10.1853 19.4003 10.1297 19.3558 10.0676 19.3624L10.0383 19.3655C9.97616 19.372 9.9317 19.4276 9.93827 19.4898L9.97313 19.8148C9.88623 19.8265 9.79933 19.8401 9.71294 19.8563L9.64372 19.5373C9.63059 19.4767 9.57047 19.4377 9.50984 19.4509L9.48104 19.4569C9.42041 19.4701 9.38151 19.5302 9.39465 19.5909L9.46386 19.9104C9.37848 19.9311 9.2936 19.9549 9.20923 19.9806L9.10616 19.6703C9.08646 19.6111 9.0228 19.5793 8.96369 19.599L8.9359 19.6081C8.87679 19.6278 8.84496 19.6915 8.86467 19.7506L8.96824 20.0615C8.90054 20.0863 8.83334 20.1121 8.76615 20.1399L8.63327 19.8406C8.60801 19.7835 8.54132 19.7582 8.48423 19.7835L8.45745 19.7956C8.40036 19.8209 8.3751 19.8876 8.40036 19.9448L8.53374 20.244C8.45341 20.2824 8.37359 20.3239 8.29477 20.3669L8.12956 20.0833C8.09824 20.0292 8.02902 20.011 7.97547 20.0423L7.95021 20.057C7.89615 20.0883 7.87796 20.1576 7.90929 20.2112L8.07449 20.4952C7.99972 20.5418 7.92596 20.5903 7.85321 20.6408L7.65819 20.3759C7.62131 20.3259 7.55058 20.3153 7.50056 20.3522L7.47681 20.3694C7.4268 20.4063 7.41619 20.4771 7.45307 20.5271L7.64859 20.7925C7.5915 20.837 7.53542 20.883 7.47984 20.9305L7.48136 20.9295L7.26108 20.6838C7.21965 20.6373 7.14842 20.6338 7.10194 20.6752L7.08021 20.6949C7.03373 20.7364 7.03019 20.8076 7.07162 20.8542L7.2919 21.0998L7.29796 21.0943C7.23228 21.1564 7.16863 21.2196 7.10749 21.2843L7.11002 21.2818L6.86499 21.0609C6.81851 21.0195 6.74727 21.023 6.70584 21.0695L6.68614 21.0912C6.64471 21.1377 6.64824 21.209 6.69472 21.2505L6.93976 21.4709C6.88014 21.5406 6.82305 21.6114 6.76798 21.6837L6.50072 21.4916C6.4502 21.4552 6.37946 21.4668 6.34309 21.5174L6.32591 21.5411C6.28953 21.5917 6.30115 21.6625 6.35168 21.6983L6.61894 21.8904C6.57852 21.9501 6.53912 22.0107 6.50173 22.0724L6.21678 21.9071C6.16272 21.8758 6.09401 21.894 6.06269 21.9481L6.04804 21.9733C6.01671 22.0274 6.0349 22.0962 6.08896 22.1275L6.37391 22.2928C6.32894 22.3757 6.28549 22.4591 6.24558 22.544L5.94497 22.4116C5.88788 22.3863 5.82119 22.4126 5.79644 22.4692L5.78481 22.496C5.75955 22.5531 5.78583 22.6199 5.84241 22.6446L6.14352 22.7771C6.11624 22.8438 6.09048 22.9115 6.06623 22.9793L5.75349 22.8767C5.69438 22.8575 5.63072 22.8893 5.61102 22.949L5.60192 22.9768C5.58273 23.0359 5.61455 23.0996 5.67417 23.1193L5.98741 23.2219C5.95305 23.3377 5.92375 23.455 5.89849 23.5722L5.91264 23.5035L5.5898 23.4368C5.52867 23.4241 5.46905 23.4636 5.45642 23.5242L5.45036 23.553C5.43773 23.6142 5.47713 23.6738 5.53776 23.6865L5.8606 23.7532L5.87121 23.7027C5.84847 23.822 5.83079 23.9423 5.81715 24.0631L5.82725 23.967L5.49936 23.9322C5.43722 23.9256 5.38165 23.9706 5.37508 24.0322L5.37205 24.0616C5.36548 24.1237 5.41044 24.1793 5.47208 24.1859L5.79997 24.2208L5.80755 24.15C5.79441 24.2901 5.78684 24.4306 5.78583 24.5711V24.5226L5.45541 24.5256C5.39327 24.5261 5.34325 24.5772 5.34375 24.6394V24.6687C5.34476 24.7309 5.39529 24.7809 5.45793 24.7804L5.78785 24.7774L5.78633 24.6136C5.78633 24.7546 5.79239 24.8956 5.80502 25.0362L5.80048 24.9932L5.47259 25.0281C5.41044 25.0347 5.36598 25.0903 5.37255 25.1524L5.37558 25.1818C5.38215 25.2439 5.43773 25.2884 5.49987 25.2818L5.82776 25.247L5.81008 25.0807C5.82978 25.2808 5.86211 25.48 5.90657 25.6766L5.86969 25.5073L5.54736 25.5776C5.48673 25.5907 5.44783 25.6509 5.46097 25.7115L5.46703 25.7403C5.48016 25.801 5.54029 25.8399 5.60091 25.8268L5.92325 25.7565L5.9192 25.7373C5.94851 25.8591 5.98337 25.9794 6.02227 26.0992L5.99297 26.0113L5.68023 26.1154C5.62112 26.1351 5.58929 26.1988 5.609 26.258L5.61809 26.2858C5.63779 26.3449 5.70145 26.3768 5.76056 26.3571L6.0738 26.2529L6.06117 26.2145C6.10008 26.3247 6.14352 26.4339 6.19102 26.5416L6.15211 26.4541L5.851 26.5881C5.79391 26.6133 5.76865 26.6801 5.79391 26.7372L5.80603 26.764C5.8313 26.8211 5.89799 26.8464 5.95508 26.8211L6.25619 26.6871L6.23901 26.6487C6.2956 26.7695 6.35723 26.8883 6.42443 27.0051L6.37845 26.9262L6.09351 27.092C6.03945 27.1234 6.02126 27.1926 6.05258 27.2462L6.06724 27.2715C6.09856 27.3251 6.16778 27.3438 6.22133 27.3125L6.50628 27.1466L6.46535 27.0759C6.53962 27.2007 6.61945 27.3231 6.70635 27.4419L6.65178 27.3681L6.38603 27.5637C6.33602 27.6006 6.3249 27.6714 6.36229 27.7214L6.37946 27.7452C6.41635 27.7952 6.48708 27.8058 6.53709 27.7689L6.80284 27.5733L6.72251 27.4636C6.81648 27.591 6.91702 27.7153 7.02464 27.8356C7.13326 27.9565 7.24694 28.0707 7.36465 28.1784L7.2919 28.1127L7.07112 28.3578C7.02969 28.4043 7.03323 28.4756 7.07971 28.5171L7.10143 28.5368C7.14791 28.5782 7.21915 28.5747 7.26058 28.5282L7.48136 28.283L7.38688 28.1981C7.49955 28.2997 7.61575 28.3952 7.73549 28.4842L7.69456 28.4544L7.50207 28.7223C7.4657 28.7728 7.47732 28.8436 7.52784 28.8795L7.55159 28.8967C7.60211 28.9331 7.67284 28.9215 7.70871 28.8709L7.9012 28.603L7.7951 28.5267C7.9012 28.603 8.00932 28.6753 8.11996 28.742L8.08258 28.7203L7.91686 29.0059C7.88554 29.06 7.90373 29.1287 7.95779 29.1601L7.98305 29.1747C8.03711 29.2061 8.10582 29.1879 8.13714 29.1338L8.30286 28.8482L8.22101 28.8006C8.33317 28.8648 8.44634 28.925 8.56254 28.9796L8.55395 28.9761L8.42108 29.2783C8.39582 29.3355 8.42209 29.4022 8.47867 29.427L8.50545 29.4386C8.56254 29.4639 8.62923 29.4376 8.65399 29.381L8.78686 29.0787L8.7136 29.0463C9.00815 29.1727 9.31331 29.2687 9.62402 29.3334L9.51236 29.3102L9.44567 29.6332C9.43304 29.6944 9.47245 29.754 9.53308 29.7667L9.56188 29.7727C9.62301 29.7854 9.68262 29.7459 9.69526 29.6853L9.76195 29.3623L9.69475 29.3486C9.8251 29.3739 9.95646 29.3936 10.0878 29.4078L9.97515 29.3956L9.94029 29.7237C9.93372 29.7859 9.97869 29.8415 10.0403 29.848L10.0696 29.8511C10.1318 29.8577 10.1873 29.8127 10.1939 29.751L10.2288 29.4229L10.155 29.4148C10.2955 29.4285 10.4359 29.4356 10.5769 29.4371H10.5309L10.5339 29.7677C10.5344 29.8298 10.5855 29.8799 10.6476 29.8794H10.6769C10.7391 29.8784 10.7891 29.8278 10.7886 29.7651L10.7855 29.4351L10.6547 29.4361C10.7805 29.4351 10.9058 29.43 11.0316 29.4194L11.0018 29.4224L11.0366 29.7505C11.0432 29.8127 11.0988 29.8571 11.1609 29.8506L11.1902 29.8475C11.2524 29.841 11.2968 29.7854 11.2903 29.7232L11.2554 29.3951L11.1842 29.4027C11.2948 29.3896 11.4054 29.3744 11.5156 29.3537L11.5853 29.6757C11.5984 29.7368 11.6586 29.7753 11.7192 29.7621L11.748 29.756C11.8086 29.7429 11.8475 29.6828 11.8344 29.6221L11.7647 29.3001C11.85 29.2794 11.9349 29.2556 12.0193 29.2303L12.1234 29.5432C12.1431 29.6024 12.2067 29.6342 12.2658 29.6145L12.2936 29.6054C12.3527 29.5857 12.3846 29.522 12.3649 29.4629L12.2608 29.15C12.3285 29.1257 12.3957 29.0999 12.4624 29.0721L12.5963 29.3729C12.6215 29.43 12.6882 29.4553 12.7453 29.43L12.7721 29.4179C12.8292 29.3926 12.8544 29.3259 12.8292 29.2687L12.6953 28.968C12.7756 28.9296 12.8554 28.8886 12.9343 28.8456L13.1 29.1307C13.1313 29.1848 13.2005 29.203 13.2541 29.1717L13.2793 29.157C13.3334 29.1257 13.3516 29.0564 13.3202 29.0029L13.1545 28.7177C13.2293 28.6717 13.3031 28.6232 13.3758 28.5722L13.5713 28.8381C13.6082 28.8881 13.679 28.8987 13.729 28.8618L13.7527 28.8446C13.8027 28.8077 13.8138 28.737 13.7765 28.6869L13.5809 28.421L13.5774 28.4235C13.6375 28.377 13.6961 28.329 13.7547 28.279L13.7487 28.2845L13.969 28.5302C14.0104 28.5767 14.0816 28.5802 14.1281 28.5388L14.1498 28.5191C14.1963 28.4776 14.1998 28.4064 14.1584 28.3598L13.9381 28.1142L13.9366 28.1152C13.9998 28.0555 14.0609 27.9944 14.1205 27.9322L14.3656 28.1526C14.412 28.194 14.4833 28.1905 14.5247 28.144L14.5444 28.1223C14.5858 28.0758 14.5823 28.0045 14.5358 27.963L14.2913 27.7431C14.3509 27.6734 14.4085 27.6026 14.4636 27.5303L14.7303 27.7219C14.7808 27.7583 14.8516 27.7467 14.8875 27.6961L14.9046 27.6724C14.941 27.6218 14.9294 27.551 14.8789 27.5152L14.6126 27.3241C14.6535 27.2644 14.6924 27.2038 14.7303 27.1421L15.0138 27.3064C15.0678 27.3377 15.1365 27.3195 15.1679 27.2654L15.1825 27.2402C15.2138 27.1861 15.1956 27.1173 15.1416 27.086L14.8587 26.9217C14.9036 26.8388 14.9471 26.7554 14.987 26.6705L15.2856 26.8019C15.3427 26.8272 15.4093 26.8009 15.4341 26.7443L15.4457 26.7175C15.471 26.6604 15.4447 26.5936 15.3881 26.5689L15.0895 26.4374C15.1168 26.3707 15.1426 26.303 15.1668 26.2352L15.477 26.3368C15.5362 26.356 15.5998 26.3242 15.6195 26.2645L15.6286 26.2367C15.6478 26.1776 15.616 26.1139 15.5564 26.0942L15.2462 25.9926C15.2739 25.8991 15.2982 25.805 15.3204 25.7105L15.6412 25.7767C15.7024 25.7894 15.762 25.7499 15.7746 25.6893L15.7807 25.6605C15.7933 25.5993 15.7539 25.5397 15.6933 25.527L15.3725 25.4608C15.3851 25.3895 15.3962 25.3182 15.4058 25.247L15.7317 25.2818C15.7938 25.2884 15.8494 25.2434 15.856 25.1818L15.859 25.1524C15.8656 25.0903 15.8206 25.0347 15.759 25.0281L15.7569 25.0291ZM7.81178 21.6478C9.48508 20.1429 12.0612 20.2799 13.5653 21.9541C14.1619 22.6184 14.4994 23.4241 14.5858 24.2491L13.6385 24.2183C13.6143 23.9382 13.5526 23.6814 13.4521 23.4494C13.3066 23.1127 13.0995 22.8514 12.8312 22.6654C12.5629 22.4793 12.2547 22.3808 11.9056 22.3691C11.4928 22.3621 11.1604 22.4495 10.9088 22.6315C10.6572 22.8135 10.4723 23.0283 10.3536 23.2755C10.2495 23.4929 10.1419 23.7684 10.0312 24.1L9.08242 24.0691C9.2067 23.9413 9.36939 23.868 9.57047 23.8493L9.62048 22.3231C9.00663 22.3611 8.50848 22.5688 8.12552 22.9464C7.84462 23.2239 7.66122 23.5818 7.57432 24.0201L6.52042 23.9857C6.67047 23.1143 7.10244 22.2847 7.81077 21.6478H7.81178ZM12.2274 24.1723L11.4615 24.147C11.5489 23.9928 11.6762 23.918 11.845 23.9236C11.9875 23.9281 12.1011 23.9883 12.1865 24.104C12.2022 24.1248 12.2153 24.148 12.2279 24.1718L12.2274 24.1723ZM9.70233 25.0038C9.61189 25.1625 9.48205 25.2394 9.31229 25.2338C9.17033 25.2293 9.05968 25.1742 8.98087 25.068C8.96066 25.0412 8.94348 25.0114 8.92933 24.9785L9.70182 25.0038H9.70233ZM13.2591 27.7113C11.5858 29.2162 9.00967 29.0792 7.50511 27.405C6.85741 26.6841 6.51486 25.7959 6.46737 24.8982L7.52986 24.9331C7.55563 25.2232 7.6203 25.4856 7.72589 25.7186C7.87847 26.0558 8.09268 26.3141 8.36854 26.4935C8.64439 26.6735 8.95257 26.769 9.29411 26.7802C9.6998 26.7933 10.0247 26.7104 10.2692 26.5314C10.5137 26.3525 10.6951 26.1361 10.8138 25.8819C10.9194 25.6559 11.0225 25.3784 11.123 25.0498L12.1461 25.0832C12.1299 25.1059 12.1123 25.1287 12.0936 25.1499C11.9602 25.3 11.7904 25.3814 11.5833 25.3941L11.5302 27.0263C11.9152 27.0132 12.2658 26.9055 12.5826 26.7028C12.8994 26.5006 13.1525 26.2185 13.3425 25.8576C13.4592 25.6357 13.5425 25.3931 13.5931 25.1302L14.5803 25.1625C14.4676 26.1104 14.0245 27.0223 13.2596 27.7108L13.2591 27.7113Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.108 16.2723L12.816 16.244L12.8018 16.3886C12.8089 16.3072 12.8134 16.2248 12.8134 16.1414C12.8134 16.0661 12.8094 15.9913 12.8038 15.9175L12.8134 16.0332L13.106 16.0095C13.1868 16.0029 13.2469 15.9321 13.2403 15.8513C13.2338 15.7704 13.163 15.7102 13.0822 15.7168L12.7897 15.7406L12.7983 15.8457C12.7882 15.7466 12.7725 15.6491 12.7518 15.553L13.0287 15.4802C13.107 15.4595 13.154 15.3791 13.1332 15.3008C13.1125 15.2224 13.0322 15.1754 12.9539 15.1961L12.6755 15.2694C12.6614 15.2249 12.6457 15.181 12.629 15.1375L12.8948 15.0222C12.969 14.9899 13.0034 14.9034 12.9711 14.8291C12.9387 14.7548 12.8523 14.7204 12.7781 14.7528L12.5108 14.8686C12.479 14.8059 12.4456 14.7437 12.4093 14.6835L12.6472 14.5258C12.7149 14.4808 12.7331 14.3899 12.6881 14.3221C12.6432 14.2544 12.5522 14.2362 12.4845 14.2812L12.2445 14.4404C12.2026 14.3848 12.1582 14.3307 12.1122 14.2786L12.3193 14.0785C12.3774 14.0223 12.3794 13.9293 12.3229 13.8707C12.2668 13.8126 12.1738 13.8105 12.1152 13.8672L11.9076 14.0678C11.856 14.0198 11.802 13.9738 11.7469 13.9298L11.7646 13.943L11.9379 13.7059C11.9859 13.6402 11.9712 13.5487 11.906 13.5007C11.8404 13.4526 11.7489 13.4673 11.7009 13.5325L11.5276 13.7696L11.5473 13.7843C11.4766 13.7372 11.4039 13.6928 11.3286 13.6523L11.4539 13.3895C11.4887 13.3162 11.4579 13.2287 11.3847 13.1938C11.3114 13.159 11.224 13.1898 11.1891 13.2631L11.0638 13.5265C11.0017 13.5007 10.938 13.4774 10.8739 13.4562L10.9507 13.1772C10.9724 13.0988 10.9264 13.0179 10.8481 12.9967C10.7698 12.9755 10.689 13.0209 10.6677 13.0993L10.5909 13.3783C10.5197 13.3627 10.447 13.35 10.3737 13.3399L10.3985 13.0543C10.4055 12.9734 10.3454 12.9022 10.2651 12.8956C10.1842 12.8885 10.113 12.9487 10.1059 13.029L10.0812 13.3152C10.0493 13.3141 10.0175 13.3126 9.98569 13.3126C9.95739 13.3126 9.9291 13.3141 9.90081 13.3146L9.87656 13.03C9.86948 12.9492 9.79875 12.889 9.71792 12.8961C9.63708 12.9032 9.57696 12.9739 9.58403 13.0548L9.60828 13.3379C9.55018 13.3455 9.49259 13.3546 9.436 13.3657L9.36679 13.0937C9.34658 13.0154 9.26675 12.9679 9.18844 12.9876C9.11013 13.0078 9.06264 13.0877 9.08234 13.166L9.15156 13.437C9.08285 13.4582 9.01616 13.4825 8.94998 13.5088L8.83478 13.2565C8.80093 13.1827 8.71404 13.1504 8.64027 13.1842C8.56651 13.2181 8.53418 13.305 8.56803 13.3788L8.68322 13.6306C8.62966 13.6584 8.57712 13.6872 8.52609 13.718L8.3725 13.4916C8.32703 13.4243 8.23559 13.4072 8.16839 13.4526C8.1012 13.4981 8.08402 13.5896 8.12949 13.6569L8.28308 13.8833C8.22195 13.9293 8.16334 13.9784 8.10625 14.0289L7.91578 13.8358C7.85869 13.7782 7.76573 13.7777 7.70813 13.8348C7.65054 13.8919 7.65003 13.9849 7.70712 14.0426L7.89759 14.2352C7.85162 14.2857 7.80766 14.3383 7.76522 14.3924L7.54596 14.2372C7.47977 14.1902 7.38833 14.2058 7.34134 14.2721C7.29435 14.3383 7.31002 14.4298 7.3762 14.4768L7.59547 14.632C7.56212 14.6851 7.52928 14.7392 7.49948 14.7943L7.25949 14.6795C7.18624 14.6446 7.09883 14.6755 7.06347 14.7488C7.02861 14.8221 7.05942 14.9095 7.13268 14.9449L7.37317 15.0601C7.34791 15.1208 7.32517 15.183 7.30446 15.2462L7.04982 15.1749C6.97151 15.1532 6.89068 15.1987 6.86895 15.2765C6.84723 15.3549 6.8927 15.4357 6.9705 15.4575L7.22615 15.5293C7.2115 15.5965 7.19836 15.6647 7.18876 15.734L6.92706 15.7087C6.84622 15.7006 6.77448 15.7598 6.7669 15.8406C6.75882 15.9215 6.81793 15.9933 6.89876 16.0009L7.16198 16.0262C7.16047 16.0646 7.15895 16.103 7.15895 16.1414C7.15895 16.1733 7.16047 16.2051 7.16148 16.2364L6.89977 16.2577C6.81894 16.2643 6.75882 16.335 6.76538 16.4159C6.77195 16.4968 6.84268 16.5569 6.92352 16.5504L7.18624 16.5291C7.19583 16.5979 7.20746 16.6661 7.2216 16.7334L6.96899 16.7996C6.89068 16.8203 6.84369 16.9007 6.86441 16.979C6.88512 17.0574 6.96545 17.1044 7.04376 17.0837L7.29789 17.0169C7.31254 17.0614 7.3282 17.1059 7.34488 17.1494L7.1054 17.2535C7.03113 17.2859 6.99678 17.3723 7.02911 17.4466C7.06145 17.5209 7.14784 17.5553 7.22211 17.523L7.4636 17.4183C7.49543 17.481 7.52878 17.5422 7.56465 17.6018L7.3469 17.7464C7.2792 17.7914 7.26101 17.8824 7.30597 17.9501C7.35094 18.0178 7.44188 18.036 7.50958 17.991L7.72986 17.845C7.77432 17.9041 7.82181 17.9612 7.87082 18.0168L7.68136 18.1998C7.62326 18.2559 7.62123 18.3489 7.67782 18.4076C7.7339 18.4657 7.82686 18.4677 7.88547 18.4111L8.07695 18.2266C8.12494 18.2706 8.17496 18.3131 8.22599 18.3535L8.06987 18.5673C8.02188 18.633 8.03653 18.7245 8.1017 18.7726C8.16738 18.8206 8.25883 18.8059 8.30682 18.7407L8.46496 18.5244C8.53114 18.5668 8.59884 18.6062 8.66806 18.6431L8.55337 18.8838C8.51851 18.9571 8.54933 19.0445 8.62259 19.0794C8.69585 19.1143 8.78325 19.0834 8.81811 19.0101L8.93431 18.7665C8.99797 18.7923 9.06264 18.816 9.12832 18.8368L9.05708 19.0961C9.03536 19.1744 9.08133 19.2553 9.15964 19.2765C9.23795 19.2983 9.31879 19.2523 9.34001 19.1739L9.41226 18.9116C9.4845 18.9267 9.55827 18.9379 9.63304 18.9475L9.6098 19.2189C9.60273 19.2998 9.66285 19.3711 9.74318 19.3781C9.82351 19.3852 9.89525 19.3251 9.90182 19.2447L9.92556 18.9692C9.94628 18.9692 9.96699 18.9707 9.98771 18.9707C10.0312 18.9707 10.0736 18.9692 10.1165 18.9677L10.1408 19.2558C10.1479 19.3367 10.2186 19.3968 10.2994 19.3898C10.3803 19.3827 10.4404 19.3119 10.4333 19.231L10.4086 18.9399C10.4657 18.9313 10.5227 18.9207 10.5788 18.909L10.6511 19.1921C10.6713 19.2705 10.7511 19.318 10.8294 19.2983C10.9077 19.2781 10.9552 19.1982 10.9355 19.1198L10.8628 18.8352L10.8309 18.8433C10.9158 18.817 10.9987 18.7862 11.0795 18.7523L11.0563 18.7629L11.1785 19.0299C11.2124 19.1037 11.2993 19.136 11.373 19.1021C11.4468 19.0683 11.4791 18.9813 11.4453 18.9075L11.323 18.6406L11.2356 18.6806C11.3175 18.6401 11.3968 18.5961 11.4741 18.5486L11.6332 18.7837C11.6787 18.8509 11.7701 18.8681 11.8373 18.8226C11.9045 18.7771 11.9217 18.6856 11.8762 18.6184L11.7151 18.3803C11.7752 18.3338 11.8343 18.2852 11.8904 18.2337L12.0889 18.4349C12.146 18.4925 12.239 18.493 12.2966 18.4359C12.3542 18.3788 12.3547 18.2858 12.2976 18.2281L12.0965 18.0244C12.139 17.9769 12.1799 17.9274 12.2193 17.8768L12.4542 18.0431C12.5204 18.0901 12.6118 18.0745 12.6588 18.0082C12.7058 17.942 12.6902 17.8505 12.624 17.8035L12.3875 17.6362C12.4219 17.5811 12.4547 17.5245 12.4855 17.4663L12.7488 17.5922C12.822 17.6271 12.9094 17.5962 12.9448 17.523C12.9797 17.4497 12.9488 17.3622 12.8756 17.3268L12.6108 17.1999L12.6017 17.2191C12.6295 17.1514 12.6548 17.0822 12.6775 17.0124L12.676 17.018L12.9584 17.0973C13.0367 17.1191 13.1176 17.0736 13.1393 16.9957C13.161 16.9174 13.1156 16.8365 13.0378 16.8147L12.7553 16.7354L12.7371 16.8006C12.7639 16.6889 12.7841 16.5751 12.7973 16.4589L12.7897 16.5352L13.0817 16.5635C13.1625 16.5711 13.2343 16.5125 13.2419 16.4316C13.2499 16.3507 13.1908 16.2789 13.11 16.2713L13.108 16.2723ZM11.9662 16.1414C11.9662 16.5499 11.8424 16.9295 11.6312 17.2444L11.3271 16.9836C11.4069 16.8643 11.464 16.7425 11.4983 16.6176C11.5478 16.4371 11.5489 16.2668 11.5014 16.107C11.4539 15.9473 11.3624 15.8093 11.227 15.6935C11.0648 15.5591 10.9042 15.4878 10.7461 15.4797C10.5879 15.4716 10.4454 15.4984 10.3191 15.5591C10.2085 15.6122 10.0771 15.6885 9.92809 15.785L9.55978 15.4691C9.65022 15.458 9.73813 15.4807 9.82452 15.5373L10.3313 14.9454C10.0746 14.7644 9.80987 14.6881 9.53705 14.7159C9.33647 14.7366 9.14954 14.821 8.97524 14.9676L8.64381 14.6835C8.99696 14.358 9.46783 14.1588 9.98619 14.1588C11.08 14.1588 11.9672 15.046 11.9672 16.1409L11.9662 16.1414ZM10.4823 16.2602C10.5662 16.2268 10.641 16.2375 10.7061 16.2936C10.7612 16.3411 10.7875 16.4012 10.7844 16.4745C10.7839 16.4877 10.7809 16.5008 10.7784 16.514L10.4818 16.2602H10.4823ZM9.20865 15.783L9.50825 16.0398C9.42135 16.0742 9.34557 16.0631 9.27938 16.007C9.22431 15.9599 9.19804 15.9023 9.20006 15.8351C9.20057 15.8179 9.2036 15.8007 9.20815 15.783H9.20865ZM8.0047 16.1414C8.0047 15.733 8.12848 15.3533 8.33966 15.0384L8.66553 15.3174C8.58318 15.4413 8.52508 15.5667 8.49275 15.693C8.44627 15.876 8.44879 16.0474 8.50134 16.2071C8.55388 16.3669 8.64634 16.5034 8.7787 16.6171C8.93583 16.7521 9.09194 16.8228 9.24654 16.8294C9.40114 16.8365 9.5426 16.8082 9.67093 16.745C9.78461 16.6889 9.91496 16.6105 10.0589 16.5119L10.4561 16.8522C10.4419 16.8562 10.4283 16.8592 10.4136 16.8618C10.3126 16.8789 10.2191 16.8572 10.1322 16.796L9.5901 17.4294C9.74773 17.5472 9.92203 17.6165 10.1125 17.6367C10.303 17.6574 10.4939 17.6261 10.6849 17.5427C10.8021 17.4916 10.9128 17.4213 11.0169 17.3329L11.3271 17.5988C10.9739 17.9243 10.503 18.1235 9.98468 18.1235C8.89086 18.1235 8.00369 17.2363 8.00369 16.1414H8.0047Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.166 27.7169L20.8901 27.6962C20.8916 27.6254 20.8901 27.5541 20.8866 27.4834L21.1594 27.4535C21.2221 27.447 21.267 27.3904 21.26 27.3282L21.2549 27.2832C21.2483 27.2205 21.1917 27.1755 21.1296 27.1826L20.8573 27.2124C20.8472 27.1497 20.834 27.0876 20.8194 27.0259L21.0806 26.9496C21.1407 26.9319 21.1756 26.8687 21.1579 26.8085L21.1453 26.7651C21.1276 26.7049 21.0644 26.67 21.0043 26.6877L20.7431 26.764C20.7239 26.7089 20.7037 26.6544 20.6805 26.6008L20.9225 26.483C20.979 26.4557 21.0023 26.3874 20.975 26.3308L20.9553 26.2904C20.928 26.2338 20.8598 26.2105 20.8032 26.2378L20.5607 26.3561C20.5309 26.3025 20.4991 26.2505 20.4652 26.1989L20.682 26.0417C20.733 26.0048 20.7441 25.9335 20.7072 25.883L20.681 25.8466C20.6441 25.7955 20.5728 25.7844 20.5223 25.8213L20.3046 25.979C20.2642 25.9295 20.2222 25.8804 20.1778 25.8334L20.3627 25.6418C20.4061 25.5968 20.4051 25.5246 20.3596 25.4811L20.3273 25.4497C20.2823 25.4063 20.2101 25.4073 20.1666 25.4528L19.9807 25.6459C19.9539 25.6226 19.9267 25.5994 19.8984 25.5771C19.8751 25.5589 19.8514 25.5412 19.8276 25.524L19.9757 25.3026C20.0105 25.2506 19.9969 25.1798 19.9443 25.1449L19.907 25.1196C19.8549 25.0848 19.7842 25.0984 19.7493 25.151L19.6008 25.3729C19.5452 25.34 19.4891 25.3092 19.432 25.2809L19.5387 25.0383C19.5639 24.9806 19.5376 24.9139 19.4806 24.8886L19.4391 24.8704C19.3815 24.8452 19.3148 24.8714 19.2896 24.9286L19.1825 25.1727C19.1415 25.1576 19.1006 25.1434 19.0592 25.1303L19.1279 24.8745C19.1441 24.8138 19.1082 24.7516 19.0476 24.735L19.0041 24.7233C18.9435 24.7072 18.8814 24.743 18.8647 24.8037L18.7955 25.0615C18.7318 25.0484 18.6676 25.0372 18.6035 25.0292L18.6262 24.7648C18.6318 24.7021 18.5853 24.647 18.5226 24.6419L18.4777 24.6379C18.415 24.6323 18.36 24.6788 18.3549 24.7415L18.3322 25.0084C18.2635 25.0069 18.1948 25.0084 18.126 25.012L18.1003 24.7461C18.0942 24.6834 18.0386 24.6379 17.976 24.644L17.931 24.6485C17.8684 24.6546 17.8229 24.7102 17.829 24.7729L17.8547 25.0408C17.7951 25.0504 17.7355 25.062 17.6764 25.0757L17.6052 24.8169C17.5885 24.7562 17.5258 24.7208 17.4652 24.7375L17.4218 24.7496C17.3611 24.7663 17.3258 24.829 17.3424 24.8896L17.4142 25.151C17.3455 25.1747 17.2773 25.201 17.2106 25.2304L17.0918 24.9877C17.0641 24.9311 16.9964 24.9078 16.9398 24.9356L16.8994 24.9554C16.8428 24.9832 16.8195 25.0509 16.8473 25.1075L16.9671 25.3527C16.9115 25.384 16.8574 25.4174 16.8039 25.4533L16.6437 25.2339C16.6068 25.1833 16.5356 25.1722 16.4851 25.2091L16.4487 25.2359C16.3982 25.2728 16.3871 25.3441 16.4239 25.3946L16.5861 25.6166C16.5336 25.6605 16.4825 25.7075 16.433 25.7561L16.233 25.567C16.1875 25.524 16.1152 25.5261 16.0723 25.5716L16.0415 25.6044C15.9985 25.6499 16.0006 25.7222 16.046 25.7652L16.2486 25.9568C16.2365 25.9714 16.2234 25.9861 16.2117 26.0012C16.187 26.0326 16.1632 26.0644 16.14 26.0968L15.898 25.936C15.8455 25.9012 15.7752 25.9153 15.7404 25.9679L15.7156 26.0053C15.6808 26.0574 15.6949 26.1281 15.7474 26.163L15.992 26.3258C15.9652 26.3723 15.9399 26.4198 15.9162 26.4673L15.6484 26.347C15.5913 26.3212 15.5241 26.347 15.4984 26.4041L15.4797 26.4456C15.4539 26.5027 15.4797 26.5699 15.5368 26.5957L15.8055 26.716L15.8182 26.6882C15.7884 26.7651 15.7626 26.8429 15.7409 26.9213L15.7464 26.898L15.4605 26.8272C15.3993 26.8121 15.3382 26.8495 15.3231 26.9101L15.3124 26.9541C15.2973 27.0153 15.3347 27.077 15.3953 27.0916L15.6813 27.1624L15.7025 27.0754C15.6848 27.1583 15.6706 27.2412 15.6611 27.3252L15.3756 27.3034C15.313 27.2989 15.2584 27.3459 15.2538 27.4081L15.2503 27.453C15.2458 27.5157 15.2927 27.5703 15.3549 27.5749L15.6434 27.5966C15.6424 27.6674 15.6434 27.7381 15.6484 27.8089L15.3655 27.8398C15.3028 27.8463 15.2579 27.9029 15.265 27.9651L15.27 28.0101C15.2766 28.0728 15.3332 28.1178 15.3953 28.1107L15.6818 28.0794C15.6919 28.138 15.704 28.1961 15.7181 28.2538L15.4403 28.3351C15.3801 28.3528 15.3453 28.416 15.363 28.4762L15.3756 28.5197C15.3933 28.5798 15.4564 28.6147 15.5166 28.597L15.7959 28.5156C15.8162 28.5727 15.8384 28.6288 15.8626 28.6844L15.5989 28.8128C15.5423 28.8401 15.5191 28.9084 15.5464 28.965L15.5661 29.0054C15.5934 29.0621 15.6616 29.0853 15.7181 29.058L15.9829 28.9286L15.9743 28.9109C16.0071 28.9706 16.043 29.0287 16.0809 29.0858L16.0779 29.0813L15.8389 29.2541C15.7879 29.291 15.7767 29.3623 15.8136 29.4129L15.8399 29.4493C15.8768 29.5003 15.948 29.5114 15.9985 29.4745L16.2375 29.3017L16.2006 29.2506C16.2663 29.3345 16.337 29.4149 16.4143 29.4912L16.3633 29.4422L16.1587 29.6545C16.1152 29.6995 16.1163 29.7718 16.1617 29.8153L16.1941 29.8466C16.239 29.8901 16.3113 29.8891 16.3547 29.8436L16.5593 29.6313L16.4623 29.5377C16.5174 29.5898 16.5745 29.6404 16.6351 29.6884C16.6902 29.7318 16.7463 29.7723 16.8039 29.8107L16.7144 29.7506L16.5502 29.9957C16.5154 30.0478 16.529 30.1186 16.5816 30.1534L16.619 30.1787C16.671 30.2136 16.7417 30.1999 16.7766 30.1474L16.9408 29.9022L16.8594 29.8476C16.9378 29.8971 17.0176 29.9421 17.0989 29.9831L16.9827 30.247C16.9575 30.3046 16.9837 30.3713 17.0408 30.3966L17.0822 30.4148C17.1398 30.4401 17.2065 30.4138 17.2318 30.3566L17.3485 30.0913C17.3889 30.1064 17.4298 30.1206 17.4708 30.1337L17.3955 30.4153C17.3793 30.4759 17.4152 30.5381 17.4758 30.5548L17.5193 30.5664C17.5799 30.5826 17.642 30.5467 17.6587 30.4861L17.7345 30.203C17.7987 30.2161 17.8628 30.2277 17.9275 30.2358L17.9032 30.5225C17.8977 30.5851 17.9442 30.6402 18.0068 30.6453L18.0518 30.6493C18.1144 30.6549 18.1695 30.6084 18.1745 30.5457L18.1993 30.2571C18.264 30.2586 18.3286 30.2571 18.3933 30.2545L18.4211 30.5432C18.4272 30.6059 18.4827 30.6514 18.5454 30.6453L18.5903 30.6407C18.653 30.6347 18.6985 30.5791 18.6924 30.5164L18.6646 30.2272C18.7293 30.2171 18.794 30.205 18.8576 30.1903L18.8379 30.1959L18.9162 30.48C18.9329 30.5407 18.9955 30.576 19.0562 30.5594L19.0996 30.5472C19.1602 30.5305 19.1956 30.4679 19.1789 30.4072L19.1006 30.1226L19.0784 30.1287C19.1532 30.1044 19.2274 30.0771 19.3002 30.0458L19.429 30.3086C19.4568 30.3652 19.5245 30.3885 19.5811 30.3607L19.6215 30.341C19.6781 30.3132 19.7013 30.2454 19.6735 30.1888L19.5447 29.9255C19.5993 29.8951 19.6528 29.8623 19.7054 29.8279L19.8772 30.063C19.914 30.1135 19.9853 30.1246 20.0358 30.0877L20.0722 30.0609C20.1227 30.024 20.1338 29.9528 20.0969 29.9022L19.9251 29.6671C19.9777 29.6242 20.0287 29.5792 20.0782 29.5317L20.2879 29.7298C20.3334 29.7728 20.4056 29.7708 20.4486 29.7253L20.4794 29.6924C20.5223 29.6469 20.5203 29.5746 20.4748 29.5317L20.2647 29.333C20.2839 29.3103 20.3031 29.288 20.3217 29.2648C20.3379 29.244 20.3536 29.2228 20.3692 29.2021L20.6087 29.3613C20.6608 29.3962 20.7315 29.382 20.7663 29.3295L20.7911 29.2921C20.826 29.24 20.8118 29.1692 20.7593 29.1343L20.5208 28.9761C20.5486 28.9296 20.5754 28.8826 20.5996 28.8346L20.8578 28.9503C20.9149 28.9761 20.9821 28.9503 21.0078 28.8932L21.0265 28.8518C21.0523 28.7946 21.0265 28.7274 20.9694 28.7016L20.7123 28.5864C20.7365 28.5242 20.7578 28.4615 20.777 28.3983L21.0488 28.4656C21.1099 28.4807 21.1715 28.4433 21.1862 28.3827L21.1968 28.3387C21.212 28.2775 21.1746 28.2164 21.1139 28.2012L20.8426 28.1345C20.8532 28.0799 20.8628 28.0248 20.8699 27.9697L21.1458 27.9904C21.2084 27.9949 21.263 27.9479 21.2675 27.8858L21.2711 27.8408C21.2756 27.7781 21.2286 27.7235 21.1665 27.7189L21.166 27.7169ZM19.4098 26.1918C19.7064 26.4274 19.9105 26.7362 20.0176 27.0719L19.6271 27.1477C19.5846 27.0163 19.527 26.902 19.4538 26.8055C19.3477 26.666 19.2214 26.5689 19.0754 26.5153C18.9294 26.4612 18.7768 26.4496 18.6176 26.4805C18.4287 26.5169 18.2872 26.5896 18.1932 26.6978C18.0993 26.806 18.0381 26.9253 18.0098 27.0552C17.9851 27.1705 17.9669 27.31 17.9553 27.4717L17.4804 27.5637C17.4854 27.5516 17.4895 27.5395 17.496 27.5279C17.5415 27.4444 17.6117 27.3888 17.7057 27.361L17.5587 26.6018C17.3824 26.6483 17.2318 26.7352 17.1065 26.8621C16.9817 26.989 16.8943 27.1457 16.8448 27.3327C16.8145 27.4475 16.8013 27.5683 16.8054 27.6952L16.4335 27.7675C16.4007 27.3231 16.528 26.8656 16.8266 26.4891C17.4576 25.6934 18.6141 25.5609 19.4088 26.1923L19.4098 26.1918ZM18.9758 27.2741L18.6161 27.3439C18.6414 27.261 18.6934 27.2119 18.7722 27.1968C18.8384 27.1841 18.895 27.1978 18.9425 27.2382C18.9546 27.2483 18.9657 27.2604 18.9758 27.2741ZM17.8936 27.9247C17.8694 28.0051 17.8189 28.0531 17.7406 28.0682C17.6744 28.0809 17.6153 28.0652 17.5637 28.0207C17.5546 28.0126 17.5465 28.003 17.5385 27.9934L17.8936 27.9247ZM17.1242 29.0722C16.8276 28.8366 16.623 28.5277 16.5164 28.1921L16.8822 28.1213C16.9231 28.2477 16.9777 28.3604 17.0484 28.457C17.151 28.597 17.2742 28.6961 17.4177 28.7537C17.5612 28.8113 17.7138 28.8245 17.8765 28.7931C18.0679 28.7527 18.2119 28.6774 18.3094 28.5672C18.4064 28.4565 18.4696 28.3377 18.4979 28.2113C18.5232 28.0996 18.5439 27.9616 18.56 27.7963L19.0011 27.7109C18.9571 27.7826 18.8899 27.8342 18.799 27.8635L18.9364 28.5737C19.2158 28.4913 19.424 28.3432 19.5614 28.1284C19.6619 27.9707 19.7089 27.7862 19.7028 27.5744L20.1005 27.497C20.1333 27.9414 20.006 28.3988 19.7074 28.7754C19.0764 29.5711 17.9199 29.7035 17.1252 29.0722H17.1242Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9947 33.7227C8.07907 33.7267 8.15132 33.6615 8.15536 33.5771C8.1594 33.4927 8.09423 33.4204 8.00986 33.4164L7.63195 33.3977C7.63245 33.3572 7.63397 33.3168 7.63397 33.2763C7.63397 33.2597 7.63397 33.243 7.63346 33.2263H8.0048C8.08968 33.2263 8.15839 33.1575 8.15839 33.0726C8.15839 32.9877 8.08968 32.9189 8.0048 32.9189H7.62689C7.62437 32.8613 7.62184 32.8042 7.61831 32.7471L7.98409 32.7269C8.06846 32.7223 8.13364 32.65 8.12858 32.5651C8.12404 32.4807 8.05179 32.4155 7.96691 32.42L7.59456 32.4407C7.589 32.3836 7.58345 32.327 7.57688 32.2704L7.93003 32.2512C8.0144 32.2466 8.07958 32.1743 8.07452 32.0894C8.06998 32.005 7.99773 31.9398 7.91285 31.9448L7.53646 31.9656C7.52787 31.9084 7.51878 31.8518 7.50918 31.7952L7.87698 31.728C7.96034 31.7128 8.01541 31.6329 8.00026 31.5495C7.9851 31.4661 7.90527 31.411 7.82191 31.4262L7.45259 31.4934C7.44198 31.4414 7.43087 31.3893 7.41925 31.3372L7.76331 31.2604C7.84616 31.2417 7.8982 31.1598 7.87951 31.0769C7.86081 30.994 7.77897 30.9419 7.69611 30.9606L7.34599 31.039C7.33184 30.9859 7.3177 30.9333 7.30305 30.8808L7.65367 30.7685C7.73451 30.7428 7.77897 30.6563 7.7527 30.5754C7.72693 30.4946 7.64054 30.4501 7.5597 30.4764L7.21413 30.5871C7.19695 30.534 7.17977 30.4809 7.16158 30.4283L7.51372 30.3009C7.59355 30.2721 7.63447 30.1842 7.60618 30.1043C7.57738 30.0244 7.48947 29.9835 7.40965 30.0118L7.0565 30.1392C7.02618 30.0593 6.99435 29.98 6.96202 29.9011L6.99284 29.9643L7.33386 29.7975C7.41015 29.7601 7.44148 29.6681 7.40409 29.5922C7.3667 29.5159 7.27475 29.4846 7.19897 29.522L6.86805 29.6842C6.84481 29.6327 6.82157 29.5811 6.79732 29.5306L7.10449 29.3491C7.17724 29.3061 7.202 29.2121 7.15855 29.1388C7.11561 29.066 7.02164 29.0412 6.94838 29.0847L6.6604 29.2546C6.6316 29.1984 6.60179 29.1428 6.57198 29.0877L6.89432 28.9381C6.97111 28.9022 7.00446 28.8112 6.96859 28.7344C6.93272 28.6576 6.84177 28.6242 6.76498 28.6601L6.42092 28.8203L6.42345 28.8259C6.37141 28.7374 6.31836 28.6505 6.26329 28.564L6.56693 28.3816C6.63969 28.3381 6.66293 28.2436 6.61948 28.1708C6.57603 28.098 6.48155 28.0747 6.4088 28.1182L6.09354 28.3078C6.05615 28.2532 6.01826 28.1991 5.97936 28.1455L6.26228 27.9377C6.33049 27.8877 6.34514 27.7916 6.29512 27.7234C6.2451 27.6552 6.14911 27.6405 6.08091 27.6905L5.79545 27.8998C5.75958 27.8538 5.72321 27.8078 5.68683 27.7623L5.96016 27.5343C6.02533 27.4802 6.03392 27.3832 5.97986 27.318C5.9258 27.2528 5.8288 27.2442 5.76363 27.2983L5.4903 27.5262C5.45241 27.4828 5.41452 27.4398 5.37612 27.3968L5.63025 27.1618C5.69239 27.1042 5.69643 27.0071 5.63883 26.9449C5.58124 26.8827 5.48424 26.8787 5.42209 26.9363L5.16645 27.1724C5.12603 27.1309 5.08561 27.0895 5.04419 27.0485L5.27608 26.8089C5.33519 26.7483 5.33368 26.6507 5.27305 26.5921C5.21242 26.5329 5.11492 26.5345 5.05631 26.5951L4.8229 26.8357C4.78096 26.7968 4.73903 26.7584 4.69608 26.7205L4.91384 26.4955C4.97295 26.4349 4.97143 26.3373 4.91081 26.2787C4.85018 26.2195 4.75267 26.221 4.69406 26.2817L4.46368 26.5193C4.41821 26.4814 4.37173 26.444 4.32525 26.4066L4.52077 26.1467C4.5718 26.079 4.55816 25.9829 4.49046 25.9319C4.42276 25.8808 4.32677 25.8945 4.27574 25.9622L4.08224 26.2195C4.03879 26.1872 3.99534 26.1558 3.95138 26.1245L4.12013 25.8803C4.16812 25.8106 4.15095 25.715 4.08123 25.667C4.01151 25.619 3.91602 25.6362 3.86802 25.7059L3.69877 25.9506C3.65179 25.9193 3.60429 25.8884 3.5568 25.8581L3.70635 25.5937C3.74828 25.5199 3.72201 25.4264 3.64825 25.3844C3.57449 25.3425 3.48102 25.3688 3.43909 25.4426L3.29409 25.6984C3.24558 25.6695 3.19607 25.6417 3.14707 25.6139L3.28651 25.345C3.32541 25.2697 3.29611 25.1772 3.22083 25.1383C3.14555 25.0993 3.05309 25.1287 3.01419 25.204L2.87677 25.4689C2.81917 25.439 2.76107 25.4102 2.70297 25.3814L2.81261 25.0978C2.84343 25.019 2.80402 24.93 2.7252 24.8992C2.64639 24.8683 2.55747 24.9077 2.52665 24.9866L2.42459 25.2505C2.37155 25.2267 2.31799 25.2035 2.26393 25.1812L2.35891 24.8663C2.38317 24.7849 2.33719 24.6995 2.25635 24.6752C2.17501 24.651 2.08963 24.697 2.06538 24.7778L1.97848 25.067C1.91583 25.0432 1.85268 25.02 1.78902 24.9972L1.89007 24.6611C1.91432 24.5797 1.86834 24.4942 1.78751 24.47C1.70616 24.4457 1.62078 24.4917 1.59653 24.5726L1.49801 24.8997C1.43688 24.8805 1.37575 24.8617 1.31411 24.8441L1.39141 24.4725C1.40859 24.3896 1.35554 24.3082 1.27268 24.291C1.18982 24.2738 1.10848 24.3269 1.09131 24.4098L1.01805 24.7627C0.959947 24.748 0.901341 24.7339 0.842735 24.7202L0.859407 24.3411C0.862944 24.2562 0.797265 24.1849 0.712892 24.1808C0.680558 24.1793 0.65075 24.1879 0.625488 24.2041V25.2474C4.31312 26.0573 7.07317 29.344 7.07317 33.2768C7.07317 34.0528 6.96556 34.8035 6.76498 35.5152H7.347C7.36721 35.4389 7.3854 35.3625 7.40359 35.2857L7.73047 35.3909C7.8113 35.4166 7.8977 35.3721 7.92346 35.2918C7.94923 35.2109 7.90477 35.1244 7.82444 35.0987L7.46926 34.9844C7.48846 34.8859 7.50665 34.7868 7.52231 34.6877L7.86738 34.7595C7.95024 34.7767 8.03158 34.7236 8.04876 34.6407C8.06594 34.5578 8.01289 34.4764 7.93003 34.4592L7.56576 34.3834C7.57385 34.3182 7.58143 34.2525 7.58799 34.1862L7.94468 34.2267C8.02905 34.2363 8.10484 34.1756 8.11444 34.0912C8.12404 34.0068 8.06341 33.931 7.97904 33.9214L7.61426 33.8799C7.61831 33.8218 7.62083 33.7636 7.62386 33.7055L7.99621 33.7242L7.9947 33.7227Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08423 6.7896L5.08928 6.85683L5.08777 6.92457L5.08473 7.06004L5.25398 7.06661L5.25752 6.92356L5.25853 6.85228L5.25348 6.78101L5.08423 6.7896Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.327 0.934331H21.1811C20.3218 4.70386 16.9504 7.51647 12.9227 7.51647C9.32351 7.51647 6.24922 5.27053 5.02203 2.10305L7.5234 1.34581C7.75732 1.87911 8.04934 2.34013 8.40047 2.72886C8.90923 3.2925 9.48872 3.66708 10.1379 3.85411C10.7871 4.04014 11.4576 4.02902 12.1487 3.82024C12.9626 3.55991 13.5563 3.16764 13.9291 2.64394C14.3015 2.11973 14.5223 1.57632 14.5905 1.01218C14.5945 0.977299 14.5986 0.941408 14.6026 0.905518H4.23186L4.24095 0.934837H3.47857C3.47857 0.938881 3.47705 0.942925 3.47705 0.947474C3.47705 1.04099 3.55283 1.11732 3.64681 1.11732H4.04897C4.05806 1.15675 4.06816 1.19568 4.07776 1.2351L3.7433 1.2897C3.65085 1.30486 3.5882 1.39181 3.60336 1.48432C3.61851 1.57682 3.70541 1.63951 3.79787 1.62434L4.16517 1.56419C4.17628 1.60362 4.1879 1.64254 4.19952 1.68146L3.86405 1.75476C3.77261 1.77498 3.71451 1.86547 3.73472 1.95696C3.75492 2.04846 3.84536 2.10659 3.93681 2.08637L4.30511 2.006C4.31926 2.04745 4.33391 2.08839 4.34856 2.12934L4.01613 2.2269C3.9262 2.25319 3.87466 2.34772 3.90093 2.43769C3.92721 2.52767 4.02168 2.57924 4.11161 2.55295L4.46931 2.44831C4.48447 2.48622 4.50013 2.52363 4.51579 2.56104L4.21316 2.68084C4.12626 2.71522 4.08332 2.81379 4.11768 2.90124C4.15203 2.98819 4.25055 3.03115 4.33795 2.99678L4.65321 2.87243C4.67393 2.91742 4.69515 2.96241 4.71687 3.0074L4.43445 3.13579C4.34907 3.17472 4.31118 3.27531 4.35008 3.36024C4.38898 3.44567 4.48952 3.48358 4.5749 3.44465L4.87046 3.31019C4.89269 3.35215 4.91543 3.3941 4.93867 3.43556L4.64968 3.60237C4.56834 3.64938 4.54055 3.75301 4.58754 3.8344C4.63452 3.91578 4.73809 3.94359 4.81943 3.89657L5.10842 3.72976C5.13065 3.76717 5.15339 3.80457 5.17612 3.84147L4.87551 4.01486C4.79417 4.06187 4.76638 4.1655 4.81337 4.24689C4.86036 4.32827 4.96393 4.35607 5.04527 4.30906L5.36002 4.12708C5.38781 4.16853 5.41661 4.20948 5.4449 4.25042L5.15793 4.44909C5.08063 4.50217 5.06144 4.60832 5.11499 4.68516C5.16804 4.76199 5.27414 4.78171 5.35093 4.72812L5.64396 4.52542C5.67225 4.56283 5.70055 4.60023 5.72934 4.63713L5.46865 4.8176C5.39135 4.87068 5.37215 4.97683 5.4257 5.05367C5.47875 5.1305 5.58485 5.15022 5.66164 5.09664L5.94305 4.90202C5.97084 4.93488 5.99863 4.96773 6.02692 5.00008L5.78037 5.20987C5.70913 5.27053 5.70055 5.37769 5.76117 5.44897C5.8218 5.52025 5.92891 5.52884 6.00014 5.46818L6.25326 5.25284C6.2861 5.28822 6.31945 5.32361 6.35279 5.35849L6.11432 5.56119C6.04309 5.62185 6.0345 5.72902 6.09513 5.80029C6.15575 5.87157 6.26286 5.88016 6.3341 5.8195L6.59277 5.59961C6.62309 5.62893 6.65391 5.65825 6.68472 5.68706L6.46344 5.90847C6.39725 5.97469 6.39725 6.08236 6.46344 6.14859C6.52962 6.21481 6.63723 6.21481 6.70342 6.14859L6.93683 5.91504C6.9727 5.94638 7.00857 5.97722 7.04495 6.00806L6.81305 6.24008C6.74687 6.3063 6.74687 6.41397 6.81305 6.4802C6.87924 6.54642 6.98685 6.54642 7.05303 6.4802L7.30969 6.2234C7.35162 6.25626 7.39355 6.28861 7.4365 6.32096L7.24502 6.5358C7.18237 6.60556 7.18894 6.71323 7.25866 6.77541C7.32838 6.83809 7.43599 6.83152 7.49814 6.76176L7.71286 6.52114C7.74216 6.54136 7.77146 6.56158 7.80077 6.5818L7.61787 6.84264C7.56432 6.91948 7.58251 7.02513 7.6593 7.07921C7.7361 7.1333 7.84169 7.1146 7.89575 7.03776L8.0842 6.76833C8.11906 6.79007 8.15442 6.8118 8.18928 6.83303L8.02205 7.12319C7.97507 7.20458 8.00286 7.30821 8.0842 7.35522C8.16554 7.40223 8.26911 7.37443 8.31609 7.29304L8.48282 7.0044C8.52021 7.02563 8.5581 7.04636 8.59599 7.06708L8.46362 7.35876C8.42472 7.44419 8.46261 7.54478 8.54799 7.5832C8.63338 7.62212 8.73392 7.58421 8.77231 7.49878L8.89761 7.22278C8.93196 7.23996 8.96682 7.25614 9.00118 7.27282L8.89155 7.5741C8.85972 7.66206 8.90468 7.75962 8.9931 7.79147C9.08101 7.82331 9.17851 7.77832 9.21034 7.68986L9.31088 7.41386C9.35837 7.43458 9.40587 7.4548 9.45386 7.47452L9.35383 7.80057C9.32655 7.89004 9.37656 7.98508 9.46649 8.01237C9.55592 8.03967 9.6509 7.98962 9.67818 7.89964L9.77064 7.59735C9.81358 7.61303 9.85703 7.6287 9.89998 7.64386L9.80853 7.94211C9.78125 8.03158 9.83126 8.12662 9.92119 8.15391C10.0106 8.18121 10.1056 8.13117 10.1329 8.04119L10.2223 7.75002C10.2637 7.76316 10.3057 7.7758 10.3476 7.78793L10.2966 8.10387C10.2814 8.19637 10.3446 8.28332 10.437 8.29849C10.5295 8.31315 10.6164 8.25046 10.6315 8.15796L10.6765 7.87791C10.727 7.89055 10.7776 7.90318 10.8286 7.91481L10.7765 8.23732C10.7619 8.32983 10.8245 8.41677 10.917 8.43194C11.0094 8.4466 11.0963 8.38392 11.1115 8.29141L11.1605 7.98659C11.208 7.99569 11.255 8.00479 11.3025 8.01338L11.254 8.31567C11.2388 8.40818 11.302 8.49513 11.3944 8.51029C11.4869 8.52546 11.5738 8.46227 11.5889 8.36976L11.6374 8.06697C11.6819 8.07303 11.7269 8.0791 11.7718 8.08516L11.7511 8.39807C11.7451 8.49159 11.8158 8.57247 11.9093 8.57853C12.0027 8.5846 12.0836 8.51383 12.0896 8.42031L12.1093 8.12156C12.1533 8.1256 12.1977 8.12864 12.2417 8.13167V8.46176C12.2417 8.55528 12.3175 8.63161 12.4114 8.63161C12.5054 8.63161 12.5812 8.55579 12.5812 8.46176V8.15037C12.6358 8.1524 12.6908 8.15442 12.7459 8.15543V8.46227C12.7459 8.55579 12.8217 8.63212 12.9157 8.63212C13.0091 8.63212 13.0854 8.55629 13.0854 8.46227V8.15593C13.1218 8.15543 13.1587 8.15442 13.1951 8.15341L13.2102 8.47036C13.2148 8.56388 13.2941 8.63616 13.3875 8.63161C13.481 8.62706 13.5533 8.5477 13.5487 8.45418L13.5336 8.13774C13.5932 8.13369 13.6528 8.12914 13.7119 8.12409L13.725 8.39352C13.7296 8.48704 13.8089 8.55933 13.9024 8.55478C13.9958 8.55023 14.0681 8.47086 14.0635 8.37735L14.0499 8.0887C14.0888 8.08415 14.1272 8.0791 14.1661 8.07404L14.2116 8.36471C14.2262 8.45721 14.3131 8.5204 14.4056 8.50574C14.498 8.49108 14.5612 8.40414 14.5465 8.31163L14.5011 8.02198C14.5521 8.01288 14.6031 8.00327 14.6541 7.99367L14.7168 8.28029C14.737 8.37178 14.8274 8.42992 14.9189 8.4097C15.0103 8.38948 15.0684 8.29899 15.0482 8.2075L14.9861 7.9229C15.025 7.9138 15.0634 7.90521 15.1023 7.8956L15.1806 8.19789C15.2043 8.28838 15.2968 8.34297 15.3872 8.31921C15.4777 8.29545 15.5322 8.20295 15.509 8.11246L15.4302 7.80815C15.4777 7.7945 15.5251 7.78035 15.5726 7.76619L15.6474 8.05483C15.6712 8.14582 15.7636 8.19991 15.8541 8.17666C15.9445 8.1529 15.9991 8.06039 15.9758 7.96991L15.896 7.66206C15.942 7.64639 15.9874 7.63021 16.0329 7.61404L16.1001 7.87235C16.1238 7.96283 16.2163 8.01743 16.3067 7.99417C16.3977 7.97042 16.4517 7.87791 16.4285 7.78742L16.3517 7.4917C16.3992 7.4725 16.4462 7.45278 16.4932 7.43256L16.5907 7.69846C16.623 7.78641 16.7205 7.83191 16.8084 7.79956C16.8963 7.7672 16.9418 7.66964 16.9095 7.58168L16.8039 7.29355C16.8448 7.27434 16.8857 7.25513 16.9261 7.23491L17.0444 7.49676C17.0828 7.58219 17.1833 7.6201 17.2687 7.58168C17.3541 7.54327 17.392 7.44267 17.3536 7.35724L17.2283 7.07921C17.2687 7.05748 17.3086 7.03524 17.349 7.01299L17.4743 7.29102C17.5127 7.37645 17.6132 7.41436 17.6986 7.37594C17.784 7.33753 17.8219 7.23693 17.7835 7.1515L17.6436 6.84163C17.6855 6.81635 17.7274 6.79057 17.7694 6.76429L17.924 7.03271C17.9709 7.11409 18.0745 7.1419 18.1559 7.09489C18.2372 7.04787 18.265 6.94425 18.218 6.86286L18.0533 6.57776C18.0841 6.55703 18.1144 6.5358 18.1447 6.51457L18.318 6.76378C18.3716 6.84062 18.4772 6.85932 18.554 6.80624C18.6308 6.75266 18.65 6.64701 18.5964 6.57017L18.4191 6.3154C18.4625 6.28254 18.5055 6.24969 18.5479 6.21632L18.7156 6.45694C18.7692 6.53378 18.8748 6.55299 18.9516 6.4994C19.0284 6.44582 19.0471 6.34017 18.994 6.26333L18.8111 6.00098C18.8455 5.97217 18.8793 5.94285 18.9132 5.91302L19.1208 6.13999C19.184 6.20925 19.2916 6.2138 19.3603 6.15061C19.429 6.08742 19.4341 5.97975 19.3709 5.911L19.1643 5.68555C19.1946 5.65673 19.2254 5.62792 19.2552 5.5991L19.4528 5.81495C19.5159 5.88421 19.6235 5.88876 19.6922 5.82557C19.7615 5.76238 19.766 5.65471 19.7029 5.58596L19.4947 5.35849C19.526 5.32613 19.5568 5.29328 19.5872 5.26042L19.7918 5.46515C19.858 5.53137 19.9656 5.53137 20.0318 5.46515C20.0979 5.39893 20.0979 5.29125 20.0318 5.22503L19.8145 5.00767C19.8423 4.97532 19.8701 4.94296 19.8974 4.91061L20.1464 5.11938C20.2182 5.17954 20.3253 5.17044 20.3854 5.09866C20.4455 5.02688 20.4364 4.91971 20.3642 4.85956L20.1106 4.64674C20.1429 4.60529 20.1747 4.56384 20.2061 4.52238L20.4612 4.73621C20.5329 4.79637 20.64 4.78727 20.7002 4.71498C20.7603 4.6432 20.7512 4.53603 20.6789 4.47588L20.4056 4.24638C20.4334 4.20695 20.4607 4.16702 20.4875 4.12708L20.7406 4.29339C20.8189 4.34495 20.924 4.32322 20.9755 4.24486C21.027 4.16651 21.0053 4.06137 20.927 4.00981L20.6714 3.84198C20.6976 3.79952 20.7234 3.75655 20.7492 3.71358L21.018 3.86877C21.0993 3.91578 21.2029 3.88798 21.2499 3.80659C21.2968 3.72521 21.2691 3.62158 21.1877 3.57457L20.9179 3.41837C20.9376 3.38298 20.9568 3.34709 20.976 3.3112L21.2504 3.45123C21.3337 3.49369 21.4358 3.46083 21.4787 3.37692C21.5212 3.29351 21.4883 3.1914 21.4045 3.14843L21.1291 3.0079C21.1463 2.97252 21.163 2.93663 21.1796 2.90124L21.5373 3.02408C21.6257 3.05441 21.7222 3.0074 21.7531 2.91843C21.7834 2.82996 21.7364 2.73341 21.6475 2.70308L21.3186 2.59036C21.3357 2.54941 21.3529 2.50796 21.3696 2.46651L21.6778 2.57216C21.7662 2.60249 21.8627 2.55548 21.893 2.46651C21.9233 2.37805 21.8763 2.28149 21.7874 2.25116L21.4903 2.14905C21.505 2.10811 21.5196 2.06716 21.5343 2.02571L21.846 2.10406C21.937 2.12681 22.0289 2.07171 22.0516 1.98072C22.0744 1.88973 22.0193 1.79773 21.9284 1.77498L21.6399 1.70269C21.6535 1.65872 21.6662 1.61423 21.6788 1.56975L21.9789 1.64507C22.0698 1.66781 22.1618 1.61272 22.1845 1.52172C22.2073 1.43073 22.1522 1.33873 22.0612 1.31599L21.7662 1.24218C21.7753 1.20629 21.7844 1.1704 21.7925 1.13451L22.1552 1.19062C22.2477 1.20477 22.3346 1.14159 22.3487 1.04857C22.3548 1.00864 22.3457 0.969716 22.327 0.937364V0.934331Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7489 0.905029H16.9983L17.692 1.75528C18.3053 1.27405 18.5362 1.16738 18.7484 0.905029H18.7489Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45729 35.4299L9.36635 35.3384C9.38453 35.306 9.39919 35.2721 9.4103 35.2357H9.53812C9.6129 35.2362 9.67302 35.1761 9.67352 35.1013C9.67352 35.027 9.6134 34.9663 9.53913 34.9658H9.41333C9.40323 34.9284 9.38908 34.893 9.3714 34.8596L9.45981 34.7717C9.51286 34.7191 9.51286 34.6337 9.45981 34.5806C9.40727 34.5275 9.32189 34.5275 9.26884 34.5801L9.18143 34.6671C9.14809 34.6478 9.11171 34.6327 9.07382 34.6221V34.4992C9.07382 34.4244 9.01319 34.3643 8.93893 34.3643C8.86466 34.3643 8.80403 34.4249 8.80403 34.4992V34.6221C8.76715 34.6327 8.73178 34.6473 8.69894 34.6655L8.61204 34.5781C8.5595 34.525 8.47412 34.525 8.42107 34.5776C8.36802 34.6302 8.36802 34.7156 8.42107 34.7687L8.50898 34.8571C8.49079 34.89 8.47664 34.9254 8.46604 34.9628H8.34023C8.26546 34.9623 8.20534 35.0224 8.20483 35.0972C8.20483 35.172 8.26496 35.2322 8.33922 35.2327H8.46705C8.47766 35.2691 8.4918 35.3035 8.50999 35.3358L8.41854 35.4268C8.39429 35.4511 8.38166 35.4819 8.37964 35.5138H9.49568C9.49316 35.4829 9.48103 35.4531 9.45729 35.4299ZM8.93893 35.3758C8.78483 35.3758 8.65954 35.2504 8.65954 35.0962C8.65954 34.942 8.78483 34.8167 8.93893 34.8167C9.09302 34.8167 9.21831 34.942 9.21831 35.0962C9.21831 35.2504 9.09302 35.3758 8.93893 35.3758Z",
    fill: "url(#paint246_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 31.1345C15.1809 31.1456 15.1632 31.1588 15.145 31.1704L15.0364 31.2437L15.1253 31.3711L15.2284 31.3018C15.2455 31.2907 15.2622 31.2781 15.2799 31.2674L15.3345 31.2381L15.2577 31.1031L15.2001 31.1345H15.1996Z",
    fill: "url(#paint247_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7693 31.4535C14.7526 31.4677 14.735 31.4808 14.7198 31.4965L14.6738 31.5435L14.7819 31.6552L14.8254 31.6107C14.84 31.5961 14.8567 31.5839 14.8724 31.5703L14.9679 31.4909L14.8699 31.3701L14.7688 31.454L14.7693 31.4535Z",
    fill: "url(#paint248_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5381 30.7226C16.5163 30.7236 16.4946 30.7271 16.4729 30.7291L16.3425 30.7433L16.3617 30.8975L16.4855 30.8843C16.5062 30.8823 16.5264 30.8793 16.5471 30.8782H16.6093L16.6037 30.722L16.5381 30.7231V30.7226Z",
    fill: "url(#paint249_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0086 30.8029C15.9652 30.81 15.9248 30.8272 15.8823 30.8383L15.9258 30.9874C15.9657 30.9763 16.0041 30.9601 16.045 30.9536L16.1668 30.9288L16.1365 30.7761L16.0081 30.8024L16.0086 30.8029Z",
    fill: "url(#paint250_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4436 31.0031L15.5108 31.1436L15.7397 31.0476L15.6856 30.9015L15.4436 31.0031Z",
    fill: "url(#paint251_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8541 30.954L17.7318 30.906L17.6772 31.0516L17.7929 31.0971C17.8121 31.1047 17.8318 31.1117 17.8505 31.1203L17.9056 31.1486L17.9733 31.0086L17.9147 30.9788C17.895 30.9697 17.8743 30.9626 17.8541 30.954Z",
    fill: "url(#paint252_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2498 30.9293C17.3321 30.9404 17.4109 30.9672 17.4907 30.9889L17.5347 30.8398C17.4503 30.8165 17.367 30.7887 17.2801 30.7766L17.2498 30.9293Z",
    fill: "url(#paint253_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8093 30.8752L17.0569 30.8959L17.0766 30.7412L16.8154 30.7195L16.8093 30.8752Z",
    fill: "url(#paint254_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0539 31.8984C18.9994 31.8301 18.9428 31.7634 18.8867 31.6962L18.771 31.7998C18.8235 31.864 18.8776 31.9267 18.9291 31.9914L19.0539 31.8984Z",
    fill: "url(#paint255_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5458 31.373L18.4478 31.4939L18.5448 31.5717L18.6332 31.6592L18.7418 31.5474L18.6478 31.4554L18.5458 31.373Z",
    fill: "url(#paint256_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.084 31.2402L18.2926 31.3747L18.3821 31.2473C18.3083 31.1998 18.2356 31.1517 18.1613 31.1052L18.084 31.2402Z",
    fill: "url(#paint257_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4426 33.2147L19.5962 33.1904L19.5431 32.9331L19.3926 32.971L19.4426 33.2147Z",
    fill: "url(#paint258_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.336 32.782L19.484 32.7335C19.4618 32.6485 19.4244 32.5692 19.391 32.4883L19.248 32.5494C19.2794 32.6263 19.3147 32.7011 19.336 32.7815V32.782Z",
    fill: "url(#paint259_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0764 32.2092L19.1057 32.2638L19.1648 32.373L19.3027 32.3017L19.2406 32.186L19.2092 32.1283L19.1724 32.0737L19.0415 32.1576L19.0764 32.2092Z",
    fill: "url(#paint260_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3293 34.5366L19.4764 34.5866L19.5486 34.3339L19.3976 34.2975L19.3293 34.5366Z",
    fill: "url(#paint261_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4543 33.9815C19.4528 34.0229 19.4411 34.0634 19.4346 34.1043L19.5882 34.1301C19.5947 34.0871 19.6069 34.0442 19.6084 34.0007L19.6195 33.8698L19.4644 33.8582L19.4543 33.982V33.9815Z",
    fill: "url(#paint262_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4709 33.4754C19.4719 33.4962 19.4714 33.5169 19.4719 33.5376L19.4734 33.662L19.6291 33.663L19.6275 33.5316C19.6275 33.5098 19.6275 33.4876 19.6265 33.4658L19.6195 33.4006L19.4644 33.4138L19.4709 33.4754Z",
    fill: "url(#paint263_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7478 35.5137H18.8312L18.7857 35.4738C18.7731 35.4874 18.7605 35.5005 18.7473 35.5137H18.7478Z",
    fill: "url(#paint264_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9089 35.3201L19.0327 35.4141C19.0908 35.3484 19.1328 35.2705 19.1818 35.1983L19.0499 35.1154C19.0034 35.1836 18.964 35.2574 18.9089 35.3196V35.3201Z",
    fill: "url(#paint265_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2333 34.7807C19.2247 34.7994 19.2146 34.8176 19.2055 34.8363L19.1489 34.947L19.2863 35.0203L19.3465 34.9035C19.3561 34.8838 19.3667 34.8646 19.3758 34.8448L19.4 34.7837L19.2565 34.723L19.2338 34.7807H19.2333Z",
    fill: "url(#paint266_linear_4648_14127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2109 32.1845L14.8869 31.9084L14.2968 31.4641L14.2109 32.1845Z",
    fill: "url(#paint267_linear_4648_14127)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4648_14127",
    x1: 21.5347,
    y1: 7.24552,
    x2: 25.4047,
    y2: 7.24552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4648_14127",
    x1: 23.6001,
    y1: 4.06031,
    x2: 23.3123,
    y2: 11.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4648_14127",
    x1: 18.4695,
    y1: 7.73084,
    x2: 19.6527,
    y2: 7.73084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4648_14127",
    x1: 11.738,
    y1: 9.75182,
    x2: 12.9213,
    y2: 9.75182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4648_14127",
    x1: 8.80199,
    y1: 9.42125,
    x2: 9.98573,
    y2: 9.42125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4648_14127",
    x1: 21.9748,
    y1: 3.02051,
    x2: 23.1581,
    y2: 3.02051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4648_14127",
    x1: 18.4695,
    y1: 3.55433,
    x2: 19.6527,
    y2: 3.55433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4648_14127",
    x1: 14.0007,
    y1: 29.0969,
    x2: 15.429,
    y2: 29.0969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4648_14127",
    x1: 7.78807,
    y1: 30.2191,
    x2: 8.97181,
    y2: 30.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4648_14127",
    x1: 3.00415,
    y1: 27.688,
    x2: 4.18739,
    y2: 27.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4648_14127",
    x1: 2.53888,
    y1: 30.202,
    x2: 5.78748,
    y2: 30.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4648_14127",
    x1: 4.6264,
    y1: 15.5914,
    x2: 6.60385,
    y2: 15.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4648_14127",
    x1: 6.12947,
    y1: 19.3427,
    x2: 7.92656,
    y2: 19.3427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4648_14127",
    x1: 5.72271,
    y1: 7.64693,
    x2: 7.45007,
    y2: 7.64693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4648_14127",
    x1: 3.66353,
    y1: 24.8072,
    x2: 5.13323,
    y2: 24.8072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4648_14127",
    x1: 5.43819,
    y1: 31.9029,
    x2: 6.44611,
    y2: 31.9029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4648_14127",
    x1: 4.17571,
    y1: 11.5266,
    x2: 8.84904,
    y2: 11.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4648_14127",
    x1: 6.55282,
    y1: 11.8203,
    x2: 7.72747,
    y2: 11.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4648_14127",
    x1: 5.80617,
    y1: 12.1995,
    x2: 6.50035,
    y2: 12.1995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4648_14127",
    x1: 9.26393,
    y1: 11.2324,
    x2: 12.316,
    y2: 11.2324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4648_14127",
    x1: 4.68703,
    y1: 8.36979,
    x2: 4.9649,
    y2: 8.36979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4648_14127",
    x1: 4.89502,
    y1: 7.91127,
    x2: 5.14309,
    y2: 7.91127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4648_14127",
    x1: 5.02757,
    y1: 7.42798,
    x2: 5.23673,
    y2: 7.42798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4648_14127",
    x1: 3.68921,
    y1: 9.48494,
    x2: 4.01407,
    y2: 9.48494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4648_14127",
    x1: 4.07666,
    y1: 9.16893,
    x2: 4.39495,
    y2: 9.16893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4648_14127",
    x1: 4.41113,
    y1: 8.79544,
    x2: 4.71225,
    y2: 8.79544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4648_14127",
    x1: 2.32153,
    y1: 10.0182,
    x2: 2.61861,
    y2: 10.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4648_14127",
    x1: 2.80005,
    y1: 9.91816,
    x2: 3.11531,
    y2: 9.91816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4648_14127",
    x1: 3.2583,
    y1: 9.73868,
    x2: 3.58164,
    y2: 9.73868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4648_14127",
    x1: 0.830583,
    y1: 9.8509,
    x2: 1.14989,
    y2: 9.8509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4648_14127",
    x1: 1.31665,
    y1: 9.98483,
    x2: 1.62181,
    y2: 9.98483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4648_14127",
    x1: 1.81982,
    y1: 10.0429,
    x2: 2.10578,
    y2: 10.0429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4648_14127",
    x1: 5.02148,
    y1: 6.42409,
    x2: 5.2357,
    y2: 6.42409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4648_14127",
    x1: 4.88039,
    y1: 5.94341,
    x2: 5.12997,
    y2: 5.94341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4648_14127",
    x1: 4.48851,
    y1: 5.29078,
    x2: 5.00535,
    y2: 5.29078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4648_14127",
    x1: 5.43213,
    y1: 14.0715,
    x2: 5.71303,
    y2: 14.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4648_14127",
    x1: 5.85913,
    y1: 14.1892,
    x2: 6.12741,
    y2: 14.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4648_14127",
    x1: 4.36011,
    y1: 13.3394,
    x2: 4.63444,
    y2: 13.3394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4648_14127",
    x1: 4.67285,
    y1: 13.6402,
    x2: 4.95578,
    y2: 13.6402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4648_14127",
    x1: 5.03003,
    y1: 13.8874,
    x2: 5.31548,
    y2: 13.8874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4648_14127",
    x1: 3.78322,
    y1: 12.1909,
    x2: 3.98784,
    y2: 12.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4648_14127",
    x1: 3.90941,
    y1: 12.6049,
    x2: 4.14282,
    y2: 12.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4648_14127",
    x1: 4.10034,
    y1: 12.9906,
    x2: 4.357,
    y2: 12.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4648_14127",
    x1: 3.77515,
    y1: 10.8811,
    x2: 3.97522,
    y2: 10.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4648_14127",
    x1: 3.72803,
    y1: 11.3139,
    x2: 3.89425,
    y2: 11.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4648_14127",
    x1: 3.72703,
    y1: 11.7567,
    x2: 3.89477,
    y2: 11.7567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4648_14127",
    x1: 4.33521,
    y1: 9.72357,
    x2: 4.60752,
    y2: 9.72357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4648_14127",
    x1: 4.08521,
    y1: 10.0759,
    x2: 4.34034,
    y2: 10.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4648_14127",
    x1: 3.89673,
    y1: 10.4626,
    x2: 4.12863,
    y2: 10.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4648_14127",
    x1: 5.39722,
    y1: 8.97641,
    x2: 5.67812,
    y2: 8.97641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4648_14127",
    x1: 5.0022,
    y1: 9.16898,
    x2: 5.28815,
    y2: 9.16898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4648_14127",
    x1: 4.64648,
    y1: 9.41829,
    x2: 4.92992,
    y2: 9.41829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4648_14127",
    x1: 6.70679,
    y1: 8.81271,
    x2: 6.96647,
    y2: 8.81271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4648_14127",
    x1: 6.26732,
    y1: 8.79901,
    x2: 6.51841,
    y2: 8.79901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4648_14127",
    x1: 5.82567,
    y1: 8.85367,
    x2: 6.09546,
    y2: 8.85367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4648_14127",
    x1: 7.91431,
    y1: 9.26555,
    x2: 8.19925,
    y2: 9.26555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4648_14127",
    x1: 7.53491,
    y1: 9.04872,
    x2: 7.81986,
    y2: 9.04872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4648_14127",
    x1: 7.13062,
    y1: 8.89958,
    x2: 7.40596,
    y2: 8.89958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4648_14127",
    x1: 8.55688,
    y1: 9.86617,
    x2: 8.82364,
    y2: 9.86617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4648_14127",
    x1: 8.25879,
    y1: 9.54254,
    x2: 8.53818,
    y2: 9.54254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4648_14127",
    x1: 6.25928,
    y1: 14.265,
    x2: 6.86151,
    y2: 14.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4648_14127",
    x1: 26.3628,
    y1: 3.78347,
    x2: 26.6907,
    y2: 3.78347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4648_14127",
    x1: 26.8906,
    y1: 3.67323,
    x2: 27.2382,
    y2: 3.67323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4648_14127",
    x1: 24.7168,
    y1: 3.5989,
    x2: 25.0694,
    y2: 3.5989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4648_14127",
    x1: 25.2532,
    y1: 3.74705,
    x2: 25.5902,
    y2: 3.74705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4648_14127",
    x1: 25.8091,
    y1: 3.8107,
    x2: 26.1243,
    y2: 3.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4648_14127",
    x1: 23.3699,
    y1: 2.67937,
    x2: 23.7144,
    y2: 2.67937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4648_14127",
    x1: 23.7625,
    y1: 3.05704,
    x2: 24.1186,
    y2: 3.05704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4648_14127",
    x1: 24.2114,
    y1: 3.36792,
    x2: 24.5701,
    y2: 3.36792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4648_14127",
    x1: 22.6448,
    y1: 1.23618,
    x2: 22.9014,
    y2: 1.23618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4648_14127",
    x1: 22.804,
    y1: 1.75634,
    x2: 23.097,
    y2: 1.75634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4648_14127",
    x1: 23.0435,
    y1: 2.24113,
    x2: 23.3663,
    y2: 2.24113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4648_14127",
    x1: 27.3965,
    y1: 3.3952,
    x2: 28.2185,
    y2: 3.3952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4648_14127",
    x1: 27.6191,
    y1: 6.24867,
    x2: 27.8349,
    y2: 6.24867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4648_14127",
    x1: 27.6924,
    y1: 6.79005,
    x2: 27.9511,
    y2: 6.79005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4648_14127",
    x1: 27.8125,
    y1: 4.61994,
    x2: 28.1,
    y2: 4.61994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4648_14127",
    x1: 27.6687,
    y1: 5.1447,
    x2: 27.9188,
    y2: 5.1447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4648_14127",
    x1: 27.6125,
    y1: 5.68708,
    x2: 27.8167,
    y2: 5.68708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4648_14127",
    x1: 28.7351,
    y1: 3.29453,
    x2: 29.0898,
    y2: 3.29453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4648_14127",
    x1: 28.3538,
    y1: 3.6823,
    x2: 28.6953,
    y2: 3.6823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4648_14127",
    x1: 28.041,
    y1: 4.12403,
    x2: 28.3613,
    y2: 4.12403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4648_14127",
    x1: 29.1802,
    y1: 2.96952,
    x2: 29.5399,
    y2: 2.96952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4648_14127",
    x1: 27.759,
    y1: 7.54434,
    x2: 28.384,
    y2: 7.54434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4648_14127",
    x1: 3.32861,
    y1: 21.9515,
    x2: 3.64084,
    y2: 21.9515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4648_14127",
    x1: 3.57202,
    y1: 21.4517,
    x2: 3.85192,
    y2: 21.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4648_14127",
    x1: 2.19775,
    y1: 23.1537,
    x2: 2.55646,
    y2: 23.1537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4648_14127",
    x1: 2.63231,
    y1: 22.815,
    x2: 2.98495,
    y2: 22.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4648_14127",
    x1: 3.01367,
    y1: 22.4136,
    x2: 3.34864,
    y2: 22.4136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4648_14127",
    x1: 0.674561,
    y1: 23.7006,
    x2: 0.99841,
    y2: 23.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4648_14127",
    x1: 1.20459,
    y1: 23.6021,
    x2: 1.54915,
    y2: 23.6021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4648_14127",
    x1: 1.71533,
    y1: 23.4226,
    x2: 2.07253,
    y2: 23.4226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4648_14127",
    x1: 3.55127,
    y1: 20.6262,
    x2: 4.25808,
    y2: 20.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4648_14127",
    x1: 8.48882,
    y1: 32.3381,
    x2: 13.441,
    y2: 32.3381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4648_14127",
    x1: 9.74927,
    y1: 32.3381,
    x2: 12.1799,
    y2: 32.3381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4648_14127",
    x1: 14.0399,
    y1: 3.93502,
    x2: 18.3863,
    y2: 3.93502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4648_14127",
    x1: 19.1577,
    y1: 6.74158,
    x2: 19.3785,
    y2: 6.74158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4648_14127",
    x1: 19.4285,
    y1: 6.74156,
    x2: 19.6493,
    y2: 6.74156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4648_14127",
    x1: 13.0582,
    y1: 9.12498,
    x2: 13.4568,
    y2: 9.12498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4648_14127",
    x1: 13.1492,
    y1: 9.03448,
    x2: 13.5483,
    y2: 9.03448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4648_14127",
    x1: 8.9977,
    y1: 12.4219,
    x2: 9.40037,
    y2: 12.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4648_14127",
    x1: 9.08522,
    y1: 12.5159,
    x2: 9.48789,
    y2: 12.5159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4648_14127",
    x1: 6.33358,
    y1: 32.8513,
    x2: 6.73221,
    y2: 32.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4648_14127",
    x1: 6.42505,
    y1: 32.7613,
    x2: 6.82367,
    y2: 32.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4648_14127",
    x1: 12.5943,
    y1: 29.9634,
    x2: 13.77,
    y2: 29.9634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4648_14127",
    x1: 21.8052,
    y1: 12.207,
    x2: 24.0681,
    y2: 12.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4648_14127",
    x1: 12.3457,
    y1: 6.15562,
    x2: 14.6086,
    y2: 6.15562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4648_14127",
    x1: 6.6194,
    y1: 4.18023,
    x2: 8.30534,
    y2: 4.18023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4648_14127",
    x1: 12.2266,
    y1: 19.1364,
    x2: 13.3532,
    y2: 19.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4648_14127",
    x1: 14.0073,
    y1: 33.0985,
    x2: 15.5164,
    y2: 33.0985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4648_14127",
    x1: 21.8777,
    y1: 14.1043,
    x2: 21.9621,
    y2: 14.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4648_14127",
    x1: 21.8777,
    y1: 13.8601,
    x2: 21.9621,
    y2: 13.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4648_14127",
    x1: 21.8777,
    y1: 13.6169,
    x2: 21.9621,
    y2: 13.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4648_14127",
    x1: 21.8777,
    y1: 14.8372,
    x2: 21.9621,
    y2: 14.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4648_14127",
    x1: 21.8777,
    y1: 14.593,
    x2: 21.9621,
    y2: 14.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4648_14127",
    x1: 21.8777,
    y1: 14.3499,
    x2: 21.9621,
    y2: 14.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4648_14127",
    x1: 21.8777,
    y1: 15.5702,
    x2: 21.9621,
    y2: 15.5702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4648_14127",
    x1: 21.8777,
    y1: 15.3261,
    x2: 21.9621,
    y2: 15.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4648_14127",
    x1: 21.8777,
    y1: 15.0829,
    x2: 21.9621,
    y2: 15.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4648_14127",
    x1: 21.8777,
    y1: 16.3027,
    x2: 21.9621,
    y2: 16.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4648_14127",
    x1: 21.8777,
    y1: 16.059,
    x2: 21.9621,
    y2: 16.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4648_14127",
    x1: 21.8777,
    y1: 15.8159,
    x2: 21.9621,
    y2: 15.8159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4648_14127",
    x1: 21.8777,
    y1: 16.792,
    x2: 21.9621,
    y2: 16.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4648_14127",
    x1: 21.8777,
    y1: 16.5483,
    x2: 21.9621,
    y2: 16.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4648_14127",
    x1: 21.5105,
    y1: 17.3915,
    x2: 22.3295,
    y2: 17.3915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4648_14127",
    x1: 14.0427,
    y1: 18.0215,
    x2: 14.1796,
    y2: 18.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4648_14127",
    x1: 13.7987,
    y1: 18.0236,
    x2: 13.9351,
    y2: 18.0236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4648_14127",
    x1: 13.5551,
    y1: 18.0255,
    x2: 13.692,
    y2: 18.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4648_14127",
    x1: 14.7751,
    y1: 18.0148,
    x2: 14.912,
    y2: 18.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_4648_14127",
    x1: 14.5312,
    y1: 18.0165,
    x2: 14.6681,
    y2: 18.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_4648_14127",
    x1: 14.288,
    y1: 18.0189,
    x2: 14.425,
    y2: 18.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_4648_14127",
    x1: 15.5076,
    y1: 18.0083,
    x2: 15.644,
    y2: 18.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_4648_14127",
    x1: 15.2636,
    y1: 18.0099,
    x2: 15.4005,
    y2: 18.0099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_4648_14127",
    x1: 15.0207,
    y1: 18.0119,
    x2: 15.1577,
    y2: 18.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_4648_14127",
    x1: 16.2395,
    y1: 18.0012,
    x2: 16.3765,
    y2: 18.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_4648_14127",
    x1: 15.9963,
    y1: 18.0038,
    x2: 16.1327,
    y2: 18.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_4648_14127",
    x1: 15.7532,
    y1: 18.0057,
    x2: 15.8896,
    y2: 18.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_4648_14127",
    x1: 16.7283,
    y1: 17.9973,
    x2: 16.8647,
    y2: 17.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_4648_14127",
    x1: 16.4853,
    y1: 17.9988,
    x2: 16.6218,
    y2: 17.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_4648_14127",
    x1: 16.9719,
    y1: 17.9941,
    x2: 17.8197,
    y2: 17.9941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_4648_14127",
    x1: 13.8853,
    y1: 17.0316,
    x2: 13.9454,
    y2: 17.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_4648_14127",
    x1: 13.8853,
    y1: 16.8576,
    x2: 13.9454,
    y2: 16.8576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_4648_14127",
    x1: 13.8853,
    y1: 16.6848,
    x2: 13.9454,
    y2: 16.6848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_4648_14127",
    x1: 13.8853,
    y1: 17.5532,
    x2: 13.9454,
    y2: 17.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_4648_14127",
    x1: 13.8853,
    y1: 17.3793,
    x2: 13.9454,
    y2: 17.3793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_4648_14127",
    x1: 13.8853,
    y1: 17.2065,
    x2: 13.9454,
    y2: 17.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_4648_14127",
    x1: 13.8853,
    y1: 18.0749,
    x2: 13.9454,
    y2: 18.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_4648_14127",
    x1: 13.8853,
    y1: 17.9009,
    x2: 13.9454,
    y2: 17.9009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_4648_14127",
    x1: 13.8853,
    y1: 17.7281,
    x2: 13.9454,
    y2: 17.7281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_4648_14127",
    x1: 13.8853,
    y1: 18.5961,
    x2: 13.9454,
    y2: 18.5961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_4648_14127",
    x1: 13.8853,
    y1: 18.4227,
    x2: 13.9454,
    y2: 18.4227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_4648_14127",
    x1: 13.8853,
    y1: 18.2498,
    x2: 13.9454,
    y2: 18.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_4648_14127",
    x1: 13.8853,
    y1: 18.9444,
    x2: 13.9454,
    y2: 18.9444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_4648_14127",
    x1: 13.8853,
    y1: 18.7709,
    x2: 13.9454,
    y2: 18.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_4648_14127",
    x1: 13.624,
    y1: 19.371,
    x2: 14.2071,
    y2: 19.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_4648_14127",
    x1: 3.44043,
    y1: 10.9018,
    x2: 3.52531,
    y2: 10.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_4648_14127",
    x1: 3.44043,
    y1: 10.6577,
    x2: 3.52531,
    y2: 10.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_4648_14127",
    x1: 3.44043,
    y1: 10.4145,
    x2: 3.52531,
    y2: 10.4145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_4648_14127",
    x1: 3.44043,
    y1: 11.6348,
    x2: 3.52531,
    y2: 11.6348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_4648_14127",
    x1: 3.44043,
    y1: 11.3906,
    x2: 3.52531,
    y2: 11.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_4648_14127",
    x1: 3.44043,
    y1: 11.1476,
    x2: 3.52531,
    y2: 11.1476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_4648_14127",
    x1: 3.44043,
    y1: 12.3678,
    x2: 3.52531,
    y2: 12.3678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_4648_14127",
    x1: 3.44043,
    y1: 12.1236,
    x2: 3.52531,
    y2: 12.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_4648_14127",
    x1: 3.44043,
    y1: 11.8805,
    x2: 3.52531,
    y2: 11.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_4648_14127",
    x1: 3.44043,
    y1: 13.1008,
    x2: 3.52531,
    y2: 13.1008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_4648_14127",
    x1: 3.44043,
    y1: 12.8566,
    x2: 3.52531,
    y2: 12.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_4648_14127",
    x1: 3.44043,
    y1: 12.6135,
    x2: 3.52531,
    y2: 12.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_4648_14127",
    x1: 3.44043,
    y1: 13.5896,
    x2: 3.52531,
    y2: 13.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_4648_14127",
    x1: 3.44043,
    y1: 13.3464,
    x2: 3.52531,
    y2: 13.3464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_4648_14127",
    x1: 3.07373,
    y1: 14.1891,
    x2: 3.8927,
    y2: 14.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_4648_14127",
    x1: 11.833,
    y1: 34.9495,
    x2: 11.928,
    y2: 34.9495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_4648_14127",
    x1: 11.6593,
    y1: 34.9476,
    x2: 11.7548,
    y2: 34.9476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_4648_14127",
    x1: 11.4922,
    y1: 34.9489,
    x2: 11.5871,
    y2: 34.9489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_4648_14127",
    x1: 12.3447,
    y1: 34.9513,
    x2: 12.4397,
    y2: 34.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_4648_14127",
    x1: 12.1745,
    y1: 34.9507,
    x2: 12.2695,
    y2: 34.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_4648_14127",
    x1: 12.0049,
    y1: 34.9502,
    x2: 12.0998,
    y2: 34.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_4648_14127",
    x1: 12.8569,
    y1: 34.9529,
    x2: 12.9524,
    y2: 34.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_4648_14127",
    x1: 12.6867,
    y1: 34.9524,
    x2: 12.7817,
    y2: 34.9524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_4648_14127",
    x1: 12.5158,
    y1: 34.9518,
    x2: 12.6113,
    y2: 34.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_4648_14127",
    x1: 13.3689,
    y1: 34.9542,
    x2: 13.4643,
    y2: 34.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_4648_14127",
    x1: 13.1992,
    y1: 34.953,
    x2: 13.2942,
    y2: 34.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_4648_14127",
    x1: 13.0285,
    y1: 34.953,
    x2: 13.124,
    y2: 34.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_4648_14127",
    x1: 13.7109,
    y1: 34.9548,
    x2: 13.8064,
    y2: 34.9548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_4648_14127",
    x1: 13.5407,
    y1: 34.9547,
    x2: 13.6362,
    y2: 34.9547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_4648_14127",
    x1: 13.8811,
    y1: 34.9552,
    x2: 14.4737,
    y2: 34.9552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_4648_14127",
    x1: 13.6331,
    y1: 31.2347,
    x2: 13.6922,
    y2: 31.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_4648_14127",
    x1: 13.6331,
    y1: 31.0644,
    x2: 13.6922,
    y2: 31.0644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_4648_14127",
    x1: 13.6331,
    y1: 30.894,
    x2: 13.6922,
    y2: 30.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_4648_14127",
    x1: 13.6331,
    y1: 31.7472,
    x2: 13.6922,
    y2: 31.7472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_4648_14127",
    x1: 13.6331,
    y1: 31.5763,
    x2: 13.6922,
    y2: 31.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_4648_14127",
    x1: 13.6331,
    y1: 31.4065,
    x2: 13.6922,
    y2: 31.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_4648_14127",
    x1: 13.6331,
    y1: 32.2598,
    x2: 13.6922,
    y2: 32.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_4648_14127",
    x1: 13.6331,
    y1: 32.089,
    x2: 13.6922,
    y2: 32.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_4648_14127",
    x1: 13.6331,
    y1: 31.9191,
    x2: 13.6922,
    y2: 31.9191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_4648_14127",
    x1: 13.6331,
    y1: 32.7724,
    x2: 13.6922,
    y2: 32.7724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_4648_14127",
    x1: 13.6331,
    y1: 32.6016,
    x2: 13.6922,
    y2: 32.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_4648_14127",
    x1: 13.6331,
    y1: 32.4317,
    x2: 13.6922,
    y2: 32.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_4648_14127",
    x1: 13.6331,
    y1: 33.1142,
    x2: 13.6922,
    y2: 33.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_4648_14127",
    x1: 13.6331,
    y1: 32.9443,
    x2: 13.6922,
    y2: 32.9443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_4648_14127",
    x1: 13.376,
    y1: 33.5337,
    x2: 13.9489,
    y2: 33.5337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_4648_14127",
    x1: 15.9561,
    y1: 30.2252,
    x2: 16.0212,
    y2: 30.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_4648_14127",
    x1: 16.0737,
    y1: 30.2253,
    x2: 16.1389,
    y2: 30.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_4648_14127",
    x1: 16.1888,
    y1: 30.2255,
    x2: 16.2544,
    y2: 30.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_4648_14127",
    x1: 15.6057,
    y1: 30.2246,
    x2: 15.6709,
    y2: 30.2246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_4648_14127",
    x1: 15.7227,
    y1: 30.2248,
    x2: 15.7878,
    y2: 30.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_4648_14127",
    x1: 15.8386,
    y1: 30.2245,
    x2: 15.9038,
    y2: 30.2245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_4648_14127",
    x1: 15.2546,
    y1: 30.223,
    x2: 15.3198,
    y2: 30.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_4648_14127",
    x1: 15.3677,
    y1: 30.2222,
    x2: 15.4329,
    y2: 30.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_4648_14127",
    x1: 15.488,
    y1: 30.2239,
    x2: 15.5532,
    y2: 30.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_4648_14127",
    x1: 14.9041,
    y1: 30.2223,
    x2: 14.9692,
    y2: 30.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_4648_14127",
    x1: 15.0205,
    y1: 30.2226,
    x2: 15.0857,
    y2: 30.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_4648_14127",
    x1: 15.137,
    y1: 30.2234,
    x2: 15.2021,
    y2: 30.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_4648_14127",
    x1: 14.553,
    y1: 30.2218,
    x2: 14.6182,
    y2: 30.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_4648_14127",
    x1: 14.6694,
    y1: 30.222,
    x2: 14.7346,
    y2: 30.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_4648_14127",
    x1: 14.7859,
    y1: 30.2226,
    x2: 14.8511,
    y2: 30.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_4648_14127",
    x1: 14.209,
    y1: 30.2201,
    x2: 14.55,
    y2: 30.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_4648_14127",
    x1: 11.7942,
    y1: 4.65236,
    x2: 11.8523,
    y2: 4.65236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_4648_14127",
    x1: 11.7942,
    y1: 4.48451,
    x2: 11.8523,
    y2: 4.48451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_4648_14127",
    x1: 11.7942,
    y1: 4.31715,
    x2: 11.8523,
    y2: 4.31715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_4648_14127",
    x1: 11.7942,
    y1: 5.15626,
    x2: 11.8523,
    y2: 5.15626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_4648_14127",
    x1: 11.7942,
    y1: 4.98842,
    x2: 11.8523,
    y2: 4.98842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_4648_14127",
    x1: 11.7942,
    y1: 4.82118,
    x2: 11.8523,
    y2: 4.82118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_4648_14127",
    x1: 11.7942,
    y1: 5.66029,
    x2: 11.8523,
    y2: 5.66029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_4648_14127",
    x1: 11.7942,
    y1: 5.49245,
    x2: 11.8523,
    y2: 5.49245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_4648_14127",
    x1: 11.7942,
    y1: 5.32509,
    x2: 11.8523,
    y2: 5.32509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_4648_14127",
    x1: 11.7942,
    y1: 6.1642,
    x2: 11.8523,
    y2: 6.1642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_4648_14127",
    x1: 11.7942,
    y1: 5.99647,
    x2: 11.8523,
    y2: 5.99647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_4648_14127",
    x1: 11.7942,
    y1: 5.82912,
    x2: 11.8523,
    y2: 5.82912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_4648_14127",
    x1: 11.7942,
    y1: 6.50038,
    x2: 11.8523,
    y2: 6.50038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_4648_14127",
    x1: 11.7942,
    y1: 6.33314,
    x2: 11.8523,
    y2: 6.33314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_4648_14127",
    x1: 11.5415,
    y1: 6.91289,
    x2: 12.1043,
    y2: 6.91289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_4648_14127",
    x1: 11.7162,
    y1: 4.81728,
    x2: 11.842,
    y2: 4.81728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_4648_14127",
    x1: 11.9411,
    y1: 4.81781,
    x2: 12.0669,
    y2: 4.81781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_4648_14127",
    x1: 12.1655,
    y1: 4.81797,
    x2: 12.2908,
    y2: 4.81797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_4648_14127",
    x1: 11.042,
    y1: 4.81474,
    x2: 11.1673,
    y2: 4.81474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_4648_14127",
    x1: 11.266,
    y1: 4.81649,
    x2: 11.3913,
    y2: 4.81649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_4648_14127",
    x1: 11.4904,
    y1: 4.81688,
    x2: 11.6162,
    y2: 4.81688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_4648_14127",
    x1: 10.3664,
    y1: 4.81374,
    x2: 10.4917,
    y2: 4.81374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_4648_14127",
    x1: 10.5913,
    y1: 4.81415,
    x2: 10.7166,
    y2: 4.81415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_4648_14127",
    x1: 10.8146,
    y1: 4.81468,
    x2: 10.9404,
    y2: 4.81468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_4648_14127",
    x1: 9.69062,
    y1: 4.81154,
    x2: 9.81642,
    y2: 4.81154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_4648_14127",
    x1: 9.91545,
    y1: 4.81245,
    x2: 10.0413,
    y2: 4.81245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_4648_14127",
    x1: 10.1398,
    y1: 4.81286,
    x2: 10.2651,
    y2: 4.81286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_4648_14127",
    x1: 9.23967,
    y1: 4.81061,
    x2: 9.36547,
    y2: 4.81061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_4648_14127",
    x1: 9.46405,
    y1: 4.81114,
    x2: 9.58935,
    y2: 4.81114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_4648_14127",
    x1: 8.36011,
    y1: 4.81,
    x2: 9.14119,
    y2: 4.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_4648_14127",
    x1: 0.625,
    y1: 28.603,
    x2: 2.80757,
    y2: 28.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_4648_14127",
    x1: 8.20433,
    y1: 34.9395,
    x2: 9.67352,
    y2: 34.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_4648_14127",
    x1: 15.0359,
    y1: 31.2376,
    x2: 15.3345,
    y2: 31.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_4648_14127",
    x1: 14.6738,
    y1: 31.5122,
    x2: 14.9679,
    y2: 31.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_4648_14127",
    x1: 16.3425,
    y1: 30.8095,
    x2: 16.6093,
    y2: 30.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_4648_14127",
    x1: 15.8823,
    y1: 30.8823,
    x2: 16.1673,
    y2: 30.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_4648_14127",
    x1: 15.4436,
    y1: 31.0228,
    x2: 15.7397,
    y2: 31.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_4648_14127",
    x1: 17.6772,
    y1: 31.0273,
    x2: 17.9733,
    y2: 31.0273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_4648_14127",
    x1: 17.2498,
    y1: 30.8833,
    x2: 17.5347,
    y2: 30.8833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_4648_14127",
    x1: 16.8093,
    y1: 30.8074,
    x2: 17.0766,
    y2: 30.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_4648_14127",
    x1: 18.771,
    y1: 31.8438,
    x2: 19.0539,
    y2: 31.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_4648_14127",
    x1: 18.4478,
    y1: 31.5161,
    x2: 18.7418,
    y2: 31.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_4648_14127",
    x1: 18.084,
    y1: 31.2397,
    x2: 18.3821,
    y2: 31.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_4648_14127",
    x1: 19.3926,
    y1: 33.0736,
    x2: 19.5962,
    y2: 33.0736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_4648_14127",
    x1: 19.248,
    y1: 32.6354,
    x2: 19.4835,
    y2: 32.6354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_4648_14127",
    x1: 19.0415,
    y1: 32.2234,
    x2: 19.3027,
    y2: 32.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_4648_14127",
    x1: 19.3293,
    y1: 34.4421,
    x2: 19.5486,
    y2: 34.4421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_4648_14127",
    x1: 19.4351,
    y1: 33.9936,
    x2: 19.62,
    y2: 33.9936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_4648_14127",
    x1: 19.4639,
    y1: 33.5321,
    x2: 19.6286,
    y2: 33.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_4648_14127",
    x1: 18.7478,
    y1: 35.494,
    x2: 18.8312,
    y2: 35.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_4648_14127",
    x1: 18.9089,
    y1: 35.265,
    x2: 19.1818,
    y2: 35.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_4648_14127",
    x1: 19.1484,
    y1: 34.8711,
    x2: 19.399,
    y2: 34.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_4648_14127",
    x1: 14.2109,
    y1: 31.824,
    x2: 14.8869,
    y2: 31.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4648_14127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.75,
    height: 34.6087,
    fill: "white",
    transform: "translate(0.625 0.905029)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmmLogo);
export default __webpack_public_path__ + "static/media/mmm-logo.75f1b8504be14d5a6a35f1e7b79693a4.svg";
export { ForwardRef as ReactComponent };